import { jsx as p, jsxs as I, Fragment as Ht } from "react/jsx-runtime";
import * as T from "react";
import bn, { useState as V, useEffect as F, useCallback as ke, useRef as H, Children as ri, isValidElement as ft, useLayoutEffect as yn, forwardRef as Is } from "react";
import * as En from "react-dom";
import xn from "video.js";
const Sn = 16, Ue = (e) => e / Sn;
var te = /* @__PURE__ */ ((e) => (e[e.SMALL = 320] = "SMALL", e[e.MEDIUM = 768] = "MEDIUM", e[e.LARGE = 1024] = "LARGE", e[e.X_LARGE = 1440] = "X_LARGE", e[e.XX_LARGE = 1672] = "XX_LARGE", e))(te || {}), Zt = /* @__PURE__ */ ((e) => (e.SELF = "_self", e.BLANK = "_blank", e))(Zt || {});
function Os(e) {
  var t, i, s = "";
  if (typeof e == "string" || typeof e == "number") s += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var n = e.length;
    for (t = 0; t < n; t++) e[t] && (i = Os(e[t])) && (s && (s += " "), s += i);
  } else for (i in e) e[i] && (s && (s += " "), s += i);
  return s;
}
function L() {
  for (var e, t, i = 0, s = "", n = arguments.length; i < n; i++) (e = arguments[i]) && (t = Os(e)) && (s && (s += " "), s += t);
  return s;
}
const Rs = (e = !1) => {
  const [t, i] = V(() => typeof window > "u" || e ? "" : window.location.hash || ""), s = (n) => {
    if (typeof window > "u") {
      console.warn("setHashHandler called in a non-browser environment. Hash will not be set.");
      return;
    }
    if (n === "" || n === "#") {
      const o = window.location.pathname + window.location.search;
      history.replaceState(null, "", o), i("");
      return;
    }
    const a = n.startsWith("#") ? n : `#${n}`;
    history.replaceState(null, "", a), i(a);
  };
  return F(() => {
    e && i(window.location.hash);
  }, []), [t, s];
}, Ps = (e) => ({ scrollToItem: ke(
  (i) => {
    var s;
    i !== null && ((s = e == null ? void 0 : e.current) != null && s[i]) && e.current[i].scrollIntoView({ behavior: "smooth", inline: "center", block: "start" });
  },
  [e]
) }), Tn = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { fillRule: "evenodd", d: "M12 2.586 21.414 12 12 21.414 2.586 12 12 2.586ZM5.414 12 12 18.586 18.586 12 12 5.414 5.414 12Z", clipRule: "evenodd" })), An = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M10.8 2.8v14.6L5.5 12l-1.4 1.4 7.7 7.7 7.7-7.7-1.4-1.4-5.3 5.3V2.8h-2z" })), Mn = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M21 11H6.4l5.3-5.3-1.4-1.4L2.6 12l7.7 7.7 1.4-1.4L6.4 13H21v-2z" })), kn = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M22 8L12 18 2 8" })), Cn = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M16 22L6 12 16 2" })), Nn = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M16.6 12L7.3 2.7l1.4-1.4 10 10 .7.7-.7.7-10 10-1.4-1.4 9.3-9.3z", clipRule: "evenodd" })), In = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M2 16L12 6l10 10" })), On = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M2.6 13h14.6l-5.3 5.3 1.4 1.4L21 12l-7.7-7.7-1.4 1.4 5.3 5.3H2.6v2z" })), Rn = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M12.8 21.2V6.6L18 12l1.4-1.4-7.7-7.7L4 10.5l1.4 1.4 5.3-5.3v14.6h2z" })), Pn = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { fillRule: "evenodd", d: "M2 2a1 1 0 00-1 1v15c0 .6.4 1 1 1h7a2 2 0 012 2 1 1 0 102 0 2 2 0 012-2h7c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1h-6a5 5 0 00-4 2 5 5 0 00-4-2H2zm11 15.5a4 4 0 012-.5h6V4h-5a3 3 0 00-3 3v10.5zm-2 0V7a3 3 0 00-3-3H3v13h6a4 4 0 012 .5z", clipRule: "evenodd" })), Ln = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M20 3h-1V1h-2v2H7V1H5v2H4a2 2 0 00-2 2v16c0 1.1.9 2 2 2h16a2 2 0 002-2V5a2 2 0 00-2-2zm0 18H4V10h16v11zm0-13H4V5h16v3z" })), Dn = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M20.5 6.4l-11 11L8.1 16l-4.6-4.6L4.9 10l4.6 4.6L19.1 5l1.4 1.4z", clipRule: "evenodd" })), zn = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M12 15.7l6-6-1.4-1.4-4.6 4.6-4.6-4.6L6 9.7l6 6z" })), Vn = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M8.3 12l6 6 1.4-1.4-4.6-4.6 4.6-4.6L14.3 6l-6 6z" })), Bn = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M15.7 12l-6-6-1.4 1.4 4.6 4.6-4.6 4.6L9.7 18l6-6z" })), $n = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M12 8.3l-6 6 1.4 1.4 4.6-4.6 4.6 4.6 1.4-1.4-6-6z" })), Hn = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M12 2a10 10 0 100 20 10 10 0 000-20z" })), Fn = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M17.6 5L12 10.6 6.4 5 5 6.4l5.6 5.6L5 17.6 6.4 19l5.6-5.6 5.6 5.6 1.4-1.4-5.6-5.6L19 6.4 17.6 5z" })), Gn = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M0 0h20v20H0z" })), qn = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M4 4v10h10" })), jn = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "m18.58 2.6 2.83 2.84a2 2 0 0 1 0 2.83l-7.44 7.44a2 2 0 0 1-2.83 0l-1.42-1.42 1.4-1.42 1.43 1.42 7.44-7.44-2.82-2.83-2.9 2.9-1.42-1.42 2.9-2.9a2 2 0 0 1 2.83 0ZM5.39 21.46l-2.83-2.82a2 2 0 0 1 0-2.83l7.48-7.48a2 2 0 0 1 2.83 0l1.42 1.42-1.41 1.41-1.42-1.42-7.48 7.48 2.82 2.83 2.9-2.9 1.42 1.41-2.9 2.9a2 2 0 0 1-2.83 0Z", clipRule: "evenodd" })), Wn = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M20 5.4L18.6 4 12 10.6 5.4 4 4 5.4l6.6 6.6L4 18.6 5.4 20l6.6-6.6 6.6 6.6 1.4-1.4-6.6-6.6L20 5.4z", clipRule: "evenodd" })), Un = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 80 80", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "m39.54 21.61.46-.01a9.1 9.1 0 0 1 9.12 8.57l.01.46v.34a9.09 9.09 0 0 1-8.67 9.02L40 40a9.1 9.1 0 0 1-9.14-9.03v-.34a9.09 9.09 0 0 1 8.68-9.02Zm.98-4.61H40a13.72 13.72 0 0 0-13.8 13.63v.34A13.7 13.7 0 0 0 39.48 44.6H40a13.72 13.72 0 0 0 13.8-13.13v-.85A13.7 13.7 0 0 0 40.52 17Zm17.33 45.5H63l-4.36-8.21a9.27 9.27 0 0 0-8.23-4.79H29.6a9.27 9.27 0 0 0-8.23 4.79L17 62.5h5.15l3.33-6.27a4.63 4.63 0 0 1 4.11-2.4h20.82a4.6 4.6 0 0 1 4.1 2.4l3.34 6.27Z", clipRule: "evenodd" })), Yn = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M19.4 7.5h3.1V6h-3.1A2.3 2.3 0 0015 6H9.8V3.7h-6V6H1.5v1.5h2.3v2.3h6V7.5H15a2.3 2.3 0 001.4 1.4v5.5a3 3 0 00-2.1 2.1H1.5V18h12.9a3 3 0 005.7 0h2.4v-1.5h-2.4a3 3 0 00-2.1-2.1V8.9a2.3 2.3 0 001.4-1.4zm-11.1.8h-3v-3h3v3zm10.4 9a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" })), Xn = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M19 9h-4V3H9v6H5l7 7 7-7zm-8 2V5h2v6h1.2L12 13.2 9.8 11H11zm-6 7h14v2H5v-2z" })), Zn = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M7.2 9.5h9.6L12 14.3 7.2 9.5zm-.4-.4s0 0 0 0h0z" })), Kn = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { fillRule: "evenodd", d: "M12 22a10 10 0 100-20 10 10 0 000 20zm0-2a8 8 0 100-16 8 8 0 000 16z", clipRule: "evenodd" })), Qn = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M22 6a2 2 0 00-2-2H4a2 2 0 00-2 2v12c0 1.1.9 2 2 2h16a2 2 0 002-2V6zm-2 0l-8 5-8-5h16zm0 12H4V8l8 5 8-5v10z" })), Jn = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M10 6v2H5v11h11v-5h2v6a1 1 0 01-1 1H4a1 1 0 01-1-1V7a1 1 0 011-1h6zm11-3v8h-2V6.4l-7.8 7.8-1.4-1.4L17.6 5H13V3h8z" })), er = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M10.02 20L10 13H7v-3h3V8c0-2.7 1.67-4 4.08-4 1.15 0 2.14.09 2.43.12v2.83h-1.67c-1.3 0-1.56.62-1.56 1.53V10H17l-1 3h-2.72v7h-3.26z" })), tr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M22.6 11l-3-2.7V4.2L16.2.7H6.9v6H3.5A1.1 1.1 0 002.4 8V22a1.1 1.1 0 001.1 1.1H23V11.8a1.1 1.1 0 00-.4-.8zM7 21.8h-3V8.2h3v13.6zM15 2.1h.5L18 4.8v.5h-3v-3zm-6.7 0h5.2v4.5h4.5v3.4H8.4V2.3zm13.1 19.6H8.4V11.6h11.2v-1.3l2 1.7v9.8z" }), /* @__PURE__ */ T.createElement("path", { d: "M10.9 16.1h1.5v1.5h-1.5v-1.5zM13.9 16.1h1.5v1.5h-1.5v-1.5zM10.9 19.1h1.5v1.5h-1.5v-1.5zM13.9 19.1h1.5v1.5h-1.5v-1.5zM16.9 16.1h1.5v1.5h-1.5v-1.5zM16.9 19.1h1.5v1.5h-1.5v-1.5zM10.9 13.1h7.5v1.5h-7.5v-1.5z" })), ir = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M4 1H3v22h18V6.6l-.3-.3-5-5-.3-.3H4zm1 20V3h9v5h5v13H5zM17.6 6L16 4.4V6h1.6zM11 8v6.7l-2.3-2.1L7.3 14l4 3.7.7.7.7-.7 4-3.7-1.4-1.4-2.3 2.1V8h-2z", clipRule: "evenodd" })), sr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { fillRule: "evenodd", d: "M4 1H3v22h18V6.6l-.3-.3-5-5-.3-.3H4Zm1 20V3h9v5h5v13H5ZM17.6 6 16 4.4V6h1.6Z", clipRule: "evenodd" })), nr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { fillRule: "evenodd", d: "M14.126 9H3V7h11.126A4.002 4.002 0 0 1 22 8a4 4 0 0 1-7.874 1ZM16 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm-6.126 7H21v2H9.874A4.002 4.002 0 0 1 2 16a4 4 0 0 1 7.874-1ZM8 16a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z", clipRule: "evenodd" })), rr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M12 2a10 10 0 100 20 10 10 0 000-20zm8 9h-2.8c-.2-2.2-.8-4.3-1.8-6.2a8 8 0 014.5 6.2zm-7.5-7a13 13 0 012.7 7H9c.2-2.6 1-5 2.5-7h1zm-3.8.7c-1 2-1.6 4-1.7 6.3H4a8 8 0 014.7-6.3zM4 13h3c0 2.4.6 4.5 1.5 6.2A8 8 0 014.1 13zm7.3 7A12 12 0 019 13h6.2c-.3 2.8-1.2 5.2-2.6 7h-1.2zm4-.8c1-1.8 1.6-3.9 1.8-6.2h2.7a8 8 0 01-4.4 6.2z" })), ar = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M12.22 3a9.23 9.23 0 0 0-8.23 4.97 8.71 8.71 0 0 0 0 8.05A9.23 9.23 0 0 0 12.22 21c2.53 0 4.6-.82 6.08-2.17a8.68 8.68 0 0 0 2.7-6.6c0-.3-.01-.6-.04-.9h-7.74v1.76h5.73l-.24 1.2a5.64 5.64 0 0 1-2.48 3.62 7.26 7.26 0 0 1-4.01 1.13A7.09 7.09 0 0 1 5.16 12a7.09 7.09 0 0 1 7.05-7.04c1.42 0 2.74.39 3.86 1.16l1.48-1.45A8.93 8.93 0 0 0 12.22 3ZM2.2 7.06A11.23 11.23 0 0 1 12.2 1a10.9 10.9 0 0 1 7.51 2.87l.78.71-.75.74-2.92 2.85-.68.67-.7-.65a4.61 4.61 0 0 0-3.23-1.23A5.09 5.09 0 0 0 7.16 12c0 .56.1 1.08.27 1.57v.02a5.09 5.09 0 0 0 4.79 3.45c1.2 0 2.17-.31 2.91-.8.48-.31.86-.7 1.14-1.15h-5.05V9.33h11.46l.14.84c.11.65.18 1.34.18 2.05 0 3.3-1.2 6.14-3.36 8.1A10.85 10.85 0 0 1 12.22 23c-4.38 0-8.17-2.47-10.01-6.06a10.71 10.71 0 0 1 0-9.88Z", clipRule: "evenodd" })), or = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M11 7h2v2h-2V7zm0 4h2v6h-2v-6zm1-9a10 10 0 100 20 10 10 0 000-20zm0 18a8 8 0 110-16 8 8 0 010 16z" })), lr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M12 5.44c2.14 0 2.39.01 3.23.05.51 0 1.01.1 1.49.27.35.13.66.34.92.6.26.26.47.58.6.92.17.48.27.98.27 1.49.04.84.05 1.1.05 3.23s0 2.4-.05 3.23c0 .51-.1 1.01-.27 1.49a2.64 2.64 0 01-1.52 1.52c-.48.17-.98.27-1.48.27-.85.04-1.1.05-3.24.05-2.13 0-2.39 0-3.23-.05-.5 0-1.01-.1-1.49-.27a2.47 2.47 0 01-.92-.6 2.47 2.47 0 01-.6-.92 4.42 4.42 0 01-.27-1.49c-.04-.84-.05-1.1-.05-3.23s.01-2.39.05-3.23c0-.51.1-1.01.27-1.49.13-.35.34-.66.6-.92.26-.26.58-.47.92-.6.48-.17.98-.27 1.49-.27.84-.04 1.1-.05 3.23-.05zM12 4c-2.17 0-2.45 0-3.3.05-.66.01-1.32.14-1.94.37a3.9 3.9 0 00-1.42.92c-.4.4-.72.89-.92 1.42a5.87 5.87 0 00-.37 1.94C4 9.56 4 9.83 4 12s0 2.45.05 3.3c.01.66.14 1.32.37 1.94.2.53.52 1.02.92 1.42.4.4.89.72 1.42.92.62.23 1.28.36 1.94.37.86.04 1.13.05 3.3.05s2.45 0 3.3-.05a5.87 5.87 0 001.94-.37 4.1 4.1 0 002.34-2.34c.24-.62.36-1.28.37-1.94.04-.86.05-1.13.05-3.3 0-2.18 0-2.45-.05-3.3a5.87 5.87 0 00-.37-1.94 3.9 3.9 0 00-.92-1.42 3.9 3.9 0 00-1.42-.92 5.87 5.87 0 00-1.94-.37C14.44 4 14.17 4 12 4zm0 3.9a4.1 4.1 0 100 8.2 4.1 4.1 0 000-8.2zm0 6.77a2.67 2.67 0 110-5.34 2.67 2.67 0 010 5.34zm5.23-6.94a.96.96 0 11-1.92 0 .96.96 0 011.92 0z", clipRule: "evenodd" })), cr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M19.3 4H4.7c-.4 0-.7.3-.7.7v14.7c0 .3.3.6.7.6h14.7c.4 0 .7-.3.7-.7V4.7c-.1-.4-.4-.7-.8-.7zM8.7 17.6H6.4V10h2.4v7.6h-.1zM7.6 9c-.8 0-1.4-.7-1.4-1.4 0-.8.6-1.4 1.4-1.4.8 0 1.4.6 1.4 1.4-.1.7-.7 1.4-1.4 1.4zm10 8.6h-2.4v-3.7c0-.9 0-2-1.2-2s-1.4 1-1.4 2v3.8h-2.4V10h2.3v1c.3-.6 1.1-1.2 2.2-1.2 2.4 0 2.8 1.6 2.8 3.6v4.2h.1z" })), dr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7zm-4 6h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z" })), ur = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M5.298 16.359 7.657 14H2v5.657l1.86-1.86A9.99 9.99 0 0 0 12 22c4.83 0 8.87-3.44 9.8-8h-2.05c-.9 3.45-4.03 6-7.75 6a7.998 7.998 0 0 1-6.702-3.641ZM16.343 10H22V4.343l-1.86 1.86A9.99 9.99 0 0 0 12 2c-4.83 0-8.87 3.44-9.8 8h2.05c.9-3.45 4.03-6 7.75-6a8 8 0 0 1 6.703 3.641L16.343 10Z", clipRule: "evenodd" })), fr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M5 9a7 7 0 1114 0c0 5.3-7 13-7 13S5 14.2 5 9zm7-5a5 5 0 00-5 5c0 2.8 3 7.2 5 9.9 2.1-2.7 5-7 5-9.9a5 5 0 00-5-5zm2.5 5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" })), pr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 72 40", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { fillRule: "evenodd", d: "M16.2 39h39.7L72 19.5 55.9 0H16.2L0 19.5 16.2 39zM55 37H17L2.6 19.4 17.1 2H55l14.5 17.6L55 36.9zM17 19.1v6.9h-2.2V10.8h4.3c1.2 0 2 .3 2.8 1 .6.8 1 1.7 1 3a4 4 0 01-.6 2.2c-.3.6-.8 1-1.4 1.3.3.1.6.4.9.7l.4 1.5.6 5.5h-2.2l-.5-5.3c-.1-.5-.2-.9-.5-1.1-.2-.2-.5-.4-1-.4H17zm0-6.4v4.4H19c.5 0 1-.1 1.2-.5.4-.4.5-1 .5-1.7 0-.8-.2-1.3-.5-1.7-.2-.3-.7-.5-1.2-.5H17zm13 13c-.5.3-1.2.5-2 .5s-1.4-.2-2-.6c-.6-.3-1.1-.9-1.4-1.6-.4-.6-.5-1.5-.5-2.4v-2c0-1 .1-1.8.5-2.5A3.7 3.7 0 0128 15c.8 0 1.4.2 2 .6.6.4 1.1.9 1.4 1.6.4.7.5 1.5.5 2.4v2.1c0 1-.1 1.8-.5 2.4-.3.7-.8 1.3-1.4 1.6zm-3.4-2.1c.4.4.8.6 1.4.6.6 0 1-.2 1.4-.6.3-.5.5-1.1.5-2v-2.2a3 3 0 00-.5-1.9c-.4-.4-.8-.6-1.4-.6-.6 0-1 .2-1.4.6a3 3 0 00-.5 1.9v2.3c0 .8.2 1.4.5 1.9zm13.5 1.7c-.6.6-1.5 1-2.5 1-1.2 0-2.2-.5-2.9-1.3a5 5 0 01-1-3.4v-2a5 5 0 011-3.4c.8-.9 1.7-1.3 3-1.3 1 0 1.9.3 2.5 1 .6.5 1 1.4 1.2 2.5l-2 .5c-.2-1.4-.8-2-1.8-2-.6 0-1 .2-1.4.6-.3.5-.5 1.1-.5 1.9v2.3c0 .8.2 1.4.5 1.9.4.4.8.6 1.4.6.5 0 .9-.1 1.2-.5.3-.3.5-.8.6-1.5l2 .5c-.2 1.1-.6 2-1.3 2.6zm4.9-6.5V26h-2V10.8h2V16c.2-.3.5-.5 1-.8a3 3 0 011.4-.3c1 0 1.7.3 2.2 1 .5.5.8 1.4.8 2.5V26h-2v-7.2c0-.6-.2-1.1-.5-1.5-.3-.3-.7-.5-1.2-.5s-1 .2-1.2.5A2 2 0 0045 19zm13.6-2.7c.6.8 1 2 1 3.3V21H54v.9c0 .8.2 1.4.5 1.9.4.4.8.6 1.3.6s.9-.1 1.2-.5c.3-.3.5-.7.6-1.3l1.8.4c-.1 1-.5 1.8-1.1 2.4-.7.6-1.5.9-2.5.9-1.2 0-2-.4-2.8-1.3-.7-.8-1-2-1-3.4v-2c0-1 .1-1.7.5-2.5.3-.6.8-1.2 1.3-1.6.6-.3 1.3-.5 2-.5 1.2 0 2 .4 2.8 1.2zm-1.4 1.3c-.4-.5-.8-.7-1.4-.7-.5 0-1 .2-1.2.7-.4.4-.5 1-.5 1.8v.3h3.5v-.4a3 3 0 00-.4-1.7z", clipRule: "evenodd" })), hr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M9.1 22L2 19.8v-16l6.9 2.2 7-4L22 4.3v16.2L16 18l-6.9 4zM4 6.5v11.9l4 1.3V7.7L4 6.4zm10-1.1l-4 2.3v11.7l4-2.3V5.3zM16 4V16l4 1.6V5.7L16 4z" })), mr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M19 2v2h-2v3a3 3 0 013 3v11a1 1 0 01-1 1H5a1 1 0 01-1-1V10a3 3 0 013-3V4H5V2h14zm-2 7H7a1 1 0 00-1 1v10h12V10a1 1 0 00-1-1zm-4 2v2h2v2h-2v2h-2v-2H9v-2h2v-2h2zm2-7H9v3h6V4z" })), gr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M4 11h16v2H4v-2z" })), vr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M15.132 16.192L6.47 24.854l1.06 1.061 8.662-8.662 8.663 8.662 1.06-1.06-8.662-8.663 8.662-8.662-1.06-1.06-8.663 8.662L7.53 6.47 6.47 7.53l8.662 8.662z" })), _r = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M29 8.75H3v-1.5h26v1.5zm0 7.5H3v-1.5h26v1.5zm0 7.5H3v-1.5h26v1.5z" })), wr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { fillRule: "evenodd", d: "M22.167 13.333a7.833 7.833 0 11-15.667 0 7.833 7.833 0 0115.667 0zm-2.568 7.708a9.333 9.333 0 111.168-.945l6.121 6.733-1.11 1.009L19.6 21.04z" })), br = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M15.5 1h-8A2.5 2.5 0 005 3.5v17C5 21.9 6.1 23 7.5 23h8c1.4 0 2.5-1.1 2.5-2.5v-17C18 2.1 16.9 1 15.5 1zm-4 21a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm4.5-4H7V4h9v14z" })), yr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M4 11a7 7 0 0 0 7-7h2a7 7 0 0 0 7 7v2a7 7 0 0 0-7 7h-2a7 7 0 0 0-7-7v-2Zm4.127 1A9.04 9.04 0 0 1 12 15.873 9.04 9.04 0 0 1 15.873 12 9.04 9.04 0 0 1 12 8.127 9.04 9.04 0 0 1 8.127 12Z", clipRule: "evenodd" })), Er = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { fillRule: "evenodd", d: "M4 17.8V6.2l8-1.7v15l-8-1.7ZM2 4.6l10-2.2 2-.4v4h8.5v12H14v4l-2-.4-10-2.2V4.6Zm12 5.8V16h6.5v-6l-3.4 2.3-.7.5-.6-.6-1.8-1.8ZM19.8 8h-5.4l2.2 2.2L19.8 8ZM7 12c0-.7.2-1.2.4-1.6L8 10c.1 0 .3 0 .6.4a3.4 3.4 0 0 1 0 3.2L8 14c-.1 0-.3 0-.6-.4-.2-.4-.4-1-.4-1.6Zm1-4c-1 0-1.8.6-2.2 1.3a5 5 0 0 0 0 5.4C6.2 15.4 7 16 8 16c1 0 1.8-.6 2.2-1.3a5 5 0 0 0 0-5.4A2.7 2.7 0 0 0 8 8Z", clipRule: "evenodd" })), xr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M12.2 3a.7.7 0 00-.5.2h-.1a6.3 6.3 0 00-7.8 4.2c-.3 1-.4 2-.2 3l-1 1a2.1 2.1 0 00.9 3.4c.3.1.6.2 1 .1a2.1 2.1 0 001.8 1.6 2.1 2.1 0 002 2c0 .4.3 1 .6 1.3.8.8 2 .8 2.8.2l.4.4a2.2 2.2 0 003.7-1.3 2.1 2.1 0 001.9-2 2.1 2.1 0 001.9-1.6 2.1 2.1 0 002.4-2 2.1 2.1 0 00-.7-1.6l-.8-.8.2-.7a6 6 0 00-2.8-6.6 6 6 0 00-3-.8h-1.7-1zm3 5l3.4 3.4 1.7 1.6a.6.6 0 01-.5 1l-.4-.1-1.6-1.7a.8.8 0 00-1.1 0 .7.7 0 000 1.1l1.2 1.3a.6.6 0 01-.4 1h-.4a.8.8 0 00-1.2.5c0 .2 0 .3.2.5a.6.6 0 01-.5 1c-.1 0-.3 0-.4-.2a.8.8 0 00-1.2.6l.1.5a.6.6 0 01-.5 1c-.1 0-.3 0-.4-.2l-.4-.3.1-.2a2.1 2.1 0 00-1.4-3.6 2.1 2.1 0 00-2-2 2.1 2.1 0 00-1.4-1.8h-1a2.1 2.1 0 00-2-1.7 4.7 4.7 0 013-4.9c.6-.2 1.2-.3 1.9-.3L8.5 5.6a2.3 2.3 0 001 4.2c.7 0 1.3 0 1.8-.5L13.2 8h2zM9.4 6.7l3.1-2.3h2.3a4.5 4.5 0 014.5 5.3L16 6.6a.7.7 0 00-.6-.2H13c-.1 0-.3 0-.4.2L10.4 8a.8.8 0 01-1.3-.4.8.8 0 01.3-.9zm-3.4 8a.6.6 0 010-.9l1-1a.6.6 0 01.9 0 .6.6 0 010 1l-1 .9a.6.6 0 01-.9 0zm-.5-3.4a.6.6 0 010 .9l-1 1a.6.6 0 01-1-.3.6.6 0 01.2-.6l1-1a.6.6 0 01.8 0zm5.4 7.3a.6.6 0 01-1-.2.6.6 0 01.1-.6l1-1a.6.6 0 011 .2.6.6 0 01-.2.7l-1 1zm-2-2a.6.6 0 01-1.1-.4c0-.2 0-.3.2-.4l1-1a.6.6 0 011 .2.6.6 0 01-.2.7l-1 1z" })), Sr = (e) => /* @__PURE__ */ T.createElement("svg", { viewBox: "0 0 56 56", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M51 28C51 15.2975 40.7025 5 28 5C15.2975 5 5 15.2975 5 28C5 40.7025 15.2975 51 28 51V56C12.536 56 0 43.464 0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56V51C40.7025 51 51 40.7025 51 28Z" }), /* @__PURE__ */ T.createElement("path", { d: "M25.3333 19.75C25.3333 18.2312 24.1394 17 22.6667 17C21.1939 17 20 18.2312 20 19.75V36.25C20 37.7688 21.1939 39 22.6667 39C24.1394 39 25.3333 37.7688 25.3333 36.25V19.75Z" }), /* @__PURE__ */ T.createElement("path", { d: "M33.3333 17C34.8061 17 36 18.2312 36 19.75V36.25C36 37.7688 34.8061 39 33.3333 39C31.8606 39 30.6667 37.7688 30.6667 36.25V19.75C30.6667 18.2312 31.8606 17 33.3333 17Z" })), Tr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M18.8 12h-6a1.5 1.5 0 00-1.6 1.5V18H3v-7.5H1.5v12H3v-3h18v3h1.5v-6.8a3.8 3.8 0 00-3.8-3.7zm2.2 6h-8.3v-4.5h6a2.3 2.3 0 012.3 2.3V18z" }), /* @__PURE__ */ T.createElement("path", { d: "M7.1 12.8a1.1 1.1 0 110 2.2 1.1 1.1 0 010-2.3zm0-1.6a2.6 2.6 0 100 5.3 2.6 2.6 0 000-5.3zM15.8 4.5h-3v-3h-1.6v3h-3V6h3v3h1.6V6h3V4.5z" })), Ar = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M6.5 5a1 1 0 112 0 1 1 0 01-2 0zm1-3a3 3 0 100 6 3 3 0 000-6zm8 3a1 1 0 112 0 1 1 0 01-2 0zm1-3a3 3 0 100 6 3 3 0 000-6zM4.3 9.3c.2-.2.4-.3.7-.3h5a1 1 0 011 1l-1 11c0 .6-.5 1-1 1H6a1 1 0 01-1-1L4 10c0-.2 0-.5.3-.7zM6 11l.8 9h1.2l.8-9H6.1zM14 9a1 1 0 00-1 1l1 11c0 .6.5 1 1 1h3c.5 0 1-.4 1-1l1-11a1 1 0 00-1-1h-5zm2 11l-.9-9h2.8l-.8 9h-1.2z", clipRule: "evenodd" })), Mr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M6.5 5L7 7.6 5.8 8.8C5.4 7.6 5 6.3 5 5h1.5zm9.9 12c.9.3 1.7.4 2.6.5V19c-1.3-.1-2.6-.4-3.8-.8l1.2-1.2zM7.5 3H4a1 1 0 00-1 1 17 17 0 0017 17c.6 0 1-.4 1-1v-3.5c0-.5-.4-1-1-1a11.4 11.4 0 01-3.9-.6 1 1 0 00-.7.3l-2.2 2.2a15.1 15.1 0 01-6.6-6.6l2.2-2.2c.3-.3.4-.7.3-1-.4-1.1-.6-2.3-.6-3.6 0-.5-.4-1-1-1z" })), kr = (e) => /* @__PURE__ */ T.createElement("svg", { viewBox: "0 0 56 56", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M51 28C51 15.2975 40.7025 5 28 5C15.2975 5 5 15.2975 5 28C5 40.7025 15.2975 51 28 51V56C12.536 56 0 43.464 0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56V51C40.7025 51 51 40.7025 51 28Z" }), /* @__PURE__ */ T.createElement("path", { d: "M37.8269 28.6792C37.7136 28.8855 37.5505 29.0569 37.3542 29.176L23.9374 37.3179C23.7411 37.4371 23.5183 37.4999 23.2915 37.5C23.0647 37.5 22.8419 37.4373 22.6456 37.3181C22.4491 37.1988 22.2861 37.0274 22.1727 36.8209C22.0595 36.6144 21.9998 36.3803 22 36.1419V19.8592C22 18.8146 23.0753 18.161 23.9374 18.6843L37.3542 26.8251C37.5505 26.9443 37.7136 27.1156 37.8269 27.3219C37.9402 27.5283 38 27.7623 38 28.0006C38 28.2388 37.9402 28.4729 37.8269 28.6792Z" })), Cr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M11.3 3.6h1.4l.2.1v16.6l-.2.1h-1.4l-.2-.1V3.6l.2-.1z" }), /* @__PURE__ */ T.createElement("path", { d: "M4.1 11.1H20c.1 0 .2 0 .2.2v1.4l-.2.2H4c-.1 0-.2 0-.2-.2v-1.4l.2-.2z" })), Nr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M14 12c0 .74-.4 1.38-1 1.72V22h-2v-8.28c-.6-.35-1-.98-1-1.72 0-1.1.9-2 2-2s2 .9 2 2Zm-2-6c-3.31 0-6 2.69-6 6 0 1.74.75 3.31 1.94 4.4l1.42-1.42A3.956 3.956 0 0 1 8 12c0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.19-.53 2.25-1.36 2.98l1.42 1.42A5.957 5.957 0 0 0 18 12c0-3.31-2.69-6-6-6Zm0-4C6.48 2 2 6.48 2 12c0 2.85 1.2 5.41 3.11 7.24l1.42-1.42A7.986 7.986 0 0 1 4 12c0-4.41 3.59-8 8-8s8 3.59 8 8c0 2.29-.98 4.36-2.53 5.82l1.42 1.42C20.8 17.41 22 14.85 22 12c0-5.52-4.48-10-10-10Z" })), Ir = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M12 1.5a10.5 10.5 0 100 21 10.5 10.5 0 000-21zm4.4 13.7l-1.2 1.2L12 13l-3.2 3.3-1.2-1.2L11 12 7.6 8.8l1.2-1.2L12 11l3.2-3.3 1.2 1.2L13 12l3.3 3.2z" })), Or = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { fillRule: "evenodd", d: "M22.167 13.333a7.833 7.833 0 1 1-15.667 0 7.833 7.833 0 0 1 15.667 0Zm-2.568 7.708a9.333 9.333 0 1 1 1.168-.945l6.121 6.733-1.11 1.009L19.6 21.04Z", clipRule: "evenodd" })), Rr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M10 18a8 8 0 004.9-1.7l4.4 4.4 1.4-1.4-4.4-4.4A8 8 0 1010 18zm0-14a6 6 0 110 12 6 6 0 010-12z" })), Pr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "m11.99 18.54-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74ZM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16Zm0-11.47L17.74 9 12 13.47 6.26 9 12 4.53Z" })), Lr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M26 21h-4.5v2h8v-8h-2v4.6l-10.3-9.3-.7-.7-.7.7-5.3 5.3-7.8-7.3-1.4 1.4 8.5 8 .7.7.7-.7 5.3-5.3L26 21Z", clipRule: "evenodd" })), Dr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "m25.6 16.9-3.3 3.3 1.4 1.4 5-5 .7-.7-.7-.7-5-5-1.4 1.5 3.2 3.2H3v2h22.6Z", clipRule: "evenodd" })), zr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M26 10h-4.5V8h8v8h-2v-4.6l-10.3 9.3-.7.7-.7-.7-5.3-5.3-7.8 7.3-1.4-1.4 8.5-8 .7-.7.7.7 5.3 5.3L26 10Z", clipRule: "evenodd" })), Vr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M12 2a10 10 0 100 20 10 10 0 000-20zm0 18a8 8 0 110-16 8 8 0 010 16z" }), /* @__PURE__ */ T.createElement("path", { d: "M13 7h-2v6h6v-2h-4V7z" })), Br = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M17.1761 4H19.9362L13.9061 10.7774L21 20H15.4456L11.0951 14.4066L6.11723 20H3.35544L9.80517 12.7508L3 4H8.69545L12.6279 9.11262L17.1761 4ZM16.2073 18.3754H17.7368L7.86441 5.53928H6.2232L16.2073 18.3754Z" })), $r = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M8 7l4-4 4 4h-3v8h-2V7H8zM3 19c0 1.1.9 2 2 2h14a2 2 0 002-2v-5h-2v5H5v-5H3v5z", clipRule: "evenodd" })), Hr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M20.85 8.7s-.15-1.27-.75-1.8c-.68-.75-1.43-.75-1.8-.75C15.75 6 12 6 12 6s-3.75 0-6.3.15c-.38.07-1.13.07-1.8.75-.52.52-.75 1.8-.75 1.8S3 10.13 3 11.63v1.34a34 34 0 00.15 2.93s.15 1.28.75 1.8c.68.75 1.57.68 1.95.75 1.43.15 6.15.15 6.15.15s3.75 0 6.3-.23c.38-.07 1.13-.07 1.8-.75.52-.52.75-1.8.75-1.8S21 14.4 21 12.9v-1.35c0-1.43-.15-2.85-.15-2.85zm-10.73 5.93V9.6L15 12.15l-4.88 2.47z" })), Qi = {
  additional: Tn,
  "arrow-down": An,
  "arrow-left": Mn,
  "arrow-light-down": kn,
  "arrow-light-left": Cn,
  "arrow-light-right": Nn,
  "arrow-light-up": In,
  "arrow-right": On,
  "arrow-up": Rn,
  book: Pn,
  calendar: Ln,
  checkmark: Dn,
  "chevron-down": zn,
  "chevron-left": Vn,
  "chevron-right": Bn,
  "chevron-up": $n,
  circle: Hn,
  close: Fn,
  "color-indicator": Gn,
  connected: qn,
  "copy-link": jn,
  cross: Wn,
  "default-avatar": Un,
  diagnostics: Yn,
  download: Xn,
  dropdown: Zn,
  dummy: Kn,
  email: Qn,
  "external-link": Jn,
  facebook: er,
  fax: tr,
  "file-download": ir,
  file: sr,
  filter: nr,
  globe: rr,
  "google-cal": ar,
  info: or,
  instagram: lr,
  linkedin: cr,
  list: dr,
  loading: ur,
  location: fr,
  logo: pr,
  map: hr,
  medicine: mr,
  minus: gr,
  "mobile-close": vr,
  "mobile-menu": _r,
  "mobile-search": wr,
  mobile: br,
  "molecular-item": yr,
  outlook: Er,
  partnership: xr,
  pause: Sr,
  patient: Tr,
  people: Ar,
  phone: Mr,
  play: kr,
  plus: Cr,
  podcasts: Nr,
  remove: Ir,
  "search-mobile": Or,
  search: Rr,
  series: Pr,
  "stock-down": Lr,
  "stock-equal": Dr,
  "stock-up": zr,
  time: Vr,
  twitter: Br,
  upload: $r,
  youtube: Hr
}, Fr = [
  "arrow-left",
  "arrow-light-left",
  "arrow-light-right",
  "arrow-right",
  "chevron-left",
  "chevron-right",
  "diagnostics",
  "external-link",
  "file-download",
  "file",
  "list",
  "stock-down",
  "stock-equal",
  "stock-up",
  "loading"
], Gr = "icon", kt = {
  "icon-container": "icon-container",
  icon: Gr,
  "icon--rtl": "icon--rtl",
  "icon-container--inline": "icon-container--inline"
};
function qr() {
  const [e, t] = V(!1);
  return F(() => {
    if (typeof document > "u")
      return;
    const i = document.documentElement, s = () => {
      t(i.getAttribute("dir") === "rtl");
    };
    s();
    const n = new MutationObserver((r) => {
      for (const a of r)
        a.type === "attributes" && a.attributeName === "dir" && s();
    });
    return n.observe(i, { attributes: !0 }), () => {
      n.disconnect();
    };
  }, []), e;
}
const q = ({
  icon: e,
  height: t,
  width: i,
  color: s,
  decorative: n = !0,
  display: r,
  onClick: a
}) => {
  if (!Object.keys(Qi).includes(e))
    return null;
  const l = qr() ? Fr.includes(e) : !1, c = Qi[e], d = {
    "--custom-icon-color": s
  };
  return /* @__PURE__ */ p("span", { className: L(kt["icon-container"], r === "inline" && kt["icon-container--inline"]), children: /* @__PURE__ */ p(
    c,
    {
      className: L(kt.icon, l && kt["icon--rtl"]),
      width: i,
      height: t,
      "aria-hidden": n,
      style: s ? d : void 0,
      onClick: a
    }
  ) });
}, jr = "accordion", Wr = "magnet", Ur = "accordion__header", Yr = "accordion__icon", Xr = "accordion__panel", Zr = "accordion__item", Fe = {
  accordion: jr,
  magnet: Wr,
  accordion__header: Ur,
  "accordion__header-text": "accordion__header-text",
  accordion__icon: Yr,
  accordion__panel: Xr,
  accordion__item: Zr,
  "accordion__item--active": "accordion__item--active",
  "accordion__item--closing": "accordion__item--closing"
}, mp = ({
  initiallyOpen: e,
  sections: t,
  headlineLevel: i = "h4",
  children: s,
  slot: n,
  onPanelToggle: r
}) => {
  const [a, o] = V(null), [l, c] = V(null), d = H([]), u = H([]), [h, g] = Rs(), { scrollToItem: _ } = Ps(u);
  F(() => {
    const v = h.substring(1), w = (t == null ? void 0 : t.findIndex((k) => k.id === v)) ?? null, y = e && e >= 0 && e < ((t == null ? void 0 : t.length) ?? 0) ? e : null, S = w !== null && w >= 0 ? w : y ?? null;
    o(S), w !== null && u.current[w] && _(w);
  }, []);
  const b = (v) => {
    var k, O;
    const w = a === v, y = w ? null : v;
    o(w ? null : v), c(w ? v : null), g(y !== null && ((k = t == null ? void 0 : t[y]) == null ? void 0 : k.id) || "");
    const S = (O = d.current) == null ? void 0 : O[v];
    S && (S.style.maxHeight = w ? "0px" : `${S.scrollHeight}px`, S.style.opacity = w ? "0" : "1");
  }, E = (v, w) => {
    var S;
    b(w);
    const y = ((S = t == null ? void 0 : t[w]) == null ? void 0 : S.headline) || "";
    r == null || r(v, y);
  }, x = (v, w) => {
    var S;
    if (v.propertyName !== "max-height")
      return;
    const y = (S = d.current) == null ? void 0 : S[w];
    l === w && y && y.style.maxHeight === "0px" && c(null);
  }, f = (v, w) => {
    var O;
    if (!t || t.length === 0)
      return;
    const { key: y } = v, S = t.length, k = {
      ArrowDown: (M, C) => (M + 1) % C,
      ArrowUp: (M, C) => (M - 1 + C) % C,
      Home: () => 0,
      End: (M, C) => C - 1
    };
    if (k[y]) {
      v.preventDefault();
      const M = k[y](w, S);
      (O = u.current[M]) == null || O.focus();
    } else (y === "Enter" || y === " ") && (v.preventDefault(), E(v, w));
  }, m = `${i}`;
  return /* @__PURE__ */ p("div", { className: Fe.accordion, slot: n, children: t == null ? void 0 : t.map((v, w) => {
    var y;
    return /* @__PURE__ */ I(
      "div",
      {
        className: L(
          Fe.accordion__item,
          a === w && Fe["accordion__item--active"],
          l === w && Fe["accordion__item--closing"]
        ),
        onTransitionEnd: (S) => x(S, w),
        children: [
          /* @__PURE__ */ p(m, { children: /* @__PURE__ */ I(
            "button",
            {
              className: Fe.accordion__header,
              id: `accordion-header-${v.id}`,
              type: "button",
              "aria-expanded": a === w,
              "aria-controls": `accordion-panel-${v.id}`,
              tabIndex: 0,
              onClick: (S) => E(S, w),
              onKeyDown: (S) => f(S, w),
              ref: (S) => u.current[w] = S,
              children: [
                /* @__PURE__ */ p("span", { className: Fe["accordion__header-text"], children: v.headline }),
                /* @__PURE__ */ p("span", { className: Fe.accordion__icon, children: /* @__PURE__ */ p(q, { icon: a === w ? "minus" : "plus", height: "24px", decorative: !0 }) })
              ]
            }
          ) }),
          /* @__PURE__ */ p(
            "div",
            {
              className: Fe.accordion__panel,
              id: `accordion-panel-${v.id}`,
              role: "region",
              "aria-labelledby": `accordion-header-${v.id}`,
              "aria-hidden": a !== w,
              style: {
                maxHeight: a === w ? `${(y = d.current[w]) == null ? void 0 : y.scrollHeight}px` : "0px",
                opacity: a === w ? 1 : 0
              },
              ref: (S) => d.current[w] = S,
              children: s == null ? void 0 : s[w]
            }
          )
        ]
      },
      v.id
    );
  }) });
}, Ji = {
  "roche-add-to-calendar": "roche-add-to-calendar",
  "roche-add-to-calendar__headline": "roche-add-to-calendar__headline"
};
var Kt = /* @__PURE__ */ ((e) => (e.SELF = "_self", e.BLANK = "_blank", e))(Kt || {}), Ls = /* @__PURE__ */ ((e) => (e.BUTTON = "button", e.SUBMIT = "submit", e.RESET = "reset", e))(Ls || {}), Ft = /* @__PURE__ */ ((e) => (e.LEFT = "left", e.CENTER = "center", e))(Ft || {}), Te = /* @__PURE__ */ ((e) => (e.PRIMARY = "primary", e.SECONDARY = "secondary", e.TERTIARY = "tertiary", e.SUCCESS = "success", e.ERROR = "error", e.BOTTOM_FIXED = "bottom-fixed", e))(Te || {});
const Kr = "button", Qr = "button__text", pe = {
  button: Kr,
  "button__icon-container": "button__icon-container",
  button__text: Qr,
  "button--left-aligned": "button--left-aligned",
  "button--primary": "button--primary",
  "button--disabled": "button--disabled",
  "button--secondary": "button--secondary",
  "button--tertiary": "button--tertiary",
  "button--success": "button--success",
  "button--error": "button--error",
  "button--bottom-fixed": "button--bottom-fixed",
  "button-wrapper": "button-wrapper",
  "button-wrapper--no-margin": "button-wrapper--no-margin"
}, Jr = 24, Qt = ({
  appearance: e = Te.PRIMARY,
  alignment: t = Ft.CENTER,
  disabled: i,
  download: s,
  text: n,
  type: r = Ls.BUTTON,
  target: a = Kt.SELF,
  leftIcon: o,
  rightIcon: l,
  href: c,
  hasMarginTop: d = !0,
  isModalTrigger: u,
  slot: h,
  onModalTrigger: g,
  onClick: _
}) => {
  const b = c ? "a" : "button", E = (v) => (
    // There's always text in the button, the icons are decorative: aria-hidden={true}
    /* @__PURE__ */ p("div", { className: pe["button__icon-container"], "aria-hidden": !0, children: /* @__PURE__ */ p(q, { icon: v, height: `${Ue(Jr)}rem` }) })
  ), x = c ? {
    target: a,
    ...s && { download: s },
    ...!i && { href: c }
  } : {
    type: r,
    disabled: i,
    appearance: e
  }, f = L(
    pe.button,
    i && pe["button--disabled"],
    t === Ft.LEFT && pe["button--left-aligned"],
    e === Te.PRIMARY && pe["button--primary"],
    e === Te.SECONDARY && pe["button--secondary"],
    e === Te.TERTIARY && pe["button--tertiary"],
    e === Te.SUCCESS && pe["button--success"],
    e === Te.ERROR && pe["button--error"],
    e === Te.BOTTOM_FIXED && pe["button--bottom-fixed"]
  ), m = (v) => {
    u && g && (v.preventDefault(), g()), _ && _(v);
  };
  return /* @__PURE__ */ p("div", { className: L(pe["button-wrapper"], !d && pe["button-wrapper--no-margin"]), slot: h, children: /* @__PURE__ */ I(b, { className: f, onClick: m, ...x, children: [
    o && E(o),
    /* @__PURE__ */ p("div", { className: pe.button__text, "data-content": n, children: n }),
    l && E(l)
  ] }) });
}, Ct = (e) => e ? new Date(e).toISOString() : "", es = (e) => e.replace(/-|:|\.\d{3}/g, ""), gp = ({
  heading: e,
  eventTitle: t,
  description: i,
  startDate: s,
  endDate: n,
  icsLabel: r,
  googleCalendarLabel: a,
  outlookOnlineLabel: o,
  onCalendarLinkClick: l
}) => {
  const c = Ct(s), d = Ct(n), u = es(Ct(s)), h = es(Ct(n)), g = [
    {
      title: t,
      text: r,
      href: `data:text/calendar,${encodeURIComponent(
        `BEGIN:VCALENDAR
VERSION:2.0
BEGIN:VEVENT
SUMMARY:${t}
DESCRIPTION:${i}
DTSTART:${u}
DTEND:${h}
END:VEVENT
END:VCALENDAR`
      )}`,
      icon: "file"
    },
    {
      text: a,
      href: `https://calendar.google.com/calendar/event?action=TEMPLATE&dates=${u}%2F${h}&text=${encodeURIComponent(
        t
      )}&details=${encodeURIComponent(i)}`,
      icon: "google-cal"
    },
    {
      text: o,
      href: `https://outlook.live.com/calendar/0/deeplink/compose?rru=addevent&path=%2Fcalendar%2Faction%2Fcompose&startdt=${c}&enddt=${d}&subject=${t}&body=${i}`,
      icon: "outlook"
    }
  ];
  return /* @__PURE__ */ I("div", { className: Ji["roche-add-to-calendar"], children: [
    /* @__PURE__ */ p("h3", { className: Ji["roche-add-to-calendar__headline"], children: e }),
    g.map((_, b) => /* @__PURE__ */ p(
      Qt,
      {
        hasMarginTop: !1,
        appearance: Te.SECONDARY,
        alignment: Ft.LEFT,
        download: _.title,
        text: _.text,
        href: _.href,
        leftIcon: _.icon,
        target: Kt.BLANK,
        onClick: (E) => l(E, _.text, _.href)
      },
      b
    ))
  ] });
}, ve = {
  "animated-words": "animated-words",
  "animated-words__headline": "animated-words__headline",
  "animated-words__text-container": "animated-words__text-container",
  "animated-words__words-container": "animated-words__words-container",
  "animated-words__word": "animated-words__word",
  "animated-words__word--active": "animated-words__word--active",
  "animated-words__word--previous": "animated-words__word--previous",
  "animated-words__word--next": "animated-words__word--next",
  "animated-words__word--red": "animated-words__word--red",
  "animated-words__word--orange": "animated-words__word--orange",
  "animated-words__word--purple": "animated-words__word--purple",
  "animated-words__word--brand": "animated-words__word--brand",
  "animated-words__word--effect": "animated-words__word--effect",
  "animated-words--animated": "animated-words--animated"
}, ea = (e) => {
  const [t, i] = V(!1);
  return F(() => {
    const s = new IntersectionObserver(([n]) => i(n.isIntersecting));
    return e.current && s.observe(e.current), () => {
      s.disconnect();
    };
  }, [e]), t;
}, Ds = (e) => {
  const [, t] = V(!1), i = H(!1);
  return F(() => {
    const s = new IntersectionObserver(([n]) => {
      n.isIntersecting && !i.current && (i.current = !0, t(!0));
    });
    return e.current && s.observe(e.current), () => {
      s.disconnect();
    };
  }, [e]), i.current;
}, ta = 1400, ia = ["red", "orange", "purple", "brand"], vp = ({ headline: e, words: t }) => {
  const i = H(null), [s, n] = V(0), r = ea(i), a = t ? t.trim().split(`
`) : [], o = a.length <= 3 && a.length > 1 ? [...a, ...a] : a, l = a.length > 1, c = (d) => {
    const u = d % a.length === a.length - 1 ? "animated-words__word--effect" : `animated-words__word--${ia[d % a.length % a.length]}`;
    if (!l)
      return L(ve["animated-words__word"], ve[u], {
        [ve["animated-words__word--active"]]: !0
      });
    const h = o.length, g = d === s, _ = d === (s - 1 + h) % h, b = d === (s + 1 + h) % h;
    return L(ve["animated-words__word"], ve[u], {
      [ve["animated-words__word--active"]]: g,
      [ve["animated-words__word--previous"]]: _,
      [ve["animated-words__word--next"]]: b
    });
  };
  return F(() => {
    if (l && r) {
      const d = setInterval(() => {
        n((u) => (u + 1) % o.length);
      }, ta);
      return () => clearInterval(d);
    }
  }, [a, r]), /* @__PURE__ */ I(
    "h2",
    {
      ref: i,
      className: L(ve["animated-words"], {
        [ve["animated-words--animated"]]: l
      }),
      "aria-label": `${e} ${t.replaceAll(`
`, ", ")}`,
      children: [
        /* @__PURE__ */ p("span", { className: ve["animated-words__headline"], children: e }),
        /* @__PURE__ */ p("div", { className: ve["animated-words__text-container"], children: o.map((d, u) => /* @__PURE__ */ p("span", { className: c(u), children: d }, u)) })
      ]
    }
  );
}, sa = "avatar", na = "avatar__fallback", ra = "avatar__icon", aa = "image", ai = {
  avatar: sa,
  avatar__fallback: na,
  avatar__icon: ra,
  image: aa
}, _p = ({ children: e }) => /* @__PURE__ */ p("div", { className: ai.avatar, children: e ?? /* @__PURE__ */ p("div", { className: ai.avatar__fallback, children: /* @__PURE__ */ p("div", { className: ai.avatar__icon, children: /* @__PURE__ */ p(q, { icon: "default-avatar", height: "100%", decorative: !0 }) }) }) }), oa = "overline", la = "overline__text", ts = {
  overline: oa,
  overline__text: la
}, ca = ({ overlineText: e, slot: t }) => /* @__PURE__ */ p("div", { className: ts.overline, slot: t, children: /* @__PURE__ */ p("p", { className: ts.overline__text, children: e }) }), st = {
  "text-link": "text-link",
  "text-link__link": "text-link__link",
  "text-link__icon-container": "text-link__icon-container",
  "text-link__text": "text-link__text",
  "text-link--footnote": "text-link--footnote",
  "text-link--contact-person": "text-link--contact-person",
  "text-link--footer-social": "text-link--footer-social",
  "text-link--footer-column": "text-link--footer-column",
  "text-link--footer-quick": "text-link--footer-quick",
  "text-link--footer-service": "text-link--footer-service",
  "text-link--breadcrumbs": "text-link--breadcrumbs",
  "text-link--news-page": "text-link--news-page",
  "icon-container": "icon-container"
};
var ot = /* @__PURE__ */ ((e) => (e.CONTACT_PERSON = "contact-person", e.FOOTER = "footer", e.FOOTER_QUICK = "footer-quick", e.FOOTER_COLUMN = "footer-column", e.FOOTER_SOCIAL = "footer-social", e.FOOTER_SERVICE = "footer-service", e.BREADCRUMBS = "breadcrumbs", e.NEWS_PAGE = "news-page", e))(ot || {}), da = /* @__PURE__ */ ((e) => (e.FOOTNOTE = "footnote", e))(da || {});
const Gt = ({
  href: e,
  text: t,
  slot: i,
  target: s,
  leftIcon: n,
  rightIcon: r,
  label: a,
  type: o,
  size: l,
  onButtonClick: c,
  onTextLinkClick: d
}) => {
  const u = e ? "a" : "button", h = e ? { href: e, target: s } : {}, g = (_) => {
    const b = o === ot.NEWS_PAGE;
    return /* @__PURE__ */ p("span", { className: st["text-link__icon-container"], children: /* @__PURE__ */ p(q, { icon: _, height: b ? "14px" : "24px" }) });
  };
  return /* @__PURE__ */ p(
    "span",
    {
      className: L(st["text-link"], o && st[`text-link--${o}`], l && st[` text-link--${l}`]),
      slot: i,
      children: /* @__PURE__ */ I(
        u,
        {
          className: st["text-link__link"],
          ...h,
          "aria-label": a,
          onClick: u === "a" ? d : c,
          children: [
            n && g(n),
            /* @__PURE__ */ p("span", { className: st["text-link__text"], children: t }),
            r && g(r)
          ]
        }
      )
    }
  );
}, is = {
  "roche-back-to-branch": "roche-back-to-branch",
  "roche-back-to-branch__content": "roche-back-to-branch__content"
}, ua = "headline", oi = {
  headline: ua,
  "headline--1": "headline--1",
  "headline--2": "headline--2",
  "headline--3": "headline--3",
  "headline--4": "headline--4",
  "headline--5": "headline--5",
  "headline--6": "headline--6",
  "headline--pipeline": "headline--pipeline"
};
var yi = /* @__PURE__ */ ((e) => (e.DEFAULT = "default", e.PIPELINE = "pipeline", e))(yi || {});
const zs = ({
  headline: e,
  level: t = "1",
  appearance: i = yi.DEFAULT,
  children: s,
  slot: n
}) => {
  const r = `h${t}`;
  return /* @__PURE__ */ p(
    r,
    {
      slot: n,
      className: L(
        oi.headline,
        oi[`headline--${t}`],
        i !== yi.DEFAULT && oi[`headline--${i}`]
      ),
      children: e || s
    }
  );
}, wp = ({
  overlineText: e,
  headline: t,
  linkText: i,
  link: s,
  icon: n,
  slot: r
}) => /* @__PURE__ */ I("section", { className: is["roche-back-to-branch"], slot: r, children: [
  /* @__PURE__ */ I("div", { className: is["roche-back-to-branch__content"], children: [
    e && /* @__PURE__ */ p(ca, { overlineText: e }),
    /* @__PURE__ */ p(zs, { headline: t, level: "5" })
  ] }),
  /* @__PURE__ */ p(Gt, { rightIcon: n, href: s, text: i, target: Zt.SELF })
] }), fa = "breadcrumbs", pa = "breadcrumbs__item", ha = "breadcrumbs__text", ma = "breadcrumbs__icon", pt = {
  breadcrumbs: fa,
  "breadcrumbs__item-list": "breadcrumbs__item-list",
  breadcrumbs__item: pa,
  breadcrumbs__text: ha,
  breadcrumbs__icon: ma
}, ga = ({ items: e, ariaLabel: t, slot: i, onBreadcrumbClick: s }) => {
  const n = (r, a) => /* @__PURE__ */ I(bn.Fragment, { children: [
    a > 0 && /* @__PURE__ */ p("span", { className: pt.breadcrumbs__icon, children: /* @__PURE__ */ p(q, { icon: "chevron-right", height: "14px" }) }),
    /* @__PURE__ */ p("li", { className: pt.breadcrumbs__item, children: r.href ? /* @__PURE__ */ p(
      Gt,
      {
        href: r.href,
        text: r.text,
        target: Zt.SELF,
        type: ot.BREADCRUMBS,
        onTextLinkClick: () => s(ot.BREADCRUMBS, r.text, r.href)
      }
    ) : /* @__PURE__ */ p("p", { className: pt.breadcrumbs__text, children: r.text }) })
  ] }, `breadcrumb-${a}`);
  return /* @__PURE__ */ p("nav", { className: pt.breadcrumbs, "aria-label": t, slot: i, children: /* @__PURE__ */ p("ol", { className: pt["breadcrumbs__item-list"], children: e == null ? void 0 : e.map((r, a) => n(r, a)) }) });
};
var Lt = /* @__PURE__ */ ((e) => (e.VARIANT_A = "contact-person--variant-a", e.VARIANT_A_WITHOUT_IMAGE = "contact-person--variant-a-without-image", e.VARIANT_B = "contact-person--variant-b", e))(Lt || {});
const nt = {
  "contact-person": "contact-person",
  "contact-person__avatar": "contact-person__avatar",
  "contact-person__name": "contact-person__name",
  "contact-person__job-title": "contact-person__job-title",
  "contact-person__phone-number": "contact-person__phone-number",
  "contact-person__email-address": "contact-person__email-address"
}, bp = ({
  layout: e = Lt.VARIANT_A,
  name: t,
  jobTitle: i,
  phoneNumber: s,
  emailAddress: n,
  children: r,
  slot: a
}) => {
  const o = e !== Lt.VARIANT_B, l = e !== Lt.VARIANT_A_WITHOUT_IMAGE && r;
  return /* @__PURE__ */ I("div", { className: nt["contact-person"], slot: a, children: [
    l && /* @__PURE__ */ p("div", { className: nt["contact-person__avatar"], children: r }),
    /* @__PURE__ */ p("h3", { className: nt["contact-person__name"], children: t }),
    /* @__PURE__ */ p("p", { className: nt["contact-person__job-title"], children: i }),
    o && s && /* @__PURE__ */ p("div", { className: nt["contact-person__phone-number"], children: /* @__PURE__ */ p(
      Gt,
      {
        href: `tel:${s}`,
        text: s,
        leftIcon: "phone",
        type: ot.CONTACT_PERSON
      },
      "phone-number"
    ) }),
    o && n && /* @__PURE__ */ p("div", { className: nt["contact-person__email-address"], children: /* @__PURE__ */ p(
      Gt,
      {
        href: `mailto:${n}`,
        text: n,
        leftIcon: "email",
        type: ot.CONTACT_PERSON
      },
      "email-address"
    ) })
  ] });
}, va = "container", Ke = {
  container: va,
  "container--full-width": "container--full-width",
  "container--colored": "container--colored",
  "container--theme-aware": "container--theme-aware",
  "container--aware-gradient-top-left": "container--aware-gradient-top-left",
  "container--aware-gradient-bottom-right": "container--aware-gradient-bottom-right",
  "container--neutral-gradient-top-left": "container--neutral-gradient-top-left",
  "container--blue-gradient-top-left": "container--blue-gradient-top-left",
  "container--blue-gradient-bottom-right": "container--blue-gradient-bottom-right",
  "container--neutral-gradient-bottom-right": "container--neutral-gradient-bottom-right",
  "container--neutral-gradient-neutral-100-neutral-400": "container--neutral-gradient-neutral-100-neutral-400",
  "container--neutral-100": "container--neutral-100",
  "container--neutral-200": "container--neutral-200",
  "container--grey-50": "container--grey-50",
  "container--grey-100": "container--grey-100",
  "container--grey-300": "container--grey-300",
  "container--white": "container--white",
  "container--split-gradient-radial": "container--split-gradient-radial",
  "container__gradient-helper": "container__gradient-helper",
  "container--split-gradient-linear": "container--split-gradient-linear",
  "container--brand-gradient": "container--brand-gradient",
  "brand-gradient-animation": "brand-gradient-animation",
  "container--extended-background": "container--extended-background",
  "container--full-height": "container--full-height"
};
var Ei = /* @__PURE__ */ ((e) => (e.TRANSPARENT = "transparent", e.THEME_AWARE = "theme-aware", e.NEUTRAL_GRADIENT_TOP_LEFT = "neutral-gradient-top-left", e.NEUTRAL_GRADIENT_BOTTOM_RIGHT = "neutral-gradient-bottom-right", e.NEUTRAL_GRADIENT_NEUTRAL_100_NEUTRAL_400 = "neutral-gradient-neutral-100-neutral-400", e.NEUTRAL_100 = "neutral-100", e.NEUTRAL_200 = "neutral-200", e.GREY_50 = "grey-50", e.GREY_100 = "grey-100", e.GREY_300 = "grey-300", e.WHITE = "white", e.AWARE_SOFT_TOP_LEFT = "aware-gradient-top-left", e.AWARE_SOFT_BOTTOM_RIGHT = "aware-gradient-bottom-right", e.BLUE_GRADIENT_TOP_LEFT = "blue-gradient-top-left", e.BLUE_GRADIENT_BOTTOM_RIGHT = "blue-gradient-bottom-right", e.SPLIT_GRADIENT = "split-gradient-radial", e.GRADIENT_WHITE_TO_GRAY_4 = "split-gradient-linear", e.BRAND_GRADIENT = "brand-gradient", e))(Ei || {});
const _a = ({
  color: e = Ei.TRANSPARENT,
  fullWidth: t,
  fullHeight: i,
  extendBackgroundToTop: s,
  children: n
}) => {
  const r = L(
    Ke.container,
    e !== Ei.TRANSPARENT && Ke["container--colored"],
    Ke["container--" + e],
    t && Ke["container--full-width"],
    i && Ke["container--full-height"],
    s && Ke["container--extended-background"]
  );
  return /* @__PURE__ */ I("div", { className: r, children: [
    /* @__PURE__ */ p("div", { className: Ke["container__gradient-helper"] }),
    n
  ] });
}, Se = {
  "roche-dropdown": "roche-dropdown",
  "roche-dropdown__label-wrapper": "roche-dropdown__label-wrapper",
  "roche-dropdown__label": "roche-dropdown__label",
  "roche-dropdown__select": "roche-dropdown__select",
  "roche-dropdown__select--placeholder": "roche-dropdown__select--placeholder",
  "roche-dropdown__container": "roche-dropdown__container",
  "roche-dropdown__icon": "roche-dropdown__icon",
  "roche-dropdown--disabled": "roche-dropdown--disabled",
  "roche-dropdown__error": "roche-dropdown__error",
  "roche-dropdown--error": "roche-dropdown--error",
  "roche-dropdown__error-text": "roche-dropdown__error-text"
}, wa = "tooltip", ba = "tooltip__icon", ya = "tooltip__content", Ea = "tooltip__arrow", xa = "tooltip__text", Qe = {
  tooltip: wa,
  tooltip__icon: ba,
  "tooltip__icon--active": "tooltip__icon--active",
  tooltip__content: ya,
  tooltip__arrow: Ea,
  "tooltip__content--open": "tooltip__content--open",
  tooltip__text: xa
};
var ss = function(t) {
  return t.reduce(function(i, s) {
    var n = s[0], r = s[1];
    return i[n] = r, i;
  }, {});
}, ns = typeof window < "u" && window.document && window.document.createElement ? T.useLayoutEffect : T.useEffect, ue = "top", Ee = "bottom", xe = "right", fe = "left", Oi = "auto", Tt = [ue, Ee, xe, fe], lt = "start", yt = "end", Sa = "clippingParents", Vs = "viewport", ht = "popper", Ta = "reference", rs = /* @__PURE__ */ Tt.reduce(function(e, t) {
  return e.concat([t + "-" + lt, t + "-" + yt]);
}, []), Bs = /* @__PURE__ */ [].concat(Tt, [Oi]).reduce(function(e, t) {
  return e.concat([t, t + "-" + lt, t + "-" + yt]);
}, []), Aa = "beforeRead", Ma = "read", ka = "afterRead", Ca = "beforeMain", Na = "main", Ia = "afterMain", Oa = "beforeWrite", Ra = "write", Pa = "afterWrite", La = [Aa, Ma, ka, Ca, Na, Ia, Oa, Ra, Pa];
function Ie(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function ge(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function tt(e) {
  var t = ge(e).Element;
  return e instanceof t || e instanceof Element;
}
function ye(e) {
  var t = ge(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function Ri(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = ge(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function Da(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(i) {
    var s = t.styles[i] || {}, n = t.attributes[i] || {}, r = t.elements[i];
    !ye(r) || !Ie(r) || (Object.assign(r.style, s), Object.keys(n).forEach(function(a) {
      var o = n[a];
      o === !1 ? r.removeAttribute(a) : r.setAttribute(a, o === !0 ? "" : o);
    }));
  });
}
function za(e) {
  var t = e.state, i = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, i.popper), t.styles = i, t.elements.arrow && Object.assign(t.elements.arrow.style, i.arrow), function() {
    Object.keys(t.elements).forEach(function(s) {
      var n = t.elements[s], r = t.attributes[s] || {}, a = Object.keys(t.styles.hasOwnProperty(s) ? t.styles[s] : i[s]), o = a.reduce(function(l, c) {
        return l[c] = "", l;
      }, {});
      !ye(n) || !Ie(n) || (Object.assign(n.style, o), Object.keys(r).forEach(function(l) {
        n.removeAttribute(l);
      }));
    });
  };
}
const Va = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Da,
  effect: za,
  requires: ["computeStyles"]
};
function Ne(e) {
  return e.split("-")[0];
}
var et = Math.max, qt = Math.min, ct = Math.round;
function xi() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function $s() {
  return !/^((?!chrome|android).)*safari/i.test(xi());
}
function dt(e, t, i) {
  t === void 0 && (t = !1), i === void 0 && (i = !1);
  var s = e.getBoundingClientRect(), n = 1, r = 1;
  t && ye(e) && (n = e.offsetWidth > 0 && ct(s.width) / e.offsetWidth || 1, r = e.offsetHeight > 0 && ct(s.height) / e.offsetHeight || 1);
  var a = tt(e) ? ge(e) : window, o = a.visualViewport, l = !$s() && i, c = (s.left + (l && o ? o.offsetLeft : 0)) / n, d = (s.top + (l && o ? o.offsetTop : 0)) / r, u = s.width / n, h = s.height / r;
  return {
    width: u,
    height: h,
    top: d,
    right: c + u,
    bottom: d + h,
    left: c,
    x: c,
    y: d
  };
}
function Pi(e) {
  var t = dt(e), i = e.offsetWidth, s = e.offsetHeight;
  return Math.abs(t.width - i) <= 1 && (i = t.width), Math.abs(t.height - s) <= 1 && (s = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: i,
    height: s
  };
}
function Hs(e, t) {
  var i = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (i && Ri(i)) {
    var s = t;
    do {
      if (s && e.isSameNode(s))
        return !0;
      s = s.parentNode || s.host;
    } while (s);
  }
  return !1;
}
function $e(e) {
  return ge(e).getComputedStyle(e);
}
function Ba(e) {
  return ["table", "td", "th"].indexOf(Ie(e)) >= 0;
}
function Xe(e) {
  return ((tt(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Jt(e) {
  return Ie(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (Ri(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Xe(e)
  );
}
function as(e) {
  return !ye(e) || // https://github.com/popperjs/popper-core/issues/837
  $e(e).position === "fixed" ? null : e.offsetParent;
}
function $a(e) {
  var t = /firefox/i.test(xi()), i = /Trident/i.test(xi());
  if (i && ye(e)) {
    var s = $e(e);
    if (s.position === "fixed")
      return null;
  }
  var n = Jt(e);
  for (Ri(n) && (n = n.host); ye(n) && ["html", "body"].indexOf(Ie(n)) < 0; ) {
    var r = $e(n);
    if (r.transform !== "none" || r.perspective !== "none" || r.contain === "paint" || ["transform", "perspective"].indexOf(r.willChange) !== -1 || t && r.willChange === "filter" || t && r.filter && r.filter !== "none")
      return n;
    n = n.parentNode;
  }
  return null;
}
function At(e) {
  for (var t = ge(e), i = as(e); i && Ba(i) && $e(i).position === "static"; )
    i = as(i);
  return i && (Ie(i) === "html" || Ie(i) === "body" && $e(i).position === "static") ? t : i || $a(e) || t;
}
function Li(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function wt(e, t, i) {
  return et(e, qt(t, i));
}
function Ha(e, t, i) {
  var s = wt(e, t, i);
  return s > i ? i : s;
}
function Fs() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Gs(e) {
  return Object.assign({}, Fs(), e);
}
function qs(e, t) {
  return t.reduce(function(i, s) {
    return i[s] = e, i;
  }, {});
}
var Fa = function(t, i) {
  return t = typeof t == "function" ? t(Object.assign({}, i.rects, {
    placement: i.placement
  })) : t, Gs(typeof t != "number" ? t : qs(t, Tt));
};
function Ga(e) {
  var t, i = e.state, s = e.name, n = e.options, r = i.elements.arrow, a = i.modifiersData.popperOffsets, o = Ne(i.placement), l = Li(o), c = [fe, xe].indexOf(o) >= 0, d = c ? "height" : "width";
  if (!(!r || !a)) {
    var u = Fa(n.padding, i), h = Pi(r), g = l === "y" ? ue : fe, _ = l === "y" ? Ee : xe, b = i.rects.reference[d] + i.rects.reference[l] - a[l] - i.rects.popper[d], E = a[l] - i.rects.reference[l], x = At(r), f = x ? l === "y" ? x.clientHeight || 0 : x.clientWidth || 0 : 0, m = b / 2 - E / 2, v = u[g], w = f - h[d] - u[_], y = f / 2 - h[d] / 2 + m, S = wt(v, y, w), k = l;
    i.modifiersData[s] = (t = {}, t[k] = S, t.centerOffset = S - y, t);
  }
}
function qa(e) {
  var t = e.state, i = e.options, s = i.element, n = s === void 0 ? "[data-popper-arrow]" : s;
  n != null && (typeof n == "string" && (n = t.elements.popper.querySelector(n), !n) || Hs(t.elements.popper, n) && (t.elements.arrow = n));
}
const ja = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Ga,
  effect: qa,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function ut(e) {
  return e.split("-")[1];
}
var Wa = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Ua(e, t) {
  var i = e.x, s = e.y, n = t.devicePixelRatio || 1;
  return {
    x: ct(i * n) / n || 0,
    y: ct(s * n) / n || 0
  };
}
function os(e) {
  var t, i = e.popper, s = e.popperRect, n = e.placement, r = e.variation, a = e.offsets, o = e.position, l = e.gpuAcceleration, c = e.adaptive, d = e.roundOffsets, u = e.isFixed, h = a.x, g = h === void 0 ? 0 : h, _ = a.y, b = _ === void 0 ? 0 : _, E = typeof d == "function" ? d({
    x: g,
    y: b
  }) : {
    x: g,
    y: b
  };
  g = E.x, b = E.y;
  var x = a.hasOwnProperty("x"), f = a.hasOwnProperty("y"), m = fe, v = ue, w = window;
  if (c) {
    var y = At(i), S = "clientHeight", k = "clientWidth";
    if (y === ge(i) && (y = Xe(i), $e(y).position !== "static" && o === "absolute" && (S = "scrollHeight", k = "scrollWidth")), y = y, n === ue || (n === fe || n === xe) && r === yt) {
      v = Ee;
      var O = u && y === w && w.visualViewport ? w.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        y[S]
      );
      b -= O - s.height, b *= l ? 1 : -1;
    }
    if (n === fe || (n === ue || n === Ee) && r === yt) {
      m = xe;
      var M = u && y === w && w.visualViewport ? w.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        y[k]
      );
      g -= M - s.width, g *= l ? 1 : -1;
    }
  }
  var C = Object.assign({
    position: o
  }, c && Wa), D = d === !0 ? Ua({
    x: g,
    y: b
  }, ge(i)) : {
    x: g,
    y: b
  };
  if (g = D.x, b = D.y, l) {
    var P;
    return Object.assign({}, C, (P = {}, P[v] = f ? "0" : "", P[m] = x ? "0" : "", P.transform = (w.devicePixelRatio || 1) <= 1 ? "translate(" + g + "px, " + b + "px)" : "translate3d(" + g + "px, " + b + "px, 0)", P));
  }
  return Object.assign({}, C, (t = {}, t[v] = f ? b + "px" : "", t[m] = x ? g + "px" : "", t.transform = "", t));
}
function Ya(e) {
  var t = e.state, i = e.options, s = i.gpuAcceleration, n = s === void 0 ? !0 : s, r = i.adaptive, a = r === void 0 ? !0 : r, o = i.roundOffsets, l = o === void 0 ? !0 : o, c = {
    placement: Ne(t.placement),
    variation: ut(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: n,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, os(Object.assign({}, c, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: a,
    roundOffsets: l
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, os(Object.assign({}, c, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const Xa = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: Ya,
  data: {}
};
var Nt = {
  passive: !0
};
function Za(e) {
  var t = e.state, i = e.instance, s = e.options, n = s.scroll, r = n === void 0 ? !0 : n, a = s.resize, o = a === void 0 ? !0 : a, l = ge(t.elements.popper), c = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return r && c.forEach(function(d) {
    d.addEventListener("scroll", i.update, Nt);
  }), o && l.addEventListener("resize", i.update, Nt), function() {
    r && c.forEach(function(d) {
      d.removeEventListener("scroll", i.update, Nt);
    }), o && l.removeEventListener("resize", i.update, Nt);
  };
}
const Ka = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Za,
  data: {}
};
var Qa = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Dt(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return Qa[t];
  });
}
var Ja = {
  start: "end",
  end: "start"
};
function ls(e) {
  return e.replace(/start|end/g, function(t) {
    return Ja[t];
  });
}
function Di(e) {
  var t = ge(e), i = t.pageXOffset, s = t.pageYOffset;
  return {
    scrollLeft: i,
    scrollTop: s
  };
}
function zi(e) {
  return dt(Xe(e)).left + Di(e).scrollLeft;
}
function eo(e, t) {
  var i = ge(e), s = Xe(e), n = i.visualViewport, r = s.clientWidth, a = s.clientHeight, o = 0, l = 0;
  if (n) {
    r = n.width, a = n.height;
    var c = $s();
    (c || !c && t === "fixed") && (o = n.offsetLeft, l = n.offsetTop);
  }
  return {
    width: r,
    height: a,
    x: o + zi(e),
    y: l
  };
}
function to(e) {
  var t, i = Xe(e), s = Di(e), n = (t = e.ownerDocument) == null ? void 0 : t.body, r = et(i.scrollWidth, i.clientWidth, n ? n.scrollWidth : 0, n ? n.clientWidth : 0), a = et(i.scrollHeight, i.clientHeight, n ? n.scrollHeight : 0, n ? n.clientHeight : 0), o = -s.scrollLeft + zi(e), l = -s.scrollTop;
  return $e(n || i).direction === "rtl" && (o += et(i.clientWidth, n ? n.clientWidth : 0) - r), {
    width: r,
    height: a,
    x: o,
    y: l
  };
}
function Vi(e) {
  var t = $e(e), i = t.overflow, s = t.overflowX, n = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(i + n + s);
}
function js(e) {
  return ["html", "body", "#document"].indexOf(Ie(e)) >= 0 ? e.ownerDocument.body : ye(e) && Vi(e) ? e : js(Jt(e));
}
function bt(e, t) {
  var i;
  t === void 0 && (t = []);
  var s = js(e), n = s === ((i = e.ownerDocument) == null ? void 0 : i.body), r = ge(s), a = n ? [r].concat(r.visualViewport || [], Vi(s) ? s : []) : s, o = t.concat(a);
  return n ? o : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    o.concat(bt(Jt(a)))
  );
}
function Si(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function io(e, t) {
  var i = dt(e, !1, t === "fixed");
  return i.top = i.top + e.clientTop, i.left = i.left + e.clientLeft, i.bottom = i.top + e.clientHeight, i.right = i.left + e.clientWidth, i.width = e.clientWidth, i.height = e.clientHeight, i.x = i.left, i.y = i.top, i;
}
function cs(e, t, i) {
  return t === Vs ? Si(eo(e, i)) : tt(t) ? io(t, i) : Si(to(Xe(e)));
}
function so(e) {
  var t = bt(Jt(e)), i = ["absolute", "fixed"].indexOf($e(e).position) >= 0, s = i && ye(e) ? At(e) : e;
  return tt(s) ? t.filter(function(n) {
    return tt(n) && Hs(n, s) && Ie(n) !== "body";
  }) : [];
}
function no(e, t, i, s) {
  var n = t === "clippingParents" ? so(e) : [].concat(t), r = [].concat(n, [i]), a = r[0], o = r.reduce(function(l, c) {
    var d = cs(e, c, s);
    return l.top = et(d.top, l.top), l.right = qt(d.right, l.right), l.bottom = qt(d.bottom, l.bottom), l.left = et(d.left, l.left), l;
  }, cs(e, a, s));
  return o.width = o.right - o.left, o.height = o.bottom - o.top, o.x = o.left, o.y = o.top, o;
}
function Ws(e) {
  var t = e.reference, i = e.element, s = e.placement, n = s ? Ne(s) : null, r = s ? ut(s) : null, a = t.x + t.width / 2 - i.width / 2, o = t.y + t.height / 2 - i.height / 2, l;
  switch (n) {
    case ue:
      l = {
        x: a,
        y: t.y - i.height
      };
      break;
    case Ee:
      l = {
        x: a,
        y: t.y + t.height
      };
      break;
    case xe:
      l = {
        x: t.x + t.width,
        y: o
      };
      break;
    case fe:
      l = {
        x: t.x - i.width,
        y: o
      };
      break;
    default:
      l = {
        x: t.x,
        y: t.y
      };
  }
  var c = n ? Li(n) : null;
  if (c != null) {
    var d = c === "y" ? "height" : "width";
    switch (r) {
      case lt:
        l[c] = l[c] - (t[d] / 2 - i[d] / 2);
        break;
      case yt:
        l[c] = l[c] + (t[d] / 2 - i[d] / 2);
        break;
    }
  }
  return l;
}
function Et(e, t) {
  t === void 0 && (t = {});
  var i = t, s = i.placement, n = s === void 0 ? e.placement : s, r = i.strategy, a = r === void 0 ? e.strategy : r, o = i.boundary, l = o === void 0 ? Sa : o, c = i.rootBoundary, d = c === void 0 ? Vs : c, u = i.elementContext, h = u === void 0 ? ht : u, g = i.altBoundary, _ = g === void 0 ? !1 : g, b = i.padding, E = b === void 0 ? 0 : b, x = Gs(typeof E != "number" ? E : qs(E, Tt)), f = h === ht ? Ta : ht, m = e.rects.popper, v = e.elements[_ ? f : h], w = no(tt(v) ? v : v.contextElement || Xe(e.elements.popper), l, d, a), y = dt(e.elements.reference), S = Ws({
    reference: y,
    element: m,
    strategy: "absolute",
    placement: n
  }), k = Si(Object.assign({}, m, S)), O = h === ht ? k : y, M = {
    top: w.top - O.top + x.top,
    bottom: O.bottom - w.bottom + x.bottom,
    left: w.left - O.left + x.left,
    right: O.right - w.right + x.right
  }, C = e.modifiersData.offset;
  if (h === ht && C) {
    var D = C[n];
    Object.keys(M).forEach(function(P) {
      var $ = [xe, Ee].indexOf(P) >= 0 ? 1 : -1, B = [ue, Ee].indexOf(P) >= 0 ? "y" : "x";
      M[P] += D[B] * $;
    });
  }
  return M;
}
function ro(e, t) {
  t === void 0 && (t = {});
  var i = t, s = i.placement, n = i.boundary, r = i.rootBoundary, a = i.padding, o = i.flipVariations, l = i.allowedAutoPlacements, c = l === void 0 ? Bs : l, d = ut(s), u = d ? o ? rs : rs.filter(function(_) {
    return ut(_) === d;
  }) : Tt, h = u.filter(function(_) {
    return c.indexOf(_) >= 0;
  });
  h.length === 0 && (h = u);
  var g = h.reduce(function(_, b) {
    return _[b] = Et(e, {
      placement: b,
      boundary: n,
      rootBoundary: r,
      padding: a
    })[Ne(b)], _;
  }, {});
  return Object.keys(g).sort(function(_, b) {
    return g[_] - g[b];
  });
}
function ao(e) {
  if (Ne(e) === Oi)
    return [];
  var t = Dt(e);
  return [ls(e), t, ls(t)];
}
function oo(e) {
  var t = e.state, i = e.options, s = e.name;
  if (!t.modifiersData[s]._skip) {
    for (var n = i.mainAxis, r = n === void 0 ? !0 : n, a = i.altAxis, o = a === void 0 ? !0 : a, l = i.fallbackPlacements, c = i.padding, d = i.boundary, u = i.rootBoundary, h = i.altBoundary, g = i.flipVariations, _ = g === void 0 ? !0 : g, b = i.allowedAutoPlacements, E = t.options.placement, x = Ne(E), f = x === E, m = l || (f || !_ ? [Dt(E)] : ao(E)), v = [E].concat(m).reduce(function(Oe, re) {
      return Oe.concat(Ne(re) === Oi ? ro(t, {
        placement: re,
        boundary: d,
        rootBoundary: u,
        padding: c,
        flipVariations: _,
        allowedAutoPlacements: b
      }) : re);
    }, []), w = t.rects.reference, y = t.rects.popper, S = /* @__PURE__ */ new Map(), k = !0, O = v[0], M = 0; M < v.length; M++) {
      var C = v[M], D = Ne(C), P = ut(C) === lt, $ = [ue, Ee].indexOf(D) >= 0, B = $ ? "width" : "height", R = Et(t, {
        placement: C,
        boundary: d,
        rootBoundary: u,
        altBoundary: h,
        padding: c
      }), A = $ ? P ? xe : fe : P ? Ee : ue;
      w[B] > y[B] && (A = Dt(A));
      var N = Dt(A), z = [];
      if (r && z.push(R[D] <= 0), o && z.push(R[A] <= 0, R[N] <= 0), z.every(function(Oe) {
        return Oe;
      })) {
        O = C, k = !1;
        break;
      }
      S.set(C, z);
    }
    if (k)
      for (var G = _ ? 3 : 1, J = function(re) {
        var Re = v.find(function(it) {
          var Pe = S.get(it);
          if (Pe)
            return Pe.slice(0, re).every(function(ii) {
              return ii;
            });
        });
        if (Re)
          return O = Re, "break";
      }, X = G; X > 0; X--) {
        var K = J(X);
        if (K === "break") break;
      }
    t.placement !== O && (t.modifiersData[s]._skip = !0, t.placement = O, t.reset = !0);
  }
}
const lo = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: oo,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function ds(e, t, i) {
  return i === void 0 && (i = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - i.y,
    right: e.right - t.width + i.x,
    bottom: e.bottom - t.height + i.y,
    left: e.left - t.width - i.x
  };
}
function us(e) {
  return [ue, xe, Ee, fe].some(function(t) {
    return e[t] >= 0;
  });
}
function co(e) {
  var t = e.state, i = e.name, s = t.rects.reference, n = t.rects.popper, r = t.modifiersData.preventOverflow, a = Et(t, {
    elementContext: "reference"
  }), o = Et(t, {
    altBoundary: !0
  }), l = ds(a, s), c = ds(o, n, r), d = us(l), u = us(c);
  t.modifiersData[i] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: c,
    isReferenceHidden: d,
    hasPopperEscaped: u
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": d,
    "data-popper-escaped": u
  });
}
const uo = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: co
};
function fo(e, t, i) {
  var s = Ne(e), n = [fe, ue].indexOf(s) >= 0 ? -1 : 1, r = typeof i == "function" ? i(Object.assign({}, t, {
    placement: e
  })) : i, a = r[0], o = r[1];
  return a = a || 0, o = (o || 0) * n, [fe, xe].indexOf(s) >= 0 ? {
    x: o,
    y: a
  } : {
    x: a,
    y: o
  };
}
function po(e) {
  var t = e.state, i = e.options, s = e.name, n = i.offset, r = n === void 0 ? [0, 0] : n, a = Bs.reduce(function(d, u) {
    return d[u] = fo(u, t.rects, r), d;
  }, {}), o = a[t.placement], l = o.x, c = o.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += l, t.modifiersData.popperOffsets.y += c), t.modifiersData[s] = a;
}
const ho = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: po
};
function mo(e) {
  var t = e.state, i = e.name;
  t.modifiersData[i] = Ws({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const go = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: mo,
  data: {}
};
function vo(e) {
  return e === "x" ? "y" : "x";
}
function _o(e) {
  var t = e.state, i = e.options, s = e.name, n = i.mainAxis, r = n === void 0 ? !0 : n, a = i.altAxis, o = a === void 0 ? !1 : a, l = i.boundary, c = i.rootBoundary, d = i.altBoundary, u = i.padding, h = i.tether, g = h === void 0 ? !0 : h, _ = i.tetherOffset, b = _ === void 0 ? 0 : _, E = Et(t, {
    boundary: l,
    rootBoundary: c,
    padding: u,
    altBoundary: d
  }), x = Ne(t.placement), f = ut(t.placement), m = !f, v = Li(x), w = vo(v), y = t.modifiersData.popperOffsets, S = t.rects.reference, k = t.rects.popper, O = typeof b == "function" ? b(Object.assign({}, t.rects, {
    placement: t.placement
  })) : b, M = typeof O == "number" ? {
    mainAxis: O,
    altAxis: O
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, O), C = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, D = {
    x: 0,
    y: 0
  };
  if (y) {
    if (r) {
      var P, $ = v === "y" ? ue : fe, B = v === "y" ? Ee : xe, R = v === "y" ? "height" : "width", A = y[v], N = A + E[$], z = A - E[B], G = g ? -k[R] / 2 : 0, J = f === lt ? S[R] : k[R], X = f === lt ? -k[R] : -S[R], K = t.elements.arrow, Oe = g && K ? Pi(K) : {
        width: 0,
        height: 0
      }, re = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : Fs(), Re = re[$], it = re[B], Pe = wt(0, S[R], Oe[R]), ii = m ? S[R] / 2 - G - Pe - Re - M.mainAxis : J - Pe - Re - M.mainAxis, hn = m ? -S[R] / 2 + G + Pe + it + M.mainAxis : X + Pe + it + M.mainAxis, si = t.elements.arrow && At(t.elements.arrow), mn = si ? v === "y" ? si.clientTop || 0 : si.clientLeft || 0 : 0, Gi = (P = C == null ? void 0 : C[v]) != null ? P : 0, gn = A + ii - Gi - mn, vn = A + hn - Gi, qi = wt(g ? qt(N, gn) : N, A, g ? et(z, vn) : z);
      y[v] = qi, D[v] = qi - A;
    }
    if (o) {
      var ji, _n = v === "x" ? ue : fe, wn = v === "x" ? Ee : xe, Ze = y[w], Mt = w === "y" ? "height" : "width", Wi = Ze + E[_n], Ui = Ze - E[wn], ni = [ue, fe].indexOf(x) !== -1, Yi = (ji = C == null ? void 0 : C[w]) != null ? ji : 0, Xi = ni ? Wi : Ze - S[Mt] - k[Mt] - Yi + M.altAxis, Zi = ni ? Ze + S[Mt] + k[Mt] - Yi - M.altAxis : Ui, Ki = g && ni ? Ha(Xi, Ze, Zi) : wt(g ? Xi : Wi, Ze, g ? Zi : Ui);
      y[w] = Ki, D[w] = Ki - Ze;
    }
    t.modifiersData[s] = D;
  }
}
const wo = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: _o,
  requiresIfExists: ["offset"]
};
function bo(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function yo(e) {
  return e === ge(e) || !ye(e) ? Di(e) : bo(e);
}
function Eo(e) {
  var t = e.getBoundingClientRect(), i = ct(t.width) / e.offsetWidth || 1, s = ct(t.height) / e.offsetHeight || 1;
  return i !== 1 || s !== 1;
}
function xo(e, t, i) {
  i === void 0 && (i = !1);
  var s = ye(t), n = ye(t) && Eo(t), r = Xe(t), a = dt(e, n, i), o = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (s || !s && !i) && ((Ie(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Vi(r)) && (o = yo(t)), ye(t) ? (l = dt(t, !0), l.x += t.clientLeft, l.y += t.clientTop) : r && (l.x = zi(r))), {
    x: a.left + o.scrollLeft - l.x,
    y: a.top + o.scrollTop - l.y,
    width: a.width,
    height: a.height
  };
}
function So(e) {
  var t = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Set(), s = [];
  e.forEach(function(r) {
    t.set(r.name, r);
  });
  function n(r) {
    i.add(r.name);
    var a = [].concat(r.requires || [], r.requiresIfExists || []);
    a.forEach(function(o) {
      if (!i.has(o)) {
        var l = t.get(o);
        l && n(l);
      }
    }), s.push(r);
  }
  return e.forEach(function(r) {
    i.has(r.name) || n(r);
  }), s;
}
function To(e) {
  var t = So(e);
  return La.reduce(function(i, s) {
    return i.concat(t.filter(function(n) {
      return n.phase === s;
    }));
  }, []);
}
function Ao(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(i) {
      Promise.resolve().then(function() {
        t = void 0, i(e());
      });
    })), t;
  };
}
function Mo(e) {
  var t = e.reduce(function(i, s) {
    var n = i[s.name];
    return i[s.name] = n ? Object.assign({}, n, s, {
      options: Object.assign({}, n.options, s.options),
      data: Object.assign({}, n.data, s.data)
    }) : s, i;
  }, {});
  return Object.keys(t).map(function(i) {
    return t[i];
  });
}
var fs = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function ps() {
  for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
    t[i] = arguments[i];
  return !t.some(function(s) {
    return !(s && typeof s.getBoundingClientRect == "function");
  });
}
function ko(e) {
  e === void 0 && (e = {});
  var t = e, i = t.defaultModifiers, s = i === void 0 ? [] : i, n = t.defaultOptions, r = n === void 0 ? fs : n;
  return function(o, l, c) {
    c === void 0 && (c = r);
    var d = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, fs, r),
      modifiersData: {},
      elements: {
        reference: o,
        popper: l
      },
      attributes: {},
      styles: {}
    }, u = [], h = !1, g = {
      state: d,
      setOptions: function(x) {
        var f = typeof x == "function" ? x(d.options) : x;
        b(), d.options = Object.assign({}, r, d.options, f), d.scrollParents = {
          reference: tt(o) ? bt(o) : o.contextElement ? bt(o.contextElement) : [],
          popper: bt(l)
        };
        var m = To(Mo([].concat(s, d.options.modifiers)));
        return d.orderedModifiers = m.filter(function(v) {
          return v.enabled;
        }), _(), g.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!h) {
          var x = d.elements, f = x.reference, m = x.popper;
          if (ps(f, m)) {
            d.rects = {
              reference: xo(f, At(m), d.options.strategy === "fixed"),
              popper: Pi(m)
            }, d.reset = !1, d.placement = d.options.placement, d.orderedModifiers.forEach(function(M) {
              return d.modifiersData[M.name] = Object.assign({}, M.data);
            });
            for (var v = 0; v < d.orderedModifiers.length; v++) {
              if (d.reset === !0) {
                d.reset = !1, v = -1;
                continue;
              }
              var w = d.orderedModifiers[v], y = w.fn, S = w.options, k = S === void 0 ? {} : S, O = w.name;
              typeof y == "function" && (d = y({
                state: d,
                options: k,
                name: O,
                instance: g
              }) || d);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Ao(function() {
        return new Promise(function(E) {
          g.forceUpdate(), E(d);
        });
      }),
      destroy: function() {
        b(), h = !0;
      }
    };
    if (!ps(o, l))
      return g;
    g.setOptions(c).then(function(E) {
      !h && c.onFirstUpdate && c.onFirstUpdate(E);
    });
    function _() {
      d.orderedModifiers.forEach(function(E) {
        var x = E.name, f = E.options, m = f === void 0 ? {} : f, v = E.effect;
        if (typeof v == "function") {
          var w = v({
            state: d,
            name: x,
            instance: g,
            options: m
          }), y = function() {
          };
          u.push(w || y);
        }
      });
    }
    function b() {
      u.forEach(function(E) {
        return E();
      }), u = [];
    }
    return g;
  };
}
var Co = [Ka, go, Xa, Va, ho, lo, wo, ja, uo], No = /* @__PURE__ */ ko({
  defaultModifiers: Co
});
function Io(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var li, hs;
function Oo() {
  if (hs) return li;
  hs = 1;
  var e = typeof Element < "u", t = typeof Map == "function", i = typeof Set == "function", s = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
  function n(r, a) {
    if (r === a) return !0;
    if (r && a && typeof r == "object" && typeof a == "object") {
      if (r.constructor !== a.constructor) return !1;
      var o, l, c;
      if (Array.isArray(r)) {
        if (o = r.length, o != a.length) return !1;
        for (l = o; l-- !== 0; )
          if (!n(r[l], a[l])) return !1;
        return !0;
      }
      var d;
      if (t && r instanceof Map && a instanceof Map) {
        if (r.size !== a.size) return !1;
        for (d = r.entries(); !(l = d.next()).done; )
          if (!a.has(l.value[0])) return !1;
        for (d = r.entries(); !(l = d.next()).done; )
          if (!n(l.value[1], a.get(l.value[0]))) return !1;
        return !0;
      }
      if (i && r instanceof Set && a instanceof Set) {
        if (r.size !== a.size) return !1;
        for (d = r.entries(); !(l = d.next()).done; )
          if (!a.has(l.value[0])) return !1;
        return !0;
      }
      if (s && ArrayBuffer.isView(r) && ArrayBuffer.isView(a)) {
        if (o = r.length, o != a.length) return !1;
        for (l = o; l-- !== 0; )
          if (r[l] !== a[l]) return !1;
        return !0;
      }
      if (r.constructor === RegExp) return r.source === a.source && r.flags === a.flags;
      if (r.valueOf !== Object.prototype.valueOf && typeof r.valueOf == "function" && typeof a.valueOf == "function") return r.valueOf() === a.valueOf();
      if (r.toString !== Object.prototype.toString && typeof r.toString == "function" && typeof a.toString == "function") return r.toString() === a.toString();
      if (c = Object.keys(r), o = c.length, o !== Object.keys(a).length) return !1;
      for (l = o; l-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(a, c[l])) return !1;
      if (e && r instanceof Element) return !1;
      for (l = o; l-- !== 0; )
        if (!((c[l] === "_owner" || c[l] === "__v" || c[l] === "__o") && r.$$typeof) && !n(r[c[l]], a[c[l]]))
          return !1;
      return !0;
    }
    return r !== r && a !== a;
  }
  return li = function(a, o) {
    try {
      return n(a, o);
    } catch (l) {
      if ((l.message || "").match(/stack|recursion/i))
        return console.warn("react-fast-compare cannot handle circular refs"), !1;
      throw l;
    }
  }, li;
}
var Ro = Oo();
const Po = /* @__PURE__ */ Io(Ro);
var Lo = [], Do = function(t, i, s) {
  s === void 0 && (s = {});
  var n = T.useRef(null), r = {
    onFirstUpdate: s.onFirstUpdate,
    placement: s.placement || "bottom",
    strategy: s.strategy || "absolute",
    modifiers: s.modifiers || Lo
  }, a = T.useState({
    styles: {
      popper: {
        position: r.strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }), o = a[0], l = a[1], c = T.useMemo(function() {
    return {
      name: "updateState",
      enabled: !0,
      phase: "write",
      fn: function(g) {
        var _ = g.state, b = Object.keys(_.elements);
        En.flushSync(function() {
          l({
            styles: ss(b.map(function(E) {
              return [E, _.styles[E] || {}];
            })),
            attributes: ss(b.map(function(E) {
              return [E, _.attributes[E]];
            }))
          });
        });
      },
      requires: ["computeStyles"]
    };
  }, []), d = T.useMemo(function() {
    var h = {
      onFirstUpdate: r.onFirstUpdate,
      placement: r.placement,
      strategy: r.strategy,
      modifiers: [].concat(r.modifiers, [c, {
        name: "applyStyles",
        enabled: !1
      }])
    };
    return Po(n.current, h) ? n.current || h : (n.current = h, h);
  }, [r.onFirstUpdate, r.placement, r.strategy, r.modifiers, c]), u = T.useRef();
  return ns(function() {
    u.current && u.current.setOptions(d);
  }, [d]), ns(function() {
    if (!(t == null || i == null)) {
      var h = s.createPopper || No, g = h(t, i, d);
      return u.current = g, function() {
        g.destroy(), u.current = null;
      };
    }
  }, [t, i, s.createPopper]), {
    state: u.current ? u.current.state : null,
    styles: o.styles,
    attributes: o.attributes,
    update: u.current ? u.current.update : null,
    forceUpdate: u.current ? u.current.forceUpdate : null
  };
};
const Bi = (e) => {
  F(() => {
    const t = (i) => {
      i.key === "Escape" && e(null);
    };
    return window.addEventListener("keydown", t), () => {
      window.removeEventListener("keydown", t);
    };
  }, [e]);
}, zo = 20, Vo = 18, Bo = ({ children: e, height: t = Vo, ariaLabel: i }) => {
  const [s, n] = V(!1), [r, a] = V(null), [o, l] = V(null), [c, d] = V(null);
  Bi(n);
  const {
    styles: u,
    attributes: h,
    update: g
  } = Do(r, o, {
    placement: "bottom",
    modifiers: [
      { name: "arrow", options: { element: c } },
      { name: "offset", options: { offset: [0, zo] } }
    ]
  }), _ = () => {
    n(!s), setTimeout(() => {
      g == null || g();
    }, 0);
  }, b = () => {
    n(!0), setTimeout(() => {
      g == null || g();
    }, 0);
  }, E = () => {
    n(!1);
  };
  return /* @__PURE__ */ I("div", { className: Qe.tooltip, children: [
    /* @__PURE__ */ p(
      "button",
      {
        ref: a,
        type: "button",
        className: L(Qe.tooltip__icon, s && Qe["tooltip__icon--active"]),
        "aria-label": i,
        onClick: _,
        onMouseEnter: b,
        onMouseLeave: E,
        onBlur: () => n(!1),
        children: /* @__PURE__ */ p(q, { icon: "info", height: `${Ue(t)}rem` })
      }
    ),
    /* @__PURE__ */ I(
      "div",
      {
        role: "status",
        ref: l,
        style: u.popper,
        ...h.popper,
        className: L(Qe.tooltip__content, s && Qe["tooltip__content--open"]),
        children: [
          /* @__PURE__ */ p("div", { className: Qe.tooltip__text, children: e }),
          /* @__PURE__ */ p("div", { ref: d, style: u.arrow, className: Qe.tooltip__arrow })
        ]
      }
    )
  ] });
}, yp = ({
  id: e,
  name: t,
  label: i,
  tooltip: s,
  tooltipAriaLabel: n,
  options: r,
  value: a,
  placeholder: o,
  error: l,
  hasError: c = !1,
  required: d = !1,
  disabled: u = !1,
  slot: h,
  onChange: g,
  onBlur: _
}) => {
  const b = `${e}-error`, E = (w) => {
    g && g(w.target.value);
  }, x = (w) => {
    w.key === "Enter" && w.currentTarget.click();
  }, f = L(
    Se["roche-dropdown"],
    u && [Se["roche-dropdown--disabled"]],
    (l || c) && [Se["roche-dropdown--error"]]
  ), m = L(
    Se["roche-dropdown__select"],
    !a && o && [Se["roche-dropdown__select--placeholder"]]
  ), v = !!(l || c);
  return /* @__PURE__ */ I("div", { className: f, slot: h, children: [
    i && /* @__PURE__ */ I("div", { className: Se["roche-dropdown__label-wrapper"], children: [
      /* @__PURE__ */ p("label", { htmlFor: e, className: Se["roche-dropdown__label"], children: i }),
      s && /* @__PURE__ */ p(Bo, { ariaLabel: n, children: s })
    ] }),
    /* @__PURE__ */ I("div", { className: Se["roche-dropdown__container"], children: [
      /* @__PURE__ */ I(
        "select",
        {
          id: e,
          name: t,
          value: a || "",
          required: d,
          disabled: u,
          onChange: E,
          onBlur: _,
          onKeyDown: x,
          className: m,
          "aria-invalid": v,
          "aria-describedby": v ? b : void 0,
          children: [
            /* @__PURE__ */ p("option", { value: "", disabled: !0, children: o }),
            r.map((w) => /* @__PURE__ */ p("option", { value: w.value, children: w.label }, w.value))
          ]
        }
      ),
      /* @__PURE__ */ p("div", { className: Se["roche-dropdown__icon"], children: /* @__PURE__ */ p(q, { icon: "chevron-down", width: "16px", decorative: !0 }) })
    ] }),
    /* @__PURE__ */ p("div", { className: Se["roche-dropdown__error"], children: l && /* @__PURE__ */ I(Ht, { children: [
      /* @__PURE__ */ p(q, { icon: "info", width: "16px", decorative: !0 }),
      /* @__PURE__ */ p("p", { id: b, role: "alert", className: Se["roche-dropdown__error-text"], children: l })
    ] }) })
  ] });
}, ms = (e) => {
  let t = e.toLowerCase();
  return t = t.normalize("NFD").replace(/[\u0300-\u036f]/g, ""), t = t.replace(/[^a-z0-9\s-]/g, ""), t = t.replace(/\s+/g, "-"), t = t.replace(/^-+|-+$/g, ""), t.match(/^\d/) && (t = "_" + t), t;
}, $o = "column", Ho = "columns", Fo = "grid", Go = "grid__column", qo = "teaser", jo = "grid__columns", Wo = "image", Uo = "headline", _e = {
  column: $o,
  columns: Ho,
  "is-mobile": "is-mobile",
  "is-narrow": "is-narrow",
  "is-full": "is-full",
  "is-three-quarters": "is-three-quarters",
  "is-two-thirds": "is-two-thirds",
  "is-half": "is-half",
  "is-one-third": "is-one-third",
  "is-one-quarter": "is-one-quarter",
  "is-one-fifth": "is-one-fifth",
  "is-two-fifths": "is-two-fifths",
  "is-three-fifths": "is-three-fifths",
  "is-four-fifths": "is-four-fifths",
  "is-offset-three-quarters": "is-offset-three-quarters",
  "is-offset-two-thirds": "is-offset-two-thirds",
  "is-offset-half": "is-offset-half",
  "is-offset-one-third": "is-offset-one-third",
  "is-offset-one-quarter": "is-offset-one-quarter",
  "is-offset-one-fifth": "is-offset-one-fifth",
  "is-offset-two-fifths": "is-offset-two-fifths",
  "is-offset-three-fifths": "is-offset-three-fifths",
  "is-offset-four-fifths": "is-offset-four-fifths",
  "is-0": "is-0",
  "is-offset-0": "is-offset-0",
  "is-1": "is-1",
  "is-offset-1": "is-offset-1",
  "is-2": "is-2",
  "is-offset-2": "is-offset-2",
  "is-3": "is-3",
  "is-offset-3": "is-offset-3",
  "is-4": "is-4",
  "is-offset-4": "is-offset-4",
  "is-5": "is-5",
  "is-offset-5": "is-offset-5",
  "is-6": "is-6",
  "is-offset-6": "is-offset-6",
  "is-7": "is-7",
  "is-offset-7": "is-offset-7",
  "is-8": "is-8",
  "is-offset-8": "is-offset-8",
  "is-9": "is-9",
  "is-offset-9": "is-offset-9",
  "is-10": "is-10",
  "is-offset-10": "is-offset-10",
  "is-11": "is-11",
  "is-offset-11": "is-offset-11",
  "is-12": "is-12",
  "is-offset-12": "is-offset-12",
  "is-narrow-mobile": "is-narrow-mobile",
  "is-full-mobile": "is-full-mobile",
  "is-three-quarters-mobile": "is-three-quarters-mobile",
  "is-two-thirds-mobile": "is-two-thirds-mobile",
  "is-half-mobile": "is-half-mobile",
  "is-one-third-mobile": "is-one-third-mobile",
  "is-one-quarter-mobile": "is-one-quarter-mobile",
  "is-one-fifth-mobile": "is-one-fifth-mobile",
  "is-two-fifths-mobile": "is-two-fifths-mobile",
  "is-three-fifths-mobile": "is-three-fifths-mobile",
  "is-four-fifths-mobile": "is-four-fifths-mobile",
  "is-offset-three-quarters-mobile": "is-offset-three-quarters-mobile",
  "is-offset-two-thirds-mobile": "is-offset-two-thirds-mobile",
  "is-offset-half-mobile": "is-offset-half-mobile",
  "is-offset-one-third-mobile": "is-offset-one-third-mobile",
  "is-offset-one-quarter-mobile": "is-offset-one-quarter-mobile",
  "is-offset-one-fifth-mobile": "is-offset-one-fifth-mobile",
  "is-offset-two-fifths-mobile": "is-offset-two-fifths-mobile",
  "is-offset-three-fifths-mobile": "is-offset-three-fifths-mobile",
  "is-offset-four-fifths-mobile": "is-offset-four-fifths-mobile",
  "is-0-mobile": "is-0-mobile",
  "is-offset-0-mobile": "is-offset-0-mobile",
  "is-1-mobile": "is-1-mobile",
  "is-offset-1-mobile": "is-offset-1-mobile",
  "is-2-mobile": "is-2-mobile",
  "is-offset-2-mobile": "is-offset-2-mobile",
  "is-3-mobile": "is-3-mobile",
  "is-offset-3-mobile": "is-offset-3-mobile",
  "is-4-mobile": "is-4-mobile",
  "is-offset-4-mobile": "is-offset-4-mobile",
  "is-5-mobile": "is-5-mobile",
  "is-offset-5-mobile": "is-offset-5-mobile",
  "is-6-mobile": "is-6-mobile",
  "is-offset-6-mobile": "is-offset-6-mobile",
  "is-7-mobile": "is-7-mobile",
  "is-offset-7-mobile": "is-offset-7-mobile",
  "is-8-mobile": "is-8-mobile",
  "is-offset-8-mobile": "is-offset-8-mobile",
  "is-9-mobile": "is-9-mobile",
  "is-offset-9-mobile": "is-offset-9-mobile",
  "is-10-mobile": "is-10-mobile",
  "is-offset-10-mobile": "is-offset-10-mobile",
  "is-11-mobile": "is-11-mobile",
  "is-offset-11-mobile": "is-offset-11-mobile",
  "is-12-mobile": "is-12-mobile",
  "is-offset-12-mobile": "is-offset-12-mobile",
  "is-narrow-tablet": "is-narrow-tablet",
  "is-full-tablet": "is-full-tablet",
  "is-three-quarters-tablet": "is-three-quarters-tablet",
  "is-two-thirds-tablet": "is-two-thirds-tablet",
  "is-half-tablet": "is-half-tablet",
  "is-one-third-tablet": "is-one-third-tablet",
  "is-one-quarter-tablet": "is-one-quarter-tablet",
  "is-one-fifth-tablet": "is-one-fifth-tablet",
  "is-two-fifths-tablet": "is-two-fifths-tablet",
  "is-three-fifths-tablet": "is-three-fifths-tablet",
  "is-four-fifths-tablet": "is-four-fifths-tablet",
  "is-offset-three-quarters-tablet": "is-offset-three-quarters-tablet",
  "is-offset-two-thirds-tablet": "is-offset-two-thirds-tablet",
  "is-offset-half-tablet": "is-offset-half-tablet",
  "is-offset-one-third-tablet": "is-offset-one-third-tablet",
  "is-offset-one-quarter-tablet": "is-offset-one-quarter-tablet",
  "is-offset-one-fifth-tablet": "is-offset-one-fifth-tablet",
  "is-offset-two-fifths-tablet": "is-offset-two-fifths-tablet",
  "is-offset-three-fifths-tablet": "is-offset-three-fifths-tablet",
  "is-offset-four-fifths-tablet": "is-offset-four-fifths-tablet",
  "is-0-tablet": "is-0-tablet",
  "is-offset-0-tablet": "is-offset-0-tablet",
  "is-1-tablet": "is-1-tablet",
  "is-offset-1-tablet": "is-offset-1-tablet",
  "is-2-tablet": "is-2-tablet",
  "is-offset-2-tablet": "is-offset-2-tablet",
  "is-3-tablet": "is-3-tablet",
  "is-offset-3-tablet": "is-offset-3-tablet",
  "is-4-tablet": "is-4-tablet",
  "is-offset-4-tablet": "is-offset-4-tablet",
  "is-5-tablet": "is-5-tablet",
  "is-offset-5-tablet": "is-offset-5-tablet",
  "is-6-tablet": "is-6-tablet",
  "is-offset-6-tablet": "is-offset-6-tablet",
  "is-7-tablet": "is-7-tablet",
  "is-offset-7-tablet": "is-offset-7-tablet",
  "is-8-tablet": "is-8-tablet",
  "is-offset-8-tablet": "is-offset-8-tablet",
  "is-9-tablet": "is-9-tablet",
  "is-offset-9-tablet": "is-offset-9-tablet",
  "is-10-tablet": "is-10-tablet",
  "is-offset-10-tablet": "is-offset-10-tablet",
  "is-11-tablet": "is-11-tablet",
  "is-offset-11-tablet": "is-offset-11-tablet",
  "is-12-tablet": "is-12-tablet",
  "is-offset-12-tablet": "is-offset-12-tablet",
  "is-narrow-touch": "is-narrow-touch",
  "is-full-touch": "is-full-touch",
  "is-three-quarters-touch": "is-three-quarters-touch",
  "is-two-thirds-touch": "is-two-thirds-touch",
  "is-half-touch": "is-half-touch",
  "is-one-third-touch": "is-one-third-touch",
  "is-one-quarter-touch": "is-one-quarter-touch",
  "is-one-fifth-touch": "is-one-fifth-touch",
  "is-two-fifths-touch": "is-two-fifths-touch",
  "is-three-fifths-touch": "is-three-fifths-touch",
  "is-four-fifths-touch": "is-four-fifths-touch",
  "is-offset-three-quarters-touch": "is-offset-three-quarters-touch",
  "is-offset-two-thirds-touch": "is-offset-two-thirds-touch",
  "is-offset-half-touch": "is-offset-half-touch",
  "is-offset-one-third-touch": "is-offset-one-third-touch",
  "is-offset-one-quarter-touch": "is-offset-one-quarter-touch",
  "is-offset-one-fifth-touch": "is-offset-one-fifth-touch",
  "is-offset-two-fifths-touch": "is-offset-two-fifths-touch",
  "is-offset-three-fifths-touch": "is-offset-three-fifths-touch",
  "is-offset-four-fifths-touch": "is-offset-four-fifths-touch",
  "is-0-touch": "is-0-touch",
  "is-offset-0-touch": "is-offset-0-touch",
  "is-1-touch": "is-1-touch",
  "is-offset-1-touch": "is-offset-1-touch",
  "is-2-touch": "is-2-touch",
  "is-offset-2-touch": "is-offset-2-touch",
  "is-3-touch": "is-3-touch",
  "is-offset-3-touch": "is-offset-3-touch",
  "is-4-touch": "is-4-touch",
  "is-offset-4-touch": "is-offset-4-touch",
  "is-5-touch": "is-5-touch",
  "is-offset-5-touch": "is-offset-5-touch",
  "is-6-touch": "is-6-touch",
  "is-offset-6-touch": "is-offset-6-touch",
  "is-7-touch": "is-7-touch",
  "is-offset-7-touch": "is-offset-7-touch",
  "is-8-touch": "is-8-touch",
  "is-offset-8-touch": "is-offset-8-touch",
  "is-9-touch": "is-9-touch",
  "is-offset-9-touch": "is-offset-9-touch",
  "is-10-touch": "is-10-touch",
  "is-offset-10-touch": "is-offset-10-touch",
  "is-11-touch": "is-11-touch",
  "is-offset-11-touch": "is-offset-11-touch",
  "is-12-touch": "is-12-touch",
  "is-offset-12-touch": "is-offset-12-touch",
  "is-narrow-desktop": "is-narrow-desktop",
  "is-full-desktop": "is-full-desktop",
  "is-three-quarters-desktop": "is-three-quarters-desktop",
  "is-two-thirds-desktop": "is-two-thirds-desktop",
  "is-half-desktop": "is-half-desktop",
  "is-one-third-desktop": "is-one-third-desktop",
  "is-one-quarter-desktop": "is-one-quarter-desktop",
  "is-one-fifth-desktop": "is-one-fifth-desktop",
  "is-two-fifths-desktop": "is-two-fifths-desktop",
  "is-three-fifths-desktop": "is-three-fifths-desktop",
  "is-four-fifths-desktop": "is-four-fifths-desktop",
  "is-offset-three-quarters-desktop": "is-offset-three-quarters-desktop",
  "is-offset-two-thirds-desktop": "is-offset-two-thirds-desktop",
  "is-offset-half-desktop": "is-offset-half-desktop",
  "is-offset-one-third-desktop": "is-offset-one-third-desktop",
  "is-offset-one-quarter-desktop": "is-offset-one-quarter-desktop",
  "is-offset-one-fifth-desktop": "is-offset-one-fifth-desktop",
  "is-offset-two-fifths-desktop": "is-offset-two-fifths-desktop",
  "is-offset-three-fifths-desktop": "is-offset-three-fifths-desktop",
  "is-offset-four-fifths-desktop": "is-offset-four-fifths-desktop",
  "is-0-desktop": "is-0-desktop",
  "is-offset-0-desktop": "is-offset-0-desktop",
  "is-1-desktop": "is-1-desktop",
  "is-offset-1-desktop": "is-offset-1-desktop",
  "is-2-desktop": "is-2-desktop",
  "is-offset-2-desktop": "is-offset-2-desktop",
  "is-3-desktop": "is-3-desktop",
  "is-offset-3-desktop": "is-offset-3-desktop",
  "is-4-desktop": "is-4-desktop",
  "is-offset-4-desktop": "is-offset-4-desktop",
  "is-5-desktop": "is-5-desktop",
  "is-offset-5-desktop": "is-offset-5-desktop",
  "is-6-desktop": "is-6-desktop",
  "is-offset-6-desktop": "is-offset-6-desktop",
  "is-7-desktop": "is-7-desktop",
  "is-offset-7-desktop": "is-offset-7-desktop",
  "is-8-desktop": "is-8-desktop",
  "is-offset-8-desktop": "is-offset-8-desktop",
  "is-9-desktop": "is-9-desktop",
  "is-offset-9-desktop": "is-offset-9-desktop",
  "is-10-desktop": "is-10-desktop",
  "is-offset-10-desktop": "is-offset-10-desktop",
  "is-11-desktop": "is-11-desktop",
  "is-offset-11-desktop": "is-offset-11-desktop",
  "is-12-desktop": "is-12-desktop",
  "is-offset-12-desktop": "is-offset-12-desktop",
  "is-narrow-widescreen": "is-narrow-widescreen",
  "is-full-widescreen": "is-full-widescreen",
  "is-three-quarters-widescreen": "is-three-quarters-widescreen",
  "is-two-thirds-widescreen": "is-two-thirds-widescreen",
  "is-half-widescreen": "is-half-widescreen",
  "is-one-third-widescreen": "is-one-third-widescreen",
  "is-one-quarter-widescreen": "is-one-quarter-widescreen",
  "is-one-fifth-widescreen": "is-one-fifth-widescreen",
  "is-two-fifths-widescreen": "is-two-fifths-widescreen",
  "is-three-fifths-widescreen": "is-three-fifths-widescreen",
  "is-four-fifths-widescreen": "is-four-fifths-widescreen",
  "is-offset-three-quarters-widescreen": "is-offset-three-quarters-widescreen",
  "is-offset-two-thirds-widescreen": "is-offset-two-thirds-widescreen",
  "is-offset-half-widescreen": "is-offset-half-widescreen",
  "is-offset-one-third-widescreen": "is-offset-one-third-widescreen",
  "is-offset-one-quarter-widescreen": "is-offset-one-quarter-widescreen",
  "is-offset-one-fifth-widescreen": "is-offset-one-fifth-widescreen",
  "is-offset-two-fifths-widescreen": "is-offset-two-fifths-widescreen",
  "is-offset-three-fifths-widescreen": "is-offset-three-fifths-widescreen",
  "is-offset-four-fifths-widescreen": "is-offset-four-fifths-widescreen",
  "is-0-widescreen": "is-0-widescreen",
  "is-offset-0-widescreen": "is-offset-0-widescreen",
  "is-1-widescreen": "is-1-widescreen",
  "is-offset-1-widescreen": "is-offset-1-widescreen",
  "is-2-widescreen": "is-2-widescreen",
  "is-offset-2-widescreen": "is-offset-2-widescreen",
  "is-3-widescreen": "is-3-widescreen",
  "is-offset-3-widescreen": "is-offset-3-widescreen",
  "is-4-widescreen": "is-4-widescreen",
  "is-offset-4-widescreen": "is-offset-4-widescreen",
  "is-5-widescreen": "is-5-widescreen",
  "is-offset-5-widescreen": "is-offset-5-widescreen",
  "is-6-widescreen": "is-6-widescreen",
  "is-offset-6-widescreen": "is-offset-6-widescreen",
  "is-7-widescreen": "is-7-widescreen",
  "is-offset-7-widescreen": "is-offset-7-widescreen",
  "is-8-widescreen": "is-8-widescreen",
  "is-offset-8-widescreen": "is-offset-8-widescreen",
  "is-9-widescreen": "is-9-widescreen",
  "is-offset-9-widescreen": "is-offset-9-widescreen",
  "is-10-widescreen": "is-10-widescreen",
  "is-offset-10-widescreen": "is-offset-10-widescreen",
  "is-11-widescreen": "is-11-widescreen",
  "is-offset-11-widescreen": "is-offset-11-widescreen",
  "is-12-widescreen": "is-12-widescreen",
  "is-offset-12-widescreen": "is-offset-12-widescreen",
  "is-narrow-fullhd": "is-narrow-fullhd",
  "is-full-fullhd": "is-full-fullhd",
  "is-three-quarters-fullhd": "is-three-quarters-fullhd",
  "is-two-thirds-fullhd": "is-two-thirds-fullhd",
  "is-half-fullhd": "is-half-fullhd",
  "is-one-third-fullhd": "is-one-third-fullhd",
  "is-one-quarter-fullhd": "is-one-quarter-fullhd",
  "is-one-fifth-fullhd": "is-one-fifth-fullhd",
  "is-two-fifths-fullhd": "is-two-fifths-fullhd",
  "is-three-fifths-fullhd": "is-three-fifths-fullhd",
  "is-four-fifths-fullhd": "is-four-fifths-fullhd",
  "is-offset-three-quarters-fullhd": "is-offset-three-quarters-fullhd",
  "is-offset-two-thirds-fullhd": "is-offset-two-thirds-fullhd",
  "is-offset-half-fullhd": "is-offset-half-fullhd",
  "is-offset-one-third-fullhd": "is-offset-one-third-fullhd",
  "is-offset-one-quarter-fullhd": "is-offset-one-quarter-fullhd",
  "is-offset-one-fifth-fullhd": "is-offset-one-fifth-fullhd",
  "is-offset-two-fifths-fullhd": "is-offset-two-fifths-fullhd",
  "is-offset-three-fifths-fullhd": "is-offset-three-fifths-fullhd",
  "is-offset-four-fifths-fullhd": "is-offset-four-fifths-fullhd",
  "is-0-fullhd": "is-0-fullhd",
  "is-offset-0-fullhd": "is-offset-0-fullhd",
  "is-1-fullhd": "is-1-fullhd",
  "is-offset-1-fullhd": "is-offset-1-fullhd",
  "is-2-fullhd": "is-2-fullhd",
  "is-offset-2-fullhd": "is-offset-2-fullhd",
  "is-3-fullhd": "is-3-fullhd",
  "is-offset-3-fullhd": "is-offset-3-fullhd",
  "is-4-fullhd": "is-4-fullhd",
  "is-offset-4-fullhd": "is-offset-4-fullhd",
  "is-5-fullhd": "is-5-fullhd",
  "is-offset-5-fullhd": "is-offset-5-fullhd",
  "is-6-fullhd": "is-6-fullhd",
  "is-offset-6-fullhd": "is-offset-6-fullhd",
  "is-7-fullhd": "is-7-fullhd",
  "is-offset-7-fullhd": "is-offset-7-fullhd",
  "is-8-fullhd": "is-8-fullhd",
  "is-offset-8-fullhd": "is-offset-8-fullhd",
  "is-9-fullhd": "is-9-fullhd",
  "is-offset-9-fullhd": "is-offset-9-fullhd",
  "is-10-fullhd": "is-10-fullhd",
  "is-offset-10-fullhd": "is-offset-10-fullhd",
  "is-11-fullhd": "is-11-fullhd",
  "is-offset-11-fullhd": "is-offset-11-fullhd",
  "is-12-fullhd": "is-12-fullhd",
  "is-offset-12-fullhd": "is-offset-12-fullhd",
  "is-centered": "is-centered",
  "is-gapless": "is-gapless",
  "is-multiline": "is-multiline",
  "is-vcentered": "is-vcentered",
  "is-desktop": "is-desktop",
  "is-0-tablet-only": "is-0-tablet-only",
  "is-0-desktop-only": "is-0-desktop-only",
  "is-0-widescreen-only": "is-0-widescreen-only",
  "is-1-tablet-only": "is-1-tablet-only",
  "is-1-desktop-only": "is-1-desktop-only",
  "is-1-widescreen-only": "is-1-widescreen-only",
  "is-2-tablet-only": "is-2-tablet-only",
  "is-2-desktop-only": "is-2-desktop-only",
  "is-2-widescreen-only": "is-2-widescreen-only",
  "is-3-tablet-only": "is-3-tablet-only",
  "is-3-desktop-only": "is-3-desktop-only",
  "is-3-widescreen-only": "is-3-widescreen-only",
  "is-4-tablet-only": "is-4-tablet-only",
  "is-4-desktop-only": "is-4-desktop-only",
  "is-4-widescreen-only": "is-4-widescreen-only",
  "is-5-tablet-only": "is-5-tablet-only",
  "is-5-desktop-only": "is-5-desktop-only",
  "is-5-widescreen-only": "is-5-widescreen-only",
  "is-6-tablet-only": "is-6-tablet-only",
  "is-6-desktop-only": "is-6-desktop-only",
  "is-6-widescreen-only": "is-6-widescreen-only",
  "is-7-tablet-only": "is-7-tablet-only",
  "is-7-desktop-only": "is-7-desktop-only",
  "is-7-widescreen-only": "is-7-widescreen-only",
  "is-8-tablet-only": "is-8-tablet-only",
  "is-8-desktop-only": "is-8-desktop-only",
  "is-8-widescreen-only": "is-8-widescreen-only",
  grid: Fo,
  "grid--hide-in-print-view": "grid--hide-in-print-view",
  "grid--no-padding": "grid--no-padding",
  "grid--extend-background-to-top": "grid--extend-background-to-top",
  "grid--has-breadcrumbs": "grid--has-breadcrumbs",
  "grid--has-staging-hero": "grid--has-staging-hero",
  "grid--move-to-back": "grid--move-to-back",
  "grid--overflow-visible": "grid--overflow-visible",
  "grid--equal-columns": "grid--equal-columns",
  grid__column: Go,
  teaser: qo,
  grid__columns: jo,
  "is-variable": "is-variable",
  "grid__columns--multiple-rows": "grid__columns--multiple-rows",
  "contact-person": "contact-person",
  image: Wo,
  headline: Uo,
  "headline--1": "headline--1",
  "headline--2": "headline--2",
  "headline--3": "headline--3",
  "headline--4": "headline--4",
  "headline--5": "headline--5",
  "headline--6": "headline--6",
  "disable-rtl": "disable-rtl"
}, Yo = {
  "roche-grid-1-4-1-6": "1-4-1-6",
  "roche-grid-12": "12",
  "roche-grid-3-1-5-3": "3-1-5-3",
  "roche-grid-3-1-8": "3-1-8",
  "roche-grid-3-3-3-3": "3-3-3-3",
  "roche-grid-4-4-4": "4-4-4",
  "roche-grid-4-8": "4-8",
  "roche-grid-5-1-6": "5-1-6",
  "roche-grid-5-7": "5-7",
  "roche-grid-6-1-4-1": "6-1-4-1",
  "roche-grid-6-6": "6-6",
  "roche-grid-7-5": "7-5",
  "roche-grid-8-4": "8-4",
  "roche-grid-8": "8",
  "roche-grid-6": "6",
  "roche-grid-6-1-5": "6-1-5",
  "roche-grid-8-1-3": "8-1-3",
  "roche-grid-7-1-4": "7-1-4"
}, Xo = {
  1: ["full"],
  2: ["left", "right"],
  3: ["left", "center", "right"],
  4: ["left", "center-left", "center-right", "right"]
}, Us = (e, t, i) => ({
  span: parseInt(e, 10),
  slotName: Xo[i.length][t]
}), Zo = (e) => e.split("-").map(Us), Ko = (e) => e.split("-").reverse().map(Us), gs = (e) => e === "roche-staging-hero", vs = (e) => e === "roche-story-staging-hero", Qo = (e) => e === "roche-stage-home", Jo = (e) => e.type === ga || e.type === "roche-breadcrumbs", el = (e) => e === "hero--variant-b", mt = ({
  layout: e,
  fullWidth: t,
  backgroundColor: i,
  hideInPrintView: s,
  isRightToLeft: n,
  noPadding: r,
  fullHeight: a,
  stagingHero: o,
  multipleRows: l,
  overflowVisible: c,
  children: d
}) => {
  const u = Yo[e] || e, h = "columns is-centered is-variable is-0-mobile is-3-tablet is-4-desktop", g = ri.toArray(d), _ = g.some((w) => ft(w) && Jo(w)), b = g.some(
    (w) => {
      var y;
      return ft(w) && Qo((y = w.props.blok) == null ? void 0 : y.component);
    }
  ), E = g.some(
    (w) => {
      var y, S;
      return ft(w) && (gs((y = w.props.blok) == null ? void 0 : y.component) || vs((S = w.props.blok) == null ? void 0 : S.component));
    }
  ), x = g.some(
    (w) => {
      var y, S, k;
      return ft(w) && (gs((y = w.props.blok) == null ? void 0 : y.component) || vs((S = w.props.blok) == null ? void 0 : S.component)) && el((k = w.props.blok) == null ? void 0 : k.variant) || o;
    }
  ), f = (w) => {
    const y = w.split("-");
    return y.every((S) => S === y[0]);
  }, m = L(
    _e.grid,
    b && _e["grid--extend-background-to-top"],
    s && _e["grid--hide-in-print-view"],
    (r || E || b) && _e["grid--no-padding"],
    c && _e["grid--overflow-visible"],
    _ && _e["grid--has-breadcrumbs"],
    (E || o) && _e["grid--has-staging-hero"],
    x && _e["grid--move-to-back"],
    f(u) && _e["grid--equal-columns"]
  );
  if (!ri)
    return null;
  const v = n ? Ko(u).reverse() : Zo(u);
  return /* @__PURE__ */ p("div", { className: m, children: /* @__PURE__ */ p(
    _a,
    {
      fullWidth: t,
      color: i,
      fullHeight: a,
      extendBackgroundToTop: b,
      children: /* @__PURE__ */ p(
        "div",
        {
          className: `${L(
            _e.grid__columns,
            h,
            l && _e["grid__columns--multiple-rows"]
          )}`,
          children: v.map(({ span: w, slotName: y }, S) => /* @__PURE__ */ p("div", { className: `${_e.grid__column} column is-${w} is-offset-0`, children: ri.map(d, (k) => {
            if (ft(k) && k.props.slot === y)
              return k;
          }) }, S))
        }
      )
    }
  ) });
}, tl = "footer", il = "grid", sl = "footer__copyright", nl = "grid__column", se = {
  footer: tl,
  "footer__first-row": "footer__first-row",
  grid: il,
  "footer__columns-container": "footer__columns-container",
  "footer__second-row": "footer__second-row",
  "footer__third-row": "footer__third-row",
  "footer__quick-links": "footer__quick-links",
  "footer__column-title": "footer__column-title",
  "footer__stock-price": "footer__stock-price",
  "footer__quick-links-nav": "footer__quick-links-nav",
  "footer__social-links-nav": "footer__social-links-nav",
  footer__copyright: sl,
  "footer__social-links": "footer__social-links",
  "footer__service-links": "footer__service-links",
  "footer__legal-text": "footer__legal-text",
  "footer--with-extra-columns": "footer--with-extra-columns",
  "is-3": "is-3",
  "is-8": "is-8",
  grid__column: nl,
  "is-1": "is-1",
  "is-3-tablet": "is-3-tablet",
  "is-4-desktop": "is-4-desktop",
  "is-4": "is-4"
}, rl = 3, al = (e, t, i) => i && t ? e === 0 ? "right" : e === 1 ? "center" : "left" : t && !i ? e === 0 ? "left" : e === 1 ? "center" : "right" : i ? e === 0 ? "right" : "left" : e === 0 ? "left" : "right", Ep = ({
  quickLinksTitle: e,
  quickLinks: t,
  footerColumns: i,
  stockPrice: s,
  socialLinksTitle: n,
  socialLinks: r,
  serviceLinksTitle: a,
  serviceLinks: o,
  year: l,
  date: c,
  copyright: d,
  text: u,
  isRightToLeft: h
}) => {
  const _ = !!((i == null ? void 0 : i.length) === rl && s) ? i == null ? void 0 : i.slice(0, 2) : i == null ? void 0 : i.slice(0, 3), b = (_ == null ? void 0 : _.length) === 1, E = !!(((_ == null ? void 0 : _.length) || 0) > 1 && s || ((_ == null ? void 0 : _.length) || 0) > 2), x = b ? "8-4" : E ? "4-4-4" : "6-6";
  return /* @__PURE__ */ p("footer", { className: L(se.footer, E && se["footer--with-extra-columns"]), children: /* @__PURE__ */ I(mt, { layout: "12", noPadding: !0, children: [
    /* @__PURE__ */ p("div", { className: se["footer__first-row"], slot: "full", children: /* @__PURE__ */ I(mt, { layout: "3-1-8", fullWidth: !0, isRightToLeft: h, children: [
      /* @__PURE__ */ p(
        "nav",
        {
          className: se["footer__quick-links-nav"],
          "aria-label": e,
          slot: h ? "right" : "left",
          children: /* @__PURE__ */ p("ul", { className: se["footer__quick-links"], children: t })
        }
      ),
      /* @__PURE__ */ p("div", { slot: "center" }),
      /* @__PURE__ */ p("div", { className: se["footer__columns-container"], slot: h ? "left" : "right", children: /* @__PURE__ */ I(mt, { layout: x, fullWidth: !0, isRightToLeft: h, children: [
        _ == null ? void 0 : _.map((f, m) => /* @__PURE__ */ I(
          "nav",
          {
            "aria-labelledby": ms(f.columnTitle),
            slot: al(m, E, h),
            children: [
              /* @__PURE__ */ p("h3", { className: se["footer__column-title"], id: ms(f.columnTitle), children: f.columnTitle }),
              /* @__PURE__ */ p("ul", { className: se["footer__column-links"], children: f.links })
            ]
          },
          m
        )),
        s && /* @__PURE__ */ p("div", { className: se["footer__stock-price"], slot: "right", children: s })
      ] }) })
    ] }) }),
    /* @__PURE__ */ p("div", { className: se["footer__second-row"], slot: "full", children: /* @__PURE__ */ I(mt, { layout: "4-8", fullWidth: !0, isRightToLeft: h, children: [
      /* @__PURE__ */ p(
        "nav",
        {
          className: se["footer__social-links-nav"],
          "aria-label": n,
          slot: h ? "right" : "left",
          children: /* @__PURE__ */ p("ul", { className: se["footer__social-links"], children: r })
        }
      ),
      /* @__PURE__ */ p("nav", { "aria-label": a, slot: h ? "left" : "right", children: /* @__PURE__ */ p("ul", { className: se["footer__service-links"], children: o }) })
    ] }) }),
    /* @__PURE__ */ p("div", { className: se["footer__third-row"], slot: "full", children: /* @__PURE__ */ I(mt, { layout: "4-8", fullWidth: !0, isRightToLeft: h, children: [
      /* @__PURE__ */ I("div", { className: se.footer__copyright, slot: h ? "right" : "left", children: [
        "© ",
        /* @__PURE__ */ p("time", { children: l }),
        "  ",
        d,
        "  ",
        /* @__PURE__ */ p("time", { children: c })
      ] }),
      /* @__PURE__ */ p("div", { className: se["footer__legal-text"], slot: h ? "left" : "right", children: u })
    ] }) })
  ] }) });
}, Ys = () => {
  const [e, t] = V(typeof window < "u" ? window.scrollY : 0);
  return yn(() => {
    if (typeof window > "u") return;
    const i = () => {
      t(window.scrollY);
    };
    return window.addEventListener("scroll", i), () => {
      window.removeEventListener("scroll", i);
    };
  }, []), e;
}, ol = () => {
  const e = Ys(), [t, i] = V(null), [s, n] = V(e);
  return F(() => {
    e > s ? i("down") : e < s && i("up"), n(e);
  }, [e, s]), t;
}, ll = (e) => {
  F(() => {
    const { body: t } = document;
    return e ? (t.style.overflow = "hidden", t.style.position = "relative") : (t.style.overflow = "", t.style.position = ""), () => {
      t.style.overflow = "", t.style.position = "";
    };
  }, [e]);
}, Xs = (e, t, i) => {
  const s = ke(
    (n) => {
      t && e.current && !e.current.contains(n.target) && i();
    },
    [e, t, i]
  );
  F(() => (t ? (document.addEventListener("mousedown", s), document.addEventListener("focusin", s)) : (document.removeEventListener("mousedown", s), document.removeEventListener("focusin", s)), () => {
    document.removeEventListener("mousedown", s), document.removeEventListener("focusin", s);
  }), [t, s]);
}, Y = {
  "mobile-navigation": "mobile-navigation",
  "mobile-navigation__overlay": "mobile-navigation__overlay",
  "mobile-navigation__overlay--open": "mobile-navigation__overlay--open",
  "mobile-navigation__overlay--closing": "mobile-navigation__overlay--closing",
  "mobile-navigation__header": "mobile-navigation__header",
  "mobile-navigation__worldwide-link": "mobile-navigation__worldwide-link",
  "mobile-navigation__header-link": "mobile-navigation__header-link",
  "mobile-navigation__close-button": "mobile-navigation__close-button",
  "mobile-navigation__list": "mobile-navigation__list",
  "mobile-navigation__list--primary": "mobile-navigation__list--primary",
  "mobile-navigation__chevron": "mobile-navigation__chevron",
  "mobile-navigation__list-item": "mobile-navigation__list-item",
  "mobile-navigation__list-item--open": "mobile-navigation__list-item--open",
  "mobile-navigation__list-item--active": "mobile-navigation__list-item--active",
  "mobile-navigation__list-item-button": "mobile-navigation__list-item-button",
  "mobile-navigation__list-item-link": "mobile-navigation__list-item-link",
  "mobile-navigation__submenu-list": "mobile-navigation__submenu-list",
  "mobile-navigation__submenu-item": "mobile-navigation__submenu-item",
  "mobile-navigation__submenu-item--active": "mobile-navigation__submenu-item--active",
  "mobile-navigation__submenu-item-title": "mobile-navigation__submenu-item-title",
  "mobile-navigation__submenu-item-title--active": "mobile-navigation__submenu-item-title--active",
  "mobile-navigation__submenu-item-arrow": "mobile-navigation__submenu-item-arrow",
  "mobile-navigation__submenu-item-link": "mobile-navigation__submenu-item-link",
  "mobile-navigation__meta-nav": "mobile-navigation__meta-nav"
}, je = (e) => e == null ? void 0 : e.replace(/^\/+|\/+$/g, ""), me = (e, t) => je(e) === je(t), ci = (e, t, i) => {
  const s = je(i) === je(t);
  return L(Y[`${e}`], s && Y[`${e}--active`]);
}, cl = (e, t) => e == null ? void 0 : e.findIndex(
  ({ url: i, nestedLinks: s }) => je(t) === je(i) || (s == null ? void 0 : s.some(
    (n) => je(n.url) === je(t)
  ))
), ne = {
  "main-navigation": "main-navigation",
  "main-navigation__submenu": "main-navigation__submenu",
  "main-navigation__submenu-item--active": "main-navigation__submenu-item--active",
  "main-navigation__item": "main-navigation__item",
  "main-navigation__item--active": "main-navigation__item--active",
  "main-navigation__item--open": "main-navigation__item--open",
  "main-navigation__item--separator": "main-navigation__item--separator",
  "main-navigation__item-button": "main-navigation__item-button",
  "navigation-item__link": "navigation-item__link",
  "main-navigation__submenu-link": "main-navigation__submenu-link",
  "main-navigation__submenu-link--title": "main-navigation__submenu-link--title"
}, dl = ({ nav: e, primaryNavLabel: t, currentPage: i }) => {
  const [s, n] = V(null), r = H(null);
  Bi(n), Xs(r, s !== null, () => n(null));
  const a = (d, u) => {
    n(d === s ? null : d), d === s ? r.current = null : r.current = u.current;
  }, o = (d, u) => {
    n(d), r.current = u.current;
  }, l = () => {
    n(null), r.current = null;
  }, c = (d, u) => {
    const { nestedLinks: h, text: g, url: _ } = d, b = H(null);
    if (!d.url)
      return /* @__PURE__ */ p(
        "li",
        {
          className: L(ne["main-navigation__item"], ne["main-navigation__item--separator"]),
          "aria-hidden": "true"
        },
        "separator" + u
      );
    const E = s === u, x = L(
      ne["main-navigation__item"],
      me(_, i) && ne["main-navigation__item--active"],
      E && ne["main-navigation__item--open"]
    );
    return h != null && h.length ? /* @__PURE__ */ I("li", { className: x, ref: b, children: [
      /* @__PURE__ */ p(
        "button",
        {
          className: ne["main-navigation__item-button"],
          "aria-controls": _,
          "aria-expanded": s === u,
          onMouseEnter: () => o(u, b),
          onMouseLeave: l,
          onClick: () => a(u, b),
          children: g
        }
      ),
      /* @__PURE__ */ I(
        "ul",
        {
          className: ne["main-navigation__submenu"],
          id: _,
          onMouseEnter: () => o(u, b),
          onMouseLeave: l,
          children: [
            /* @__PURE__ */ p("li", { className: ne["main-navigation__submenu-item"], children: /* @__PURE__ */ I(
              "a",
              {
                className: L(ne["main-navigation__submenu-link"], ne["main-navigation__submenu-link--title"]),
                href: _,
                onClick: d.onClick,
                "aria-current": me(_, i) ? "page" : !1,
                children: [
                  /* @__PURE__ */ p("span", { className: ne["main-navigation__submenu-label"], children: g }),
                  /* @__PURE__ */ p(q, { icon: "arrow-right", height: "24px", decorative: !0 })
                ]
              }
            ) }),
            h == null ? void 0 : h.map((f, m) => /* @__PURE__ */ p(
              "li",
              {
                className: L(
                  ne["main-navigation__submenu-item"],
                  me(f == null ? void 0 : f.url, i) && ne["main-navigation__submenu-item--active"]
                ),
                children: /* @__PURE__ */ p(
                  "a",
                  {
                    className: ne["main-navigation__submenu-link"],
                    href: f == null ? void 0 : f.url,
                    onClick: f == null ? void 0 : f.onClick,
                    "aria-current": me(f == null ? void 0 : f.url, i) ? "page" : !1,
                    children: f.text
                  }
                )
              },
              "sub" + m
            ))
          ]
        }
      )
    ] }, u) : /* @__PURE__ */ p("li", { className: x, ref: b, children: /* @__PURE__ */ p(
      "a",
      {
        className: ne["navigation-item__link"],
        href: _,
        "aria-current": me(_, i) ? "page" : !1,
        onClick: d.onClick,
        children: g
      }
    ) }, u);
  };
  return /* @__PURE__ */ p("nav", { "aria-label": t, children: /* @__PURE__ */ p("ul", { className: ne["main-navigation"], children: e == null ? void 0 : e.map((d, u) => c(d, u)) }) });
}, le = {
  "meta-navigation": "meta-navigation",
  "meta-navigation__items": "meta-navigation__items",
  "meta-navigation__item-icon": "meta-navigation__item-icon",
  "meta-navigation__item": "meta-navigation__item",
  "meta-navigation__item--icon": "meta-navigation__item--icon",
  "meta-navigation__item--active": "meta-navigation__item--active",
  "meta-navigation__item-link": "meta-navigation__item-link",
  "meta-navigation__separator": "meta-navigation__separator"
};
var ei = /* @__PURE__ */ ((e) => (e.DROPDOWN = "dropdown", e.INLINE_LIST = "inline-list", e))(ei || {});
const Le = {
  "language-switch-dropdown": "language-switch-dropdown",
  "language-switch-dropdown__chevron-icon": "language-switch-dropdown__chevron-icon",
  "language-switch-dropdown__open": "language-switch-dropdown__open",
  "language-switch-dropdown__list": "language-switch-dropdown__list",
  "language-switch-dropdown__button": "language-switch-dropdown__button",
  "language-switch-dropdown__list-item": "language-switch-dropdown__list-item",
  "language-switch-dropdown__link": "language-switch-dropdown__link",
  "language-switch-dropdown__link--selected": "language-switch-dropdown__link--selected"
}, rt = {
  "language-switch-inline": "language-switch-inline",
  "language-switch-inline__list": "language-switch-inline__list",
  "language-switch-inline__list-item": "language-switch-inline__list-item",
  "language-switch-inline__link": "language-switch-inline__link",
  "language-switch-inline__link--selected": "language-switch-inline__link--selected"
}, Zs = ({
  alternates: e,
  currentLocale: t,
  currentPage: i,
  translatedLocale: s,
  translatedAriaLabel: n,
  layout: r,
  onClick: a
}) => {
  const [o, l] = V(!1), c = H(null), d = H(null);
  Bi(l), Xs(c, o, () => l(!1));
  const u = (E) => {
    l((x) => {
      const f = !x;
      return c.current = f ? E.current : null, f;
    });
  }, h = (E) => {
    l(!0), c.current = E.current;
  }, g = () => {
    l(!1), c.current = null;
  }, _ = (E) => /* @__PURE__ */ p("div", { className: rt["language-switch-inline"], children: /* @__PURE__ */ p("ul", { className: rt["language-switch-inline__list"], children: E.map((x, f) => {
    const m = x.url === i;
    return s[x.locale] && /* @__PURE__ */ p("li", { className: rt["language-switch-inline__list-item"], children: m ? /* @__PURE__ */ p(
      "span",
      {
        className: L(
          rt["language-switch-inline__link"],
          m && rt["language-switch-inline__link--selected"]
        ),
        "aria-current": "page",
        "aria-disabled": !0,
        children: s[x.locale]
      }
    ) : /* @__PURE__ */ p(
      "a",
      {
        className: rt["language-switch-inline__link"],
        href: x.url,
        "aria-disabled": !1,
        onClick: () => a(x.locale, x.url),
        children: s[x.locale]
      }
    ) }, f);
  }) }) }), b = (E, x) => /* @__PURE__ */ I(
    "div",
    {
      className: L(
        Le["language-switch-dropdown"],
        o && Le["language-switch-dropdown__open"]
      ),
      children: [
        /* @__PURE__ */ I(
          "button",
          {
            className: Le["language-switch-dropdown__button"],
            id: "language-switch-button",
            "aria-expanded": o,
            "aria-controls": "language-switch-list",
            "aria-label": n,
            onClick: () => u(d),
            onMouseEnter: () => h(d),
            onMouseLeave: g,
            children: [
              x.toUpperCase(),
              /* @__PURE__ */ p("span", { className: Le["language-switch-dropdown__chevron-icon"], children: /* @__PURE__ */ p(q, { icon: "chevron-down", width: "18px" }) })
            ]
          }
        ),
        /* @__PURE__ */ p(
          "ul",
          {
            ref: d,
            className: Le["language-switch-dropdown__list"],
            id: "language-switch-list",
            "aria-hidden": !o,
            onMouseEnter: () => h(d),
            onMouseLeave: g,
            inert: o ? null : "",
            children: E.map((f, m) => {
              const v = f.url === i;
              return s[f.locale] && /* @__PURE__ */ p("li", { className: Le["language-switch-dropdown__list-item"], children: v ? /* @__PURE__ */ p(
                "span",
                {
                  className: L(
                    Le["language-switch-dropdown__link"],
                    v && Le["language-switch-dropdown__link--selected"]
                  ),
                  "aria-current": "page",
                  "aria-disabled": !0,
                  children: s[f.locale]
                }
              ) : /* @__PURE__ */ p(
                "a",
                {
                  href: f.url,
                  onClick: () => a(f.locale, f.url),
                  className: Le["language-switch-dropdown__link"],
                  "aria-disabled": !1,
                  children: s[f.locale]
                }
              ) }, m);
            })
          }
        )
      ]
    }
  );
  return r === ei.DROPDOWN ? b(e, t) : _(e);
}, ul = ({
  nav: e,
  secondaryNavLabel: t,
  searchLink: i,
  worldWideLink: s,
  currentPage: n,
  languageSwitchConfig: r
}) => {
  const a = ((r == null ? void 0 : r.alternates) ?? []).length > 0, o = !!(a || s || i);
  return /* @__PURE__ */ I("nav", { className: le["meta-navigation"], "aria-label": t, children: [
    /* @__PURE__ */ p("ul", { className: le["meta-navigation__items"], children: e == null ? void 0 : e.map((l, c) => /* @__PURE__ */ p(
      "li",
      {
        className: L(
          le["meta-navigation__item"],
          me(l.url, n) && le["meta-navigation__item--active"]
        ),
        children: /* @__PURE__ */ p(
          "a",
          {
            className: le["meta-navigation__item-link"],
            href: l.url,
            onClick: l.onClick,
            "aria-current": me(l.url, n) ? "page" : !1,
            children: l.text ?? ""
          }
        )
      },
      c
    )) }),
    o && /* @__PURE__ */ p("div", { className: le["meta-navigation__separator"] }),
    a && r && /* @__PURE__ */ p(
      Zs,
      {
        currentLocale: r.currentLocale,
        currentPage: n,
        alternates: r.alternates,
        translatedLocale: r.translations.translatedLocale,
        translatedAriaLabel: r.translations.translatedAriaLabel,
        layout: ei.DROPDOWN,
        onClick: r.handleClickTracking
      }
    ),
    (s == null ? void 0 : s.url) && /* @__PURE__ */ p(
      "a",
      {
        className: L(
          le["meta-navigation__item"],
          le["meta-navigation__item--icon"],
          me(s == null ? void 0 : s.url, n) && le["meta-navigation__item--active"]
        ),
        href: s.url,
        onClick: s == null ? void 0 : s.onClick,
        "aria-label": s == null ? void 0 : s.label,
        "aria-current": me(s.url, n) ? "page" : !1,
        children: /* @__PURE__ */ p("span", { className: le["meta-navigation__item-icon"], children: /* @__PURE__ */ p(q, { icon: "globe", height: "20px", decorative: !0 }) })
      }
    ),
    (i == null ? void 0 : i.url) && /* @__PURE__ */ p(
      "a",
      {
        className: L(
          le["meta-navigation__item"],
          le["meta-navigation__item--icon"],
          me(i == null ? void 0 : i.url, n) && le["meta-navigation__item--active"]
        ),
        href: i.url,
        onClick: i == null ? void 0 : i.onClick,
        "aria-label": i == null ? void 0 : i.label,
        "aria-current": me(i.url, n) ? "page" : !1,
        children: /* @__PURE__ */ p("span", { className: le["meta-navigation__item-icon"], children: /* @__PURE__ */ p(q, { icon: "search", height: "20px", decorative: !0 }) })
      }
    )
  ] });
}, Ks = () => {
  const [e, t] = V(!1);
  return F(() => {
    const i = window.matchMedia("(prefers-reduced-motion: reduce)");
    t(i.matches);
    const s = () => {
      t(i.matches);
    };
    return i.addEventListener("change", s), () => i.removeEventListener("change", s);
  }, []), e;
}, _s = ({
  link: e,
  index: t,
  openItem: i,
  isNavOpen: s,
  currentPage: n,
  exploreLabel: r,
  handleToggleMenu: a
}) => {
  const { nestedLinks: o, text: l, url: c } = e, d = i === t, u = H(null), h = H(null), [g, _] = V(0);
  if (F(() => {
    u.current && h.current && _(d ? u.current.scrollHeight : 0);
  }, [d, s, r]), !e.url)
    return null;
  if (!(o != null && o.length))
    return /* @__PURE__ */ p("li", { className: ci("mobile-navigation__list-item", c, n), children: /* @__PURE__ */ p("a", { className: Y["mobile-navigation__list-item-link"], href: c, onClick: e.onClick, children: l }) }, t);
  const b = L(
    Y["mobile-navigation__list-item"],
    d && Y["mobile-navigation__list-item--open"]
  );
  return /* @__PURE__ */ I("li", { className: b, children: [
    /* @__PURE__ */ I(
      "button",
      {
        className: Y["mobile-navigation__list-item-button"],
        onClick: () => a(t),
        "aria-controls": c,
        "aria-expanded": d,
        children: [
          l,
          /* @__PURE__ */ p("span", { className: Y["mobile-navigation__chevron"], children: /* @__PURE__ */ p(q, { icon: "chevron-down", height: "24px", decorative: !0 }) })
        ]
      }
    ),
    /* @__PURE__ */ I(
      "ul",
      {
        ref: u,
        className: Y["mobile-navigation__submenu-list"],
        "aria-hidden": !d,
        style: {
          maxHeight: d ? `${g}px` : "0px",
          opacity: d ? 1 : 0
        },
        children: [
          /* @__PURE__ */ p("li", { className: ci("mobile-navigation__submenu-item-title", c, n), children: /* @__PURE__ */ I(
            "a",
            {
              className: Y["mobile-navigation__submenu-item-link"],
              href: c,
              ref: h,
              onClick: e.onClick,
              "aria-label": l,
              "aria-current": me(c, n) ? "page" : !1,
              children: [
                r,
                /* @__PURE__ */ p("span", { className: Y["mobile-navigation__submenu-item-arrow"], children: /* @__PURE__ */ p(q, { icon: "arrow-right", height: "24px", decorative: !0 }) })
              ]
            }
          ) }, "title" + t),
          o == null ? void 0 : o.map((E, x) => /* @__PURE__ */ p(
            "li",
            {
              className: ci("mobile-navigation__submenu-item", E.url, n),
              children: /* @__PURE__ */ p(
                "a",
                {
                  className: Y["mobile-navigation__submenu-item-link"],
                  href: E == null ? void 0 : E.url,
                  onClick: E == null ? void 0 : E.onClick,
                  "aria-current": me(E == null ? void 0 : E.url, n) ? "page" : !1,
                  children: E.text
                }
              )
            },
            "sub" + x
          ))
        ]
      }
    )
  ] }, t);
}, fl = ({
  primaryNav: e,
  secondaryNav: t,
  worldWideLink: i,
  exploreLabel: s,
  closeNavLabel: n,
  currentPage: r,
  isNavOpen: a,
  setIsNavOpen: o,
  languageSwitchConfig: l
}) => {
  var w;
  const c = H(null), d = H(null), [u, h] = V(!1), [g, _] = V(null), b = Ks();
  F(() => {
    const y = cl(e, r);
    _(y);
  }, [r, e]), F(() => {
    var S;
    const y = d.current;
    if (y) {
      if (a) {
        y.showModal(), (S = c.current) == null || S.focus();
        return;
      }
      if (b) {
        y.close();
        return;
      }
      y.open && h(!0);
    }
  }, [a]);
  const E = () => {
    o(!1);
  }, x = (y) => {
    var S;
    y.target === d.current && u && y.propertyName === "transform" && (h(!1), (S = d.current) == null || S.close());
  }, f = (y) => {
    _((S) => S === y ? null : y);
  }, m = L(
    Y["mobile-navigation__overlay"],
    a && Y["mobile-navigation__overlay--open"],
    u && Y["mobile-navigation__overlay--closing"]
  ), v = ((w = (l == null ? void 0 : l.alternates) ?? []) == null ? void 0 : w.length) > 0;
  return /* @__PURE__ */ p("nav", { className: Y["mobile-navigation"], children: /* @__PURE__ */ I(
    "dialog",
    {
      className: m,
      onClose: () => o(!1),
      id: "mobile-navigation",
      ref: d,
      inert: a ? null : "",
      "aria-hidden": !a,
      onTransitionEnd: x,
      children: [
        /* @__PURE__ */ I("header", { className: Y["mobile-navigation__header"], children: [
          /* @__PURE__ */ I(
            "a",
            {
              className: Y["mobile-navigation__worldwide-link"],
              href: i == null ? void 0 : i.url,
              onClick: i == null ? void 0 : i.onClick,
              children: [
                /* @__PURE__ */ p(q, { icon: "globe", height: "24px", decorative: !0 }),
                i == null ? void 0 : i.label
              ]
            }
          ),
          /* @__PURE__ */ p(
            "button",
            {
              className: Y["mobile-navigation__close-button"],
              onClick: E,
              ref: c,
              "aria-label": n,
              "aria-controls": "mobile-navigation",
              children: /* @__PURE__ */ p(q, { icon: "mobile-close", height: "32px", decorative: !0 })
            }
          )
        ] }),
        /* @__PURE__ */ p("ul", { className: L(Y["mobile-navigation__list"], Y["mobile-navigation__list--primary"]), children: e == null ? void 0 : e.map((y, S) => /* @__PURE__ */ p(
          _s,
          {
            link: y,
            index: S,
            openItem: g,
            isNavOpen: a,
            exploreLabel: s,
            currentPage: r,
            handleToggleMenu: f
          },
          S
        )) }),
        /* @__PURE__ */ p("ul", { className: Y["mobile-navigation__list"], children: t == null ? void 0 : t.map((y, S) => /* @__PURE__ */ p(
          _s,
          {
            link: y,
            index: S,
            openItem: g,
            isNavOpen: a,
            exploreLabel: s,
            currentPage: r,
            handleToggleMenu: f
          },
          S
        )) }),
        l && v && /* @__PURE__ */ p("div", { className: Y["mobile-navigation__meta-nav"], children: /* @__PURE__ */ p(
          Zs,
          {
            alternates: l.alternates,
            currentLocale: l.currentLocale,
            currentPage: r,
            translatedLocale: l.translations.translatedLocale,
            translatedAriaLabel: l.translations.translatedAriaLabel,
            layout: ei.INLINE_LIST,
            onClick: l.handleClickTracking
          }
        ) })
      ]
    }
  ) });
}, pl = "grid__column", hl = "header", ml = "header__logo", gl = "header__actions", vl = "header__search", _l = "header__burger", Q = {
  "no-print": "no-print",
  "print-grid-full-width": "print-grid-full-width",
  grid__column: pl,
  "is-8": "is-8",
  "is-1": "is-1",
  "is-3": "is-3",
  header: hl,
  "header__skip-link": "header__skip-link",
  "header__first-row": "header__first-row",
  "header__second-row": "header__second-row",
  header__logo: ml,
  "header__logo-mobile": "header__logo-mobile",
  "header__logo-link": "header__logo-link",
  header__actions: gl,
  header__search: vl,
  "header__search--active": "header__search--active",
  header__burger: _l,
  "header__search-icon": "header__search-icon",
  "header__burger-icon": "header__burger-icon",
  "header__mobile-nav": "header__mobile-nav",
  "header__secondary-nav": "header__secondary-nav",
  "header--scrolled": "header--scrolled",
  "header--transparent": "header--transparent",
  "header--hidden": "header--hidden"
}, wl = 100, xp = ({
  homeLink: e,
  searchLink: t,
  worldWideLink: i,
  exploreLabel: s,
  openNavLabel: n,
  closeNavLabel: r,
  currentPage: a,
  isFixed: o,
  primaryNav: l,
  secondaryNav: c,
  primaryNavLabel: d,
  secondaryNavLabel: u,
  skipToContentLabel: h,
  languageSwitchConfig: g
}) => {
  const [_, b] = V(!1);
  ll(_);
  const E = () => {
    b(!_);
  }, x = Ys(), f = ol(), m = x > 0, v = x < wl, w = !o && !v && f === "down", y = !m, S = L(
    Q.header,
    o && Q["header--fixed"],
    m && Q["header--scrolled"],
    y && Q["header--transparent"],
    w && Q["header--hidden"]
  ), k = a === (t == null ? void 0 : t.url);
  return /* @__PURE__ */ I("header", { className: S, children: [
    /* @__PURE__ */ p("a", { className: Q["header__skip-link"], href: "#main-content", children: h }),
    /* @__PURE__ */ I("div", { className: Q["header__first-row"], children: [
      /* @__PURE__ */ I(
        "a",
        {
          className: Q["header__logo-link"],
          href: (e == null ? void 0 : e.url) ?? "/",
          "aria-label": e == null ? void 0 : e.label,
          onClick: e == null ? void 0 : e.onClick,
          children: [
            /* @__PURE__ */ p("span", { className: Q.header__logo, children: /* @__PURE__ */ p(q, { icon: "logo", height: "40px", decorative: !0 }) }),
            /* @__PURE__ */ p("span", { className: Q["header__logo-mobile"], children: /* @__PURE__ */ p(q, { icon: "logo", height: "30px", decorative: !0 }) })
          ]
        }
      ),
      /* @__PURE__ */ p("div", { className: Q["header__secondary-nav"], children: /* @__PURE__ */ p(
        ul,
        {
          nav: c,
          secondaryNavLabel: u,
          worldWideLink: i,
          searchLink: t,
          currentPage: a,
          languageSwitchConfig: g
        }
      ) }),
      /* @__PURE__ */ I("div", { className: Q.header__actions, children: [
        /* @__PURE__ */ p(
          "a",
          {
            href: t == null ? void 0 : t.url,
            className: L(Q.header__search, k && Q["header__search--active"]),
            "aria-label": t == null ? void 0 : t.label,
            "aria-current": k ? "page" : !1,
            onClick: t == null ? void 0 : t.onClick,
            children: /* @__PURE__ */ p("span", { className: Q["header__search-icon"], children: /* @__PURE__ */ p(q, { icon: "search-mobile", height: "32px", decorative: !0 }) })
          }
        ),
        /* @__PURE__ */ p(
          "button",
          {
            className: Q.header__burger,
            onClick: E,
            "aria-label": n,
            "aria-controls": "mobile-navigation",
            "aria-expanded": _,
            children: /* @__PURE__ */ p("span", { className: Q["header__burger-icon"], children: /* @__PURE__ */ p(q, { icon: "mobile-menu", height: "32px", decorative: !0 }) })
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ p("div", { className: Q["header__second-row"], children: /* @__PURE__ */ p(dl, { nav: l, primaryNavLabel: d, currentPage: a }) }),
    /* @__PURE__ */ p("div", { className: Q["header__mobile-nav"], children: /* @__PURE__ */ p(
      fl,
      {
        primaryNav: l,
        secondaryNav: c,
        worldWideLink: i,
        exploreLabel: s,
        closeNavLabel: r,
        currentPage: a,
        isNavOpen: _,
        setIsNavOpen: b,
        languageSwitchConfig: g
      }
    ) })
  ] });
}, bl = "image", De = {
  "hero-teaser": "hero-teaser",
  "hero-teaser__info-container": "hero-teaser__info-container",
  "hero-teaser__text-container": "hero-teaser__text-container",
  "hero-teaser__title-container": "hero-teaser__title-container",
  "hero-teaser__title": "hero-teaser__title",
  "hero-teaser__overline": "hero-teaser__overline",
  "hero-teaser__button-container": "hero-teaser__button-container",
  "hero-teaser__image-container": "hero-teaser__image-container",
  image: bl,
  "video-player": "video-player",
  "hero-teaser--unpublished": "hero-teaser--unpublished"
}, $i = (e) => {
  const [t, i] = V(!1);
  return F(() => {
    const s = () => {
      i(window.innerWidth < e);
    };
    return s(), window.addEventListener("resize", s), () => window.removeEventListener("resize", s);
  }, [e]), t;
}, yl = "image", El = "image__img", xl = "image__container", Sl = "image__description", Tl = "image__caption", Al = "image__copyright", ce = {
  image: yl,
  image__img: El,
  image__container: xl,
  "image--fullscreen": "image--fullscreen",
  "image--bleed": "image--bleed",
  "image--original": "image--original",
  "image--top": "image--top",
  "image--center": "image--center",
  "image--bottom": "image--bottom",
  "image--full-height": "image--full-height",
  image__description: Sl,
  image__caption: Tl,
  image__copyright: Al,
  "image__ratio-hd": "image__ratio-hd",
  "image__ratio-wide": "image__ratio-wide",
  "image__ratio-square": "image__ratio-square",
  "image__ratio-vertical": "image__ratio-vertical",
  "image__ratio-normal": "image__ratio-normal",
  "image__ratio-sixtofive": "image__ratio-sixtofive"
};
var ie = /* @__PURE__ */ ((e) => (e.HD = "16:9", e.WIDE = "2.39:1", e.SQUARE = "1:1", e.VERTICAL = "4:5", e.ORIGINAL = "original", e.NORMAL = "4:3", e.SIXTOFIVE = "6:5", e))(ie || {}), Ml = /* @__PURE__ */ ((e) => (e.LAZY = "lazy", e.EAGER = "eager", e))(Ml || {}), Je = /* @__PURE__ */ ((e) => (e.TOP = "top", e.CENTER = "center", e.BOTTOM = "bottom", e))(Je || {});
const kl = [1, 1.5, 2, 3], Cl = (e) => {
  const [t, i] = V({ width: 0, height: 0 });
  return F(() => {
    const s = new ResizeObserver((n) => {
      for (let r of n) {
        const { width: a, height: o } = r.contentRect;
        i({
          width: Math.round(a),
          height: Math.round(o)
        });
      }
    });
    return e.current && s.observe(e.current), () => {
      e.current && s.unobserve(e.current);
    };
  }, []), t;
}, Nl = (e) => {
  const t = Object.values(ie).includes(e) ? e : ie.HD;
  if (t === ie.ORIGINAL)
    return null;
  const [i, s] = t.split(":").map(parseFloat);
  return i / s;
}, ws = (e, t, i, s) => {
  const n = Nl(i);
  let r = 0;
  return s ? r = s : n && (r = Math.round(t / n)), e.replace(/\$0/g, `${t}`).replace(/\$1/g, `${r}`);
}, Il = (e) => e.includes("$0"), Ol = (e) => {
  var t;
  return ((t = Object.entries(ie).find(([, i]) => i === e)) == null ? void 0 : t[0].toLowerCase()) || null;
}, Rl = (e) => Object.values(Je).includes(e) ? e : Je.CENTER, Pl = 300, ti = ({
  src: e,
  alt: t,
  slot: i,
  caption: s = void 0,
  copyright: n = void 0,
  ratio: r = ie.HD,
  position: a = Je.CENTER,
  fullscreen: o = !1,
  showCaption: l = !1,
  showCopyright: c = !1,
  bleed: d = !1,
  forceHeight: u = void 0,
  loading: h = "lazy"
}) => {
  const g = ws(e, te.SMALL, r, u), [{ fallbackSrc: _, width: b, srcSet: E }, x] = V({
    fallbackSrc: g,
    width: te.SMALL,
    srcSet: ""
  }), f = H(null), m = Cl(f), v = Ol(r), w = L({
    [ce.image__img]: !0,
    [ce[`image__ratio-${v}`]]: r !== ie.ORIGINAL && v
  });
  Il(e) && F(() => {
    const k = setTimeout(() => {
      const O = window.devicePixelRatio || 1;
      if (m.width) {
        const M = kl.map((C) => {
          const D = Math.round(m.width * O);
          return `${ws(e, D, r, u)} ${C}x`;
        }).join(", ");
        x({ fallbackSrc: _, width: m.width, srcSet: M });
      }
    }, Pl);
    return () => clearTimeout(k);
  }, [m, _]);
  const y = Rl(a), S = L({
    [ce.image]: !0,
    [ce["image--fullscreen"]]: o,
    [ce["image--bleed"]]: d,
    [ce["image--top"]]: y === Je.TOP,
    [ce["image--center"]]: y === Je.CENTER,
    [ce["image--bottom"]]: y === Je.BOTTOM,
    [ce["image--original"]]: r === ie.ORIGINAL,
    [ce["image--full-height"]]: u !== void 0
  });
  return /* @__PURE__ */ I("figure", { className: S, slot: i, "data-ratio": r, children: [
    /* @__PURE__ */ p("div", { className: ce.image__container, ref: f, children: /* @__PURE__ */ p(
      "img",
      {
        className: w,
        src: _,
        srcSet: E,
        sizes: `${b}px`,
        alt: t,
        title: s,
        loading: h
      }
    ) }),
    (l && s || c && n) && /* @__PURE__ */ I("div", { className: ce.image__description, children: [
      l && s && /* @__PURE__ */ p("figcaption", { className: ce.image__caption, children: s }),
      c && n && /* @__PURE__ */ I("div", { className: ce.image__copyright, children: [
        "© ",
        n
      ] })
    ] })
  ] });
}, bs = "youtube-iframe-api-script", Ll = "https://www.youtube.com/iframe_api";
let It = null, gt = null;
const Dl = () => (It || (It = new Promise((e) => {
  if (gt = e, document.getElementById(bs))
    if (typeof window.YT < "u" && window.YT.Player) {
      e(!0);
      return;
    } else {
      window.onYouTubeIframeAPIReady = () => {
        e(!0);
      };
      return;
    }
  const t = document.createElement("script");
  t.id = bs, t.src = Ll, t.async = !0, window.onYouTubeIframeAPIReady = () => {
    gt && gt(!0);
  }, t.onerror = () => {
    gt && gt(!1), It = null;
  }, document.head.appendChild(t);
})), It);
function zl() {
  const [e, t] = V(!1);
  return F(() => {
    let i = !0;
    return Dl().then((s) => {
      i && t(s);
    }), () => {
      i = !1;
    };
  }, []), e;
}
const Vl = "image", W = {
  "video-player": "video-player",
  "video-player__service--youtube": "video-player__service--youtube",
  "video-player__service--brightcove": "video-player__service--brightcove",
  "video-player__service--aws-video-js": "video-player__service--aws-video-js",
  "video-player__content--absolute": "video-player__content--absolute",
  "video-player__content--absolute-active": "video-player__content--absolute-active",
  "video-player__content--relative": "video-player__content--relative",
  "video-player__content--relative--fullscreen": "video-player__content--relative--fullscreen",
  "video-player__content--relative-ready": "video-player__content--relative-ready",
  "video-player__overlay": "video-player__overlay",
  "video-player__overlay-icon": "video-player__overlay-icon",
  "video-player__overlay-videoloop": "video-player__overlay-videoloop",
  "video-player__overlay--hidden": "video-player__overlay--hidden",
  "video-player__close-button": "video-player__close-button",
  "video-player--fullscreen": "video-player--fullscreen",
  "video-player__image": "video-player__image",
  image: Vl,
  "video-player__image--hidden": "video-player__image--hidden",
  "video-player__image--fullscreen": "video-player__image--fullscreen",
  "video-player__image--fullscreen-playing": "video-player__image--fullscreen-playing",
  "video-player__image--error": "video-player__image--error",
  "video-player__placeholder": "video-player__placeholder",
  "video-player__placeholder--fullscreen": "video-player__placeholder--fullscreen",
  "video-player__placeholder--hidden": "video-player__placeholder--hidden",
  "video-description": "video-description",
  "video-description__caption": "video-description__caption",
  "video-description__copyright": "video-description__copyright"
}, Bl = 64, $l = 80, Hl = 24, Qs = ({
  onPlay: e,
  onPause: t,
  fullscreen: i,
  isPlaying: s,
  videoloop: n,
  videoTitle: r,
  pauseLabel: a,
  playLabel: o
}) => {
  const l = $i(te.MEDIUM), c = `${Ue(l ? Bl : $l)}rem`, d = `${Ue(Hl)}rem`, u = L(W["video-player__overlay"], W["video-player__overlay-videoloop"]), h = L(
    W["video-player__overlay"],
    s && W["video-player__overlay--hidden"]
  ), g = n ? u : h, _ = s ? "pause" : "play", b = s ? a : o, E = (f) => {
    f.preventDefault(), s && t ? t() : e();
  }, x = (f, m) => m ? `${f} ${m}` : f;
  return s && i ? /* @__PURE__ */ p("button", { className: W["video-player__close-button"], onClick: E, children: /* @__PURE__ */ p(q, { icon: "close", height: d }) }) : /* @__PURE__ */ p("div", { className: g, children: /* @__PURE__ */ p(
    "button",
    {
      onClick: E,
      className: W["video-player__overlay-icon"],
      "aria-label": x(b, r),
      children: /* @__PURE__ */ p(q, { icon: _, height: c })
    }
  ) });
}, Fl = (e) => {
  const t = Math.round(e.getCurrentTime()), i = Math.round(e.getDuration());
  return Math.round(t / i * 100);
}, Js = ({
  isPlaying: e,
  fullscreen: t,
  preview: i,
  previewAlt: s,
  error: n
}) => {
  const r = L(
    W["video-player__image"],
    t && W["video-player__image--fullscreen"],
    t && e && W["video-player__image--fullscreen-playing"],
    e && !t && W["video-player__image--hidden"]
  ), a = L(W["video-player__image"], W["video-player__image--error"]);
  return /* @__PURE__ */ p("div", { className: n ? a : r, "aria-hidden": !0, children: /* @__PURE__ */ p(
    ti,
    {
      src: i,
      alt: s,
      ratio: t ? ie.WIDE : ie.HD,
      fullscreen: t
    }
  ) });
}, Gl = 1e3, ql = ({
  videoId: e,
  fullscreen: t,
  preview: i,
  previewAlt: s,
  pauseLabel: n,
  playLabel: r,
  onVideoStateChange: a
}) => {
  const o = zl(), l = `yt-video-${e}`, c = H(null), d = H(null), [u, h] = V(!1), [g, _] = V(!1), [b, E] = V(""), x = H(), f = (M) => {
    const C = document.getElementById(l);
    C && (C.style.width = M ? "auto" : "100%", C.style.height = M ? "90% " : "auto", C.style.aspectRatio = "16 / 9", C.style.display = "none");
  }, m = () => {
    const M = document.getElementById(l);
    M && (M.style.display = "inline");
  }, v = (M) => ({
    videoId: e,
    videoTitle: M.getVideoData().title,
    videoType: "youtube",
    videoDurationTotal: M.getDuration(),
    videoPercentageViewed: Fl(M),
    videoUrl: M.getVideoUrl()
  }), w = (M) => {
    switch (M.data) {
      case YT.PlayerState.PLAYING:
        y(), x.current = setInterval(
          () => S(M.target),
          Gl
        ), a({
          type: "playing",
          base: { ...v(M.target) },
          trackingValue: "play"
        });
        break;
      case YT.PlayerState.ENDED:
        y(), a({
          type: "ended",
          base: { ...v(M.target) },
          trackingValue: "end"
        });
        break;
      case YT.PlayerState.PAUSED:
        y(), S(M.target), a({
          type: "pause",
          base: { ...v(M.target) },
          trackingValue: "pause"
        });
        break;
      default:
        y();
    }
  }, y = () => {
    clearInterval(x.current);
  }, S = (M) => {
    a({
      type: "timeupdate",
      base: { ...v(M) },
      trackingValue: "timeupdate"
    });
  };
  F(() => {
    if (o && d.current && !c.current && e && typeof YT < "u" && YT.Player)
      try {
        c.current = new YT.Player(d.current, {
          videoId: e,
          playerVars: {
            autoplay: 0,
            controls: 1
          },
          host: "https://www.youtube-nocookie.com",
          events: {
            onReady: (M) => {
              h(!0), f(t), E(M.target.getVideoData().title);
            },
            onStateChange: w,
            onError: (M) => {
              const C = (M == null ? void 0 : M.data) || "YOUTUBE_UNKNOWN_ERROR";
              a({
                type: "error",
                base: { ...v(M.target) },
                trackingValue: "videoError",
                errorCode: C
              });
            }
          }
        });
      } catch (M) {
        console.error(`Failed to create YouTube Player with videoId: ${e} - Error: ${M.message}`);
      }
  }, [o, e, t]);
  const k = () => {
    _(!0), o && c.current && u && (m(), c.current.playVideo());
  }, O = () => {
    _(!1), o && c.current && u && c.current.pauseVideo();
  };
  return /* @__PURE__ */ I("div", { className: W["video-player__service--youtube"], children: [
    i && /* @__PURE__ */ p(
      Js,
      {
        preview: i,
        previewAlt: s,
        isPlaying: g,
        fullscreen: t,
        error: g && !e
      }
    ),
    /* @__PURE__ */ p(
      "div",
      {
        className: L(
          W["video-player__content--absolute"],
          g && W["video-player__content--absolute-active"]
        ),
        children: /* @__PURE__ */ p("div", { id: l, ref: d })
      }
    ),
    /* @__PURE__ */ p(
      Qs,
      {
        onPlay: k,
        onPause: O,
        isPlaying: g,
        pauseLabel: n,
        playLabel: r,
        videoTitle: b,
        fullscreen: t
      }
    )
  ] });
}, Ot = {
  "aws-player": "aws-player",
  "video-js": "video-js",
  "vjs-dock-shelf": "vjs-dock-shelf",
  "vjs-dock-text": "vjs-dock-text",
  "vjs-load-progress": "vjs-load-progress",
  "vjs-volume-bar": "vjs-volume-bar",
  "vjs-volume-level": "vjs-volume-level",
  "vjs-play-progress": "vjs-play-progress",
  "vjs-picture-in-picture-control": "vjs-picture-in-picture-control",
  "vjs-duration-display": "vjs-duration-display",
  "vjs-current-time-display": "vjs-current-time-display",
  "vjs-time-control": "vjs-time-control",
  "vjs-remaining-time": "vjs-remaining-time",
  "vjs-custom-control-spacer": "vjs-custom-control-spacer",
  "vjs-progress-control": "vjs-progress-control",
  "vjs-progress-holder": "vjs-progress-holder",
  "vjs-live-display": "vjs-live-display",
  "vjs-big-play-button": "vjs-big-play-button",
  "aws-player__controls--hidden": "aws-player__controls--hidden",
  "vjs-control-bar": "vjs-control-bar",
  "vjs-loading-spinner": "vjs-loading-spinner",
  "aws-player--fullscreen-videoloop": "aws-player--fullscreen-videoloop",
  "vjs-tech": "vjs-tech",
  "aws-player--fullscreen": "aws-player--fullscreen"
}, jl = (e) => {
  const t = e.currentTime(), i = e.duration();
  return t && i ? Math.round(t / i * 100) : null;
}, Wl = ({
  awsServiceBaseUrl: e,
  options: t,
  fullscreen: i,
  videoLoop: s,
  preview: n,
  previewAlt: r,
  pauseLabel: a,
  playLabel: o,
  caption: l,
  videoId: c,
  onVideoStateChange: d
}) => {
  const u = H(null), h = H(null), g = i && !s, _ = i && s, [b, E] = V(!1), [x, f] = V(!1), [m, v] = V(!1), w = x && m, y = H(!1), S = H(!1), k = (R) => {
    var A;
    return {
      videoId: c,
      videoTitle: l ?? "",
      videoType: "aws",
      videoDurationTotal: R.duration() ?? 0,
      videoPercentageViewed: jl(R) ?? 0,
      videoUrl: ((A = t.sources) == null ? void 0 : A[0].src) ?? "unknown videoUrl"
    };
  }, O = `${e}${c}`;
  F(() => {
    x && fetch(`${O}/meta.json`).then((R) => R.json()).then((R) => {
      var A;
      h.current ? (A = R.meta.video.text_tracks) == null || A.forEach((N) => {
        var z;
        (z = h.current) == null || z.addRemoteTextTrack({
          ...N,
          src: `${O}${N.src}`
        });
      }) : console.error("AWS video player: Player not properly initialized");
    }).catch((R) => {
      console.error("AWS video player: Error fetching meta data", R);
    });
  }, [x]), F(() => {
    var R;
    if (h.current) {
      const A = h.current;
      A.autoplay(t.autoplay), A.src(t.sources);
    } else {
      const A = document.createElement("video-js");
      (R = u.current) == null || R.appendChild(A);
      const N = h.current = xn(A, t, () => {
      });
      N.on("ready", () => {
        f(!0);
      }), N.on("loadedmetadata", () => {
        v(!0);
      }), N.on("seeking", () => {
        S.current = !0;
      }), N.on("seeked", () => {
        y.current = !0;
      }), N.on("play", () => {
        E(!0), y.current ? y.current = !1 : d({
          type: "playing",
          base: { ...k(N) },
          trackingValue: "play"
        });
      }), N.on("pause", () => {
        S.current ? S.current = !1 : d({
          type: "pause",
          base: { ...k(N) },
          trackingValue: "pause"
        });
      }), N.on("ended", () => {
        d({
          type: "ended",
          base: { ...k(N) },
          trackingValue: "end"
        });
      }), N.on("timeupdate", () => {
        d({
          type: "timeupdate",
          base: { ...k(N) },
          trackingValue: "timeupdate"
        });
      }), N.on("error", (z) => {
        var J, X, K;
        const G = ((K = (X = (J = z == null ? void 0 : z.target) == null ? void 0 : J.player) == null ? void 0 : X.error_) == null ? void 0 : K.code) || "VIDEOJS_UNKNOWN_ERROR";
        d({
          type: "error",
          base: { ...k(N) },
          trackingValue: "videoError",
          errorCode: G
        }), console.error(G);
      });
    }
    return () => {
      const A = h.current;
      A && !A.isDisposed() && (A.dispose(), h.current = null);
    };
  }, []);
  const M = async () => {
    if (h.current && x)
      try {
        await h.current.play();
      } catch (R) {
        console.error("VideoJS (AWS) play failed:", R), E(!1);
      }
  }, C = () => {
    E(!1), h.current && h.current.pause();
  }, D = L(
    Ot["aws-player"],
    s && Ot["aws-player__controls--hidden"],
    g && Ot["aws-player--fullscreen"],
    _ && Ot["aws-player--fullscreen-videoloop"]
  ), P = L(
    W["video-player__content--relative"],
    i && W["video-player__content--relative--fullscreen"],
    w && W["video-player__content--relative-ready"]
  ), $ = L(
    W["video-player__content--absolute"],
    x && b && W["video-player__content--absolute-active"]
  ), B = s ? P : $;
  return /* @__PURE__ */ I("div", { className: W["video-player__service--aws-video-js"], children: [
    !s && n && /* @__PURE__ */ p(
      Js,
      {
        preview: n,
        previewAlt: r,
        isPlaying: b,
        fullscreen: i,
        error: !1
      }
    ),
    /* @__PURE__ */ p("div", { className: B, children: /* @__PURE__ */ p("div", { className: D, "data-vjs-player": !0, children: /* @__PURE__ */ p("div", { ref: u }) }) }),
    /* @__PURE__ */ p(
      Qs,
      {
        onPlay: M,
        onPause: C,
        isPlaying: b,
        pauseLabel: a,
        playLabel: o,
        videoTitle: l,
        videoloop: s,
        fullscreen: g
      }
    )
  ] });
}, Hi = ({
  awsServiceBaseUrl: e,
  service: t,
  fullscreen: i,
  videoLoop: s,
  caption: n,
  copyright: r,
  slot: a,
  ...o
}) => {
  const l = H(null), c = Ds(l), d = $i(te.MEDIUM), u = () => i ? s ? !0 : !d : !1, h = () => /* @__PURE__ */ p("div", { ref: l, className: b }), g = (x) => {
    switch (x) {
      case "youtube":
        return /* @__PURE__ */ p(ql, { fullscreen: u(), ...o });
      case "aws":
        if (e) {
          const f = `${e}${o.videoId}/hls/main.m3u8`;
          return /* @__PURE__ */ p(
            Wl,
            {
              awsServiceBaseUrl: e,
              fullscreen: u(),
              videoLoop: s,
              options: {
                aspectRatio: ie.HD,
                fluid: !0,
                preload: s ? "auto" : "none",
                muted: s,
                loop: s,
                autoplay: s,
                controls: !0,
                playsinline: !!s,
                disablePictureInPicture: !0,
                fullscreen: { navigationUI: "hide" },
                controlBar: {
                  fullscreenToggle: !0,
                  pictureInPictureToggle: !1
                },
                sources: [
                  {
                    src: f,
                    type: "application/x-mpegURL"
                  }
                ]
              },
              ...o
            }
          );
        }
        return console.error("Trying to render AWS video service without supplying video service URL"), h();
      default:
        console.info(`Trying to render not-implemented video service: - ${x}`);
        break;
    }
  }, _ = () => (n || r) && /* @__PURE__ */ I("div", { className: W["video-description"], children: [
    n && /* @__PURE__ */ p("figcaption", { className: W["video-description__caption"], children: n }),
    r && /* @__PURE__ */ I("div", { className: W["video-description__copyright"], children: [
      "© ",
      r
    ] })
  ] }), b = L(
    W["video-player__placeholder"],
    i && W["video-player__placeholder--fullscreen"]
  ), E = L(
    W["video-player"],
    i && !s && W["video-player--fullscreen"]
  );
  return c ? /* @__PURE__ */ I("div", { className: E, slot: a, children: [
    g(t),
    _()
  ] }) : h();
}, Sp = ({
  teaserTitle: e,
  teaserOverline: t,
  teaserDescription: i,
  teaserImage: s,
  teaserImageRatio: n,
  teaserImageAlt: r,
  imageOnLeftSide: a = !1,
  primaryButtonUrl: o,
  primaryButtonText: l,
  secondaryButton: c,
  onPrimaryButtonClick: d,
  leftIcon: u,
  rightIcon: h,
  unpublished: g,
  playLabel: _,
  pauseLabel: b,
  onVideoStateChange: E,
  target: x,
  awsServiceBaseUrl: f
}) => {
  const v = $i(te.MEDIUM) ? !0 : a, w = !Number(s), y = s && /* @__PURE__ */ p("div", { className: De["hero-teaser__image-container"], children: w ? /* @__PURE__ */ p(ti, { src: s, alt: r ?? "", ratio: n }) : /* @__PURE__ */ p(
    Hi,
    {
      awsServiceBaseUrl: f,
      service: "aws",
      videoId: s,
      previewAlt: r ?? "",
      playLabel: _ ?? "",
      pauseLabel: b ?? "",
      videoLoop: !0,
      onVideoStateChange: (k) => {
        E && E(k);
      }
    }
  ) }), S = /* @__PURE__ */ I("div", { className: De["hero-teaser__info-container"], children: [
    /* @__PURE__ */ I("div", { className: De["hero-teaser__text-container"], children: [
      /* @__PURE__ */ I("div", { className: De["hero-teaser__title-container"], children: [
        t && t.length > 0 && /* @__PURE__ */ p("div", { className: De["hero-teaser__overline"], children: t }),
        e && /* @__PURE__ */ p("h2", { className: De["hero-teaser__title"], children: e })
      ] }),
      i && /* @__PURE__ */ p("p", { children: i })
    ] }),
    /* @__PURE__ */ I("div", { className: De["hero-teaser__button-container"], children: [
      l && /* @__PURE__ */ p(
        Qt,
        {
          target: x || Kt.SELF,
          hasMarginTop: !1,
          href: o,
          appearance: Te.SECONDARY,
          text: l,
          onClick: d,
          leftIcon: u,
          rightIcon: h
        }
      ),
      c
    ] })
  ] });
  return /* @__PURE__ */ p("section", { className: L(De["hero-teaser"], g && De["hero-teaser--unpublished"]), children: v ? /* @__PURE__ */ I(Ht, { children: [
    y,
    " ",
    S
  ] }) : /* @__PURE__ */ I(Ht, { children: [
    S,
    " ",
    y
  ] }) });
}, ys = {
  "highlight-box": "highlight-box",
  "highlight-box--transparent": "highlight-box--transparent",
  "highlight-box--theme-aware": "highlight-box--theme-aware",
  "highlight-box--neutral": "highlight-box--neutral",
  "highlight-box--neutral-100": "highlight-box--neutral-100",
  "highlight-box--neutral-200": "highlight-box--neutral-200",
  "highlight-box--grey": "highlight-box--grey",
  "highlight-box--grey-50": "highlight-box--grey-50",
  "highlight-box--grey-100": "highlight-box--grey-100",
  "highlight-box--grey-200": "highlight-box--grey-200",
  "highlight-box--grey-300": "highlight-box--grey-300",
  "highlight-box--white": "highlight-box--white"
}, Tp = ({ color: e, children: t }) => /* @__PURE__ */ p("section", { className: L(ys["highlight-box"], ys[`highlight-box--${e}`]), children: t }), Ul = {
  "horizontal-center": "horizontal-center"
}, Ap = ({ children: e, slot: t }) => e != null && (Array.isArray(e) ? e.length > 0 : !0) ? /* @__PURE__ */ p("div", { className: Ul["horizontal-center"], slot: t, children: e }) : null, Yl = {
  "lead-text": "lead-text",
  "highlight-box": "highlight-box"
}, Mp = ({ lead: e }) => /* @__PURE__ */ p("p", { className: Yl["lead-text"], children: e }), di = {
  "loading-spinner": "loading-spinner",
  "loading-spinner__icon-container": "loading-spinner__icon-container",
  "loading-spinner__text": "loading-spinner__text"
}, Xl = "loading", Zl = "24px", kp = ({ loadingText: e }) => /* @__PURE__ */ I("div", { className: di["loading-spinner"], children: [
  /* @__PURE__ */ p("div", { className: di["loading-spinner__icon-container"], children: /* @__PURE__ */ p(q, { icon: Xl, height: Zl, decorative: !0, display: "inline" }) }),
  /* @__PURE__ */ p("div", { className: di["loading-spinner__text"], "aria-live": "polite", "aria-busy": "true", children: e })
] }), Kl = "magnet", Ql = {
  magnet: Kl
}, Cp = () => /* @__PURE__ */ p("div", { className: Ql.magnet }), Jl = "marketo", ec = "mktoForm", tc = "mktoFormRow", ic = "mktoFormCol", sc = "LblConsent_given_to_contact_for_Mktg_Info__c", nc = "LblConsent_given_to_store_data_in_Data_Base__c", rc = "LblconsentforDataTracking", ac = "mktoFieldWrap", oc = "mktoError", lc = "mktoRequiredField", cc = "mktoCheckboxList", dc = "mktoRadioList", uc = "mktoButtonRow", fc = "mktoButtonWrap", pc = "mktoButton", hc = "mktoHtmlText", mc = "mktoDateButton", gc = "mktoLabel", vc = "mktoAsterix", _c = "mktoErrorMsg", wc = "mktoErrorDetail", bc = "mktoErrorArrowWrap", yc = "mktoInvalid", Ec = "mktoOffset", xc = "mktoGutter", Sc = {
  marketo: Jl,
  mktoForm: ec,
  mktoFormRow: tc,
  mktoFormCol: ic,
  LblConsent_given_to_contact_for_Mktg_Info__c: sc,
  LblConsent_given_to_store_data_in_Data_Base__c: nc,
  LblconsentforDataTracking: rc,
  mktoFieldWrap: ac,
  mktoError: oc,
  mktoRequiredField: lc,
  mktoCheckboxList: cc,
  mktoRadioList: dc,
  mktoButtonRow: uc,
  mktoButtonWrap: fc,
  mktoButton: pc,
  mktoHtmlText: hc,
  mktoDateButton: mc,
  mktoLabel: gc,
  mktoAsterix: vc,
  mktoErrorMsg: _c,
  mktoErrorDetail: wc,
  mktoErrorArrowWrap: bc,
  mktoInvalid: yc,
  mktoOffset: Ec,
  mktoGutter: xc
}, Np = ({ children: e }) => /* @__PURE__ */ p("div", { className: Sc.marketo, children: e }), Tc = "podcast", Ac = "podcast__iframe", jt = {
  podcast: Tc,
  "podcast--soundcloud": "podcast--soundcloud",
  podcast__iframe: Ac,
  "podcast--spotify": "podcast--spotify",
  "podcast--spotify-creators": "podcast--spotify-creators",
  "podcast--transistor": "podcast--transistor"
}, en = [10, 25, 50, 75, 100], Mc = 80, kc = ({ src: e, onPodcastStateChange: t }) => {
  const i = H(null), s = H(null), [n, r] = V(null), [a, o] = V(!1), l = H(/* @__PURE__ */ new Set()), c = (b, E) => ({
    audioName: "Spotify Podcast",
    audioUrl: e,
    audioProvider: "spotify",
    audioDurationTotal: b,
    audioPercentage: E
  }), d = () => {
    l.current.clear();
  }, u = (b) => {
    const { position: E, duration: x } = b.data;
    if (x === 0) {
      g("No audio found");
      return;
    }
    const f = E / x * 100;
    for (const m of en)
      f >= m && !l.current.has(m) && (l.current.add(m), t(m === 100 ? {
        type: "completed",
        base: c(x, f),
        trackingValue: "audioComplete"
      } : {
        type: "progress",
        base: c(x, m),
        trackingValue: "audioProgress"
      }));
  }, h = (b) => {
    const { duration: E } = b.data;
    if (E === 0) {
      g("No audio found");
      return;
    }
    d(), t({
      type: "starting",
      base: c(E, 0),
      trackingValue: "audioStart"
    });
  }, g = (b) => {
    t({
      type: "error",
      base: c(0, 0),
      trackingValue: "audioError",
      errorMessage: b
    });
  }, _ = (b) => {
    const E = b.match(/open\.spotify\.com\/embed\/(\w+)\/([\w\d]+)/);
    if (!E)
      return g("Failed to generate Spotify URI"), null;
    const [, x, f] = E;
    return `spotify:${x}:${f}`;
  };
  return F(() => {
    const b = document.createElement("script");
    return b.src = "https://open.spotify.com/embed/iframe-api/v1", b.async = !0, document.body.appendChild(b), () => {
      document.body.removeChild(b);
    };
  }, []), F(() => {
    n || (window.onSpotifyIframeApiReady = (b) => {
      r(b);
    });
  }, [n]), F(() => {
    if (!(a || n === null || !i.current))
      return n.createController(
        i.current,
        {
          height: Mc,
          uri: _(e) || ""
        },
        (b) => {
          b.addListener("ready", () => {
            o(!0);
          }), b.addListener("playback_started", h), b.addListener("playback_update", u), s.current = b;
        }
      ), () => {
        s.current && s.current.removeListener("playback_update");
      };
  }, [a, n, e]), /* @__PURE__ */ p(
    "iframe",
    {
      ref: i,
      className: jt.podcast__iframe,
      title: "Podcast Player",
      src: e,
      width: "100%",
      seamless: !0,
      allow: "autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture",
      allowFullScreen: !0,
      loading: "lazy"
    }
  );
}, Cc = ({ src: e, onPodcastStateChange: t }) => {
  const i = H(null), s = H(null), [n, r] = V(!1), [a, o] = V(""), [l, c] = V(0), d = H(/* @__PURE__ */ new Set()), u = H(!1), h = ke(
    (f, m, v) => ({
      audioName: f,
      audioUrl: e,
      audioProvider: "soundcloud",
      audioDurationTotal: m,
      audioPercentage: v
    }),
    [e]
  ), g = () => {
    d.current.clear(), u.current = !1;
  }, _ = ke(() => {
    if (window.SC && typeof window.SC.Widget == "function") {
      r(!0);
      return;
    }
    const f = document.createElement("script");
    f.src = "https://w.soundcloud.com/player/api.js", f.async = !0, f.onload = () => r(!0), f.onerror = () => {
      t({
        type: "error",
        base: h("SoundCloud Player", 0, 0),
        errorMessage: "Failed to load SoundCloud Widget API",
        trackingValue: "audioError"
      });
    }, document.body.appendChild(f);
  }, [h, t]), b = ke(() => {
    !s.current || u.current || (u.current = !0, s.current.getCurrentSound((f) => {
      f && (o(f.title), c(f.duration), t({
        type: "starting",
        base: h(f.title, f.duration, 0),
        trackingValue: "audioStart"
      }));
    }));
  }, [h, t]), E = ke(
    (f) => {
      const m = Math.round(f.relativePosition * 100);
      for (const v of en)
        m >= v && !d.current.has(v) && (d.current.add(v), t({
          type: "progress",
          base: h(a, l, v),
          trackingValue: "audioProgress"
        }));
    },
    [h, l, t, a]
  ), x = ke(() => {
    t({
      type: "completed",
      base: h(a, l, 100),
      trackingValue: "audioComplete"
    }), g();
  }, [h, l, t, a]);
  return F(() => {
    _();
  }, [_]), F(() => {
    n && i.current && (s.current = new window.SC.Widget(i.current));
  }, [n]), F(() => {
    const f = s.current;
    if (f)
      return f.bind(window.SC.Widget.Events.PLAY, b), f.bind(window.SC.Widget.Events.PLAY_PROGRESS, E), f.bind(window.SC.Widget.Events.FINISH, x), () => {
        f.unbind(window.SC.Widget.Events.PLAY, b), f.unbind(window.SC.Widget.Events.PLAY_PROGRESS, E), f.unbind(window.SC.Widget.Events.FINISH, x);
      };
  }, [b, E, x]), /* @__PURE__ */ p(
    "iframe",
    {
      ref: i,
      className: jt.podcast__iframe,
      title: "SoundCloud Player",
      src: e,
      width: "100%",
      allow: "autoplay",
      allowFullScreen: !0,
      loading: "lazy",
      seamless: !0
    }
  );
}, Ip = ({ src: e, provider: t, slot: i, onPodcastStateChange: s }) => {
  const n = H(null), r = Ds(n);
  return /* @__PURE__ */ I("div", { className: L(jt.podcast, `podcast--${t}`), slot: i, ref: n, children: [
    r && (t === "spotify-creators" || t === "spotify") && /* @__PURE__ */ p(kc, { src: e, onPodcastStateChange: s }),
    r && t === "soundcloud" && /* @__PURE__ */ p(Cc, { src: e, onPodcastStateChange: s }),
    t === "transistor" && /* @__PURE__ */ p(
      "iframe",
      {
        className: jt.podcast__iframe,
        title: "Podcast Player",
        src: e,
        width: "100%",
        seamless: !0,
        allow: "autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture",
        allowFullScreen: !0,
        loading: "lazy"
      }
    )
  ] });
}, Nc = {
  "published-date": "published-date"
}, Op = ({ publishedDate: e }) => /* @__PURE__ */ p("div", { className: Nc["published-date"], children: /* @__PURE__ */ p("time", { children: e }) }), Ic = "image", ze = {
  "roche-quote": "roche-quote",
  "roche-quote__image": "roche-quote__image",
  image: Ic,
  "roche-quote__content": "roche-quote__content",
  "roche-quote__text": "roche-quote__text",
  "roche-quote__text--small": "roche-quote__text--small",
  "roche-quote__subline": "roche-quote__subline",
  "roche-quote__link": "roche-quote__link",
  "roche-quote--with-image": "roche-quote--with-image",
  "roche-quote--equal-ratio": "roche-quote--equal-ratio"
};
var Ti = /* @__PURE__ */ ((e) => (e.BIG = "big", e.SMALL = "small", e))(Ti || {}), Ai = /* @__PURE__ */ ((e) => (e.WITH_IMAGE = "with-image", e.NORMAL = "normal", e))(Ai || {});
const Rp = ({
  quote: e,
  size: t = Ti.BIG,
  layout: i = Ai.NORMAL,
  isEqualRatio: s = !1,
  image: n,
  sublines: r,
  link: a
}) => {
  const o = i === Ai.WITH_IMAGE, l = t === Ti.SMALL, c = L(ze["roche-quote"], {
    [ze["roche-quote--with-image"]]: o,
    [ze["roche-quote--equal-ratio"]]: s
  }), d = L(ze["roche-quote__text"], {
    [ze["roche-quote__text--small"]]: l
  });
  return /* @__PURE__ */ I("figure", { className: c, children: [
    o && /* @__PURE__ */ p("div", { className: ze["roche-quote__image"], children: n }),
    /* @__PURE__ */ I("div", { className: ze["roche-quote__content"], children: [
      /* @__PURE__ */ p("blockquote", { children: /* @__PURE__ */ p("p", { className: d, children: e }) }),
      /* @__PURE__ */ I("figcaption", { children: [
        r && r.length > 0 && /* @__PURE__ */ p("div", { className: ze["roche-quote__subline"], children: r }),
        o && a && /* @__PURE__ */ p("div", { className: ze["roche-quote__link"], children: a })
      ] })
    ] })
  ] });
}, Oc = "grid__column", Rc = "gnw_table_border_collapse", Pc = "gnw_heading", Lc = "gnw_subhead", Dc = "gnw_colhead", zc = "gnw_colhead_uline", Vc = "gnw_colhead_dline", Bc = "gnw_label", $c = "gnw_label_uline", Hc = "gnw_label_uline_i10", Fc = "gnw_label_uline_i15", Gc = "gnw_label_uline_i20", qc = "gnw_label_uline_i25", jc = "gnw_label_uline_i30", Wc = "gnw_label_dline_i10", Uc = "gnw_label_dline_i15", Yc = "gnw_label_dline_i20", Xc = "gnw_label_dline_i25", Zc = "gnw_label_dline_i30", Kc = "gnw_label_ulinetop", Qc = "gnw_label_dline", Jc = "gnw_label_i10", ed = "gnw_label_i15", td = "gnw_label_i20", id = "gnw_label_i25", sd = "gnw_label_i30", nd = "gnw_num", rd = "gnw_num_uline", ad = "gnw_num_ulinetop", od = "gnw_num_dline", ld = "gnw_num_dlinetop", cd = "gnw_data", dd = "gnw_data_uline", ud = "gnw_data_dline", fd = "gnw_news_media_box", pd = "gnw_media_caption", hd = "gnw_media_bgcolor", md = "gnw_table", gd = "gnw_videotitle", vd = "gnw_border_top_solid", _d = "gnw_border_right_solid", wd = "gnw_border_bottom_solid", bd = "gnw_border_left_solid", yd = "gnw_border_top_double", Ed = "gnw_border_right_double", xd = "gnw_border_bottom_double", Sd = "gnw_border_left_double", Td = "gnw_align_left", Ad = "gnw_align_center", Md = "gnw_align_right", kd = "gnw_align_justify", Cd = "gnw_vertical_align_top", Nd = "gnw_vertical_align_middle", Id = "gnw_vertical_align_bottom", Od = "gnw_padding_left_none", Rd = "gnw_padding_right_none", Pd = "gnw_table_border_spacing", Ld = "gnw_release_detail_printview", Dd = "gnw_hidden_cell", zd = "hugin", Vd = "superscript", Bd = "subscript", $d = "headline", ui = {
  "no-print": "no-print",
  "print-grid-full-width": "print-grid-full-width",
  grid__column: Oc,
  "is-8": "is-8",
  "is-1": "is-1",
  "is-3": "is-3",
  "rich-text": "rich-text",
  gnw_table_border_collapse: Rc,
  gnw_heading: Pc,
  gnw_subhead: Lc,
  gnw_colhead: Dc,
  gnw_colhead_uline: zc,
  gnw_colhead_dline: Vc,
  gnw_label: Bc,
  gnw_label_uline: $c,
  gnw_label_uline_i10: Hc,
  gnw_label_uline_i15: Fc,
  gnw_label_uline_i20: Gc,
  gnw_label_uline_i25: qc,
  gnw_label_uline_i30: jc,
  gnw_label_dline_i10: Wc,
  gnw_label_dline_i15: Uc,
  gnw_label_dline_i20: Yc,
  gnw_label_dline_i25: Xc,
  gnw_label_dline_i30: Zc,
  gnw_label_ulinetop: Kc,
  gnw_label_dline: Qc,
  gnw_label_i10: Jc,
  gnw_label_i15: ed,
  gnw_label_i20: td,
  gnw_label_i25: id,
  gnw_label_i30: sd,
  gnw_num: nd,
  gnw_num_uline: rd,
  gnw_num_ulinetop: ad,
  gnw_num_dline: od,
  gnw_num_dlinetop: ld,
  gnw_data: cd,
  gnw_data_uline: dd,
  gnw_data_dline: ud,
  gnw_news_media_box: fd,
  gnw_media_caption: pd,
  gnw_media_bgcolor: hd,
  gnw_table: md,
  gnw_videotitle: gd,
  gnw_border_top_solid: vd,
  gnw_border_right_solid: _d,
  gnw_border_bottom_solid: wd,
  gnw_border_left_solid: bd,
  gnw_border_top_double: yd,
  gnw_border_right_double: Ed,
  gnw_border_bottom_double: xd,
  gnw_border_left_double: Sd,
  gnw_align_left: Td,
  gnw_align_center: Ad,
  gnw_align_right: Md,
  gnw_align_justify: kd,
  gnw_vertical_align_top: Cd,
  gnw_vertical_align_middle: Nd,
  gnw_vertical_align_bottom: Id,
  gnw_padding_left_none: Od,
  gnw_padding_right_none: Rd,
  gnw_table_border_spacing: Pd,
  gnw_release_detail_printview: Ld,
  "logo-area_printview": "logo-area_printview",
  gnw_hidden_cell: Dd,
  "rich-text--is-footnote": "rich-text--is-footnote",
  "text-link": "text-link",
  "text-link__link": "text-link__link",
  "text-link__icon-container": "text-link__icon-container",
  "rich-text--is-footer-type": "rich-text--is-footer-type",
  hugin: zd,
  superscript: Vd,
  subscript: Bd,
  headline: $d,
  "icon-container": "icon-container"
}, Pp = ({
  children: e,
  isFootnote: t,
  isFooterType: i,
  markup: s,
  slot: n,
  dir: r
}) => {
  const a = {
    ...s && { dangerouslySetInnerHTML: { __html: s } }
  };
  return /* @__PURE__ */ p(
    "div",
    {
      slot: n,
      dir: r,
      ...a,
      className: L(
        ui["rich-text"],
        t && ui["rich-text--is-footnote"],
        i && ui["rich-text--is-footer-type"]
      ),
      children: e
    }
  );
};
var zt = /* @__PURE__ */ ((e) => (e.LEFT = "left", e.RIGHT = "right", e.SPACE_BETWEEN = "space-between", e))(zt || {}), Vt = /* @__PURE__ */ ((e) => (e.TOP = "top", e.MIDDLE = "middle", e.BOTTOM = "bottom", e))(Vt || {});
const at = {
  "side-by-side": "side-by-side",
  "side-by-side--right": "side-by-side--right",
  "side-by-side--space-between": "side-by-side--space-between",
  "side-by-side--top": "side-by-side--top",
  "side-by-side--bottom": "side-by-side--bottom",
  "side-by-side--equal-ratio": "side-by-side--equal-ratio"
}, Lp = ({
  horizontalAlignment: e = zt.LEFT,
  verticalAlignment: t = Vt.MIDDLE,
  equalRatio: i = !1,
  children: s
}) => {
  const n = L(
    at["side-by-side"],
    e === zt.RIGHT && at["side-by-side--right"],
    e === zt.SPACE_BETWEEN && at["side-by-side--space-between"],
    t === Vt.TOP && at["side-by-side--top"],
    t === Vt.BOTTOM && at["side-by-side--bottom"],
    i && at["side-by-side--equal-ratio"]
  );
  return /* @__PURE__ */ p("div", { className: n, children: s });
}, Hd = "swiper", Fd = "teaser", Gd = "swiper__controls", Ve = {
  swiper: Hd,
  "swiper-slide": "swiper-slide",
  teaser: Fd,
  "swiper-pagination": "swiper-pagination",
  "swiper-pagination-current": "swiper-pagination-current",
  "swiper-pagination-total": "swiper-pagination-total",
  "swiper-pagination-fraction": "swiper-pagination-fraction",
  "swiper__button-next-custom": "swiper__button-next-custom",
  "swiper__button-prev-custom": "swiper__button-prev-custom",
  "swiper__button-icon-custom": "swiper__button-icon-custom",
  "swiper__button--disabled": "swiper__button--disabled",
  swiper__controls: Gd,
  "swiper__controls-wrapper": "swiper__controls-wrapper",
  "swiper__controls-wrapper--navigation-hidden": "swiper__controls-wrapper--navigation-hidden"
};
function Es(e) {
  return e !== null && typeof e == "object" && "constructor" in e && e.constructor === Object;
}
function Fi(e, t) {
  e === void 0 && (e = {}), t === void 0 && (t = {});
  const i = ["__proto__", "constructor", "prototype"];
  Object.keys(t).filter((s) => i.indexOf(s) < 0).forEach((s) => {
    typeof e[s] > "u" ? e[s] = t[s] : Es(t[s]) && Es(e[s]) && Object.keys(t[s]).length > 0 && Fi(e[s], t[s]);
  });
}
const tn = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function He() {
  const e = typeof document < "u" ? document : {};
  return Fi(e, tn), e;
}
const qd = {
  document: tn,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(e) {
    return typeof setTimeout > "u" ? (e(), null) : setTimeout(e, 0);
  },
  cancelAnimationFrame(e) {
    typeof setTimeout > "u" || clearTimeout(e);
  }
};
function oe() {
  const e = typeof window < "u" ? window : {};
  return Fi(e, qd), e;
}
function jd(e) {
  return e === void 0 && (e = ""), e.trim().split(" ").filter((t) => !!t.trim());
}
function Wd(e) {
  const t = e;
  Object.keys(t).forEach((i) => {
    try {
      t[i] = null;
    } catch {
    }
    try {
      delete t[i];
    } catch {
    }
  });
}
function Mi(e, t) {
  return t === void 0 && (t = 0), setTimeout(e, t);
}
function Wt() {
  return Date.now();
}
function Ud(e) {
  const t = oe();
  let i;
  return t.getComputedStyle && (i = t.getComputedStyle(e, null)), !i && e.currentStyle && (i = e.currentStyle), i || (i = e.style), i;
}
function Yd(e, t) {
  t === void 0 && (t = "x");
  const i = oe();
  let s, n, r;
  const a = Ud(e);
  return i.WebKitCSSMatrix ? (n = a.transform || a.webkitTransform, n.split(",").length > 6 && (n = n.split(", ").map((o) => o.replace(",", ".")).join(", ")), r = new i.WebKitCSSMatrix(n === "none" ? "" : n)) : (r = a.MozTransform || a.OTransform || a.MsTransform || a.msTransform || a.transform || a.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), s = r.toString().split(",")), t === "x" && (i.WebKitCSSMatrix ? n = r.m41 : s.length === 16 ? n = parseFloat(s[12]) : n = parseFloat(s[4])), t === "y" && (i.WebKitCSSMatrix ? n = r.m42 : s.length === 16 ? n = parseFloat(s[13]) : n = parseFloat(s[5])), n || 0;
}
function Rt(e) {
  return typeof e == "object" && e !== null && e.constructor && Object.prototype.toString.call(e).slice(8, -1) === "Object";
}
function Xd(e) {
  return typeof window < "u" && typeof window.HTMLElement < "u" ? e instanceof HTMLElement : e && (e.nodeType === 1 || e.nodeType === 11);
}
function he() {
  const e = Object(arguments.length <= 0 ? void 0 : arguments[0]), t = ["__proto__", "constructor", "prototype"];
  for (let i = 1; i < arguments.length; i += 1) {
    const s = i < 0 || arguments.length <= i ? void 0 : arguments[i];
    if (s != null && !Xd(s)) {
      const n = Object.keys(Object(s)).filter((r) => t.indexOf(r) < 0);
      for (let r = 0, a = n.length; r < a; r += 1) {
        const o = n[r], l = Object.getOwnPropertyDescriptor(s, o);
        l !== void 0 && l.enumerable && (Rt(e[o]) && Rt(s[o]) ? s[o].__swiper__ ? e[o] = s[o] : he(e[o], s[o]) : !Rt(e[o]) && Rt(s[o]) ? (e[o] = {}, s[o].__swiper__ ? e[o] = s[o] : he(e[o], s[o])) : e[o] = s[o]);
      }
    }
  }
  return e;
}
function Pt(e, t, i) {
  e.style.setProperty(t, i);
}
function sn(e) {
  let {
    swiper: t,
    targetPosition: i,
    side: s
  } = e;
  const n = oe(), r = -t.translate;
  let a = null, o;
  const l = t.params.speed;
  t.wrapperEl.style.scrollSnapType = "none", n.cancelAnimationFrame(t.cssModeFrameID);
  const c = i > r ? "next" : "prev", d = (h, g) => c === "next" && h >= g || c === "prev" && h <= g, u = () => {
    o = (/* @__PURE__ */ new Date()).getTime(), a === null && (a = o);
    const h = Math.max(Math.min((o - a) / l, 1), 0), g = 0.5 - Math.cos(h * Math.PI) / 2;
    let _ = r + g * (i - r);
    if (d(_, i) && (_ = i), t.wrapperEl.scrollTo({
      [s]: _
    }), d(_, i)) {
      t.wrapperEl.style.overflow = "hidden", t.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
        t.wrapperEl.style.overflow = "", t.wrapperEl.scrollTo({
          [s]: _
        });
      }), n.cancelAnimationFrame(t.cssModeFrameID);
      return;
    }
    t.cssModeFrameID = n.requestAnimationFrame(u);
  };
  u();
}
function nn(e) {
  return e.querySelector(".swiper-slide-transform") || e.shadowRoot && e.shadowRoot.querySelector(".swiper-slide-transform") || e;
}
function Ce(e, t) {
  t === void 0 && (t = "");
  const i = oe(), s = [...e.children];
  return i.HTMLSlotElement && e instanceof HTMLSlotElement && s.push(...e.assignedElements()), t ? s.filter((n) => n.matches(t)) : s;
}
function Zd(e, t) {
  const i = [t];
  for (; i.length > 0; ) {
    const s = i.shift();
    if (e === s)
      return !0;
    i.push(...s.children, ...s.shadowRoot ? s.shadowRoot.children : [], ...s.assignedElements ? s.assignedElements() : []);
  }
}
function Kd(e, t) {
  const i = oe();
  let s = t.contains(e);
  return !s && i.HTMLSlotElement && t instanceof HTMLSlotElement && (s = [...t.assignedElements()].includes(e), s || (s = Zd(e, t))), s;
}
function Ut(e) {
  try {
    console.warn(e);
    return;
  } catch {
  }
}
function xt(e, t) {
  t === void 0 && (t = []);
  const i = document.createElement(e);
  return i.classList.add(...Array.isArray(t) ? t : jd(t)), i;
}
function Qd(e, t) {
  const i = [];
  for (; e.previousElementSibling; ) {
    const s = e.previousElementSibling;
    t ? s.matches(t) && i.push(s) : i.push(s), e = s;
  }
  return i;
}
function Jd(e, t) {
  const i = [];
  for (; e.nextElementSibling; ) {
    const s = e.nextElementSibling;
    t ? s.matches(t) && i.push(s) : i.push(s), e = s;
  }
  return i;
}
function We(e, t) {
  return oe().getComputedStyle(e, null).getPropertyValue(t);
}
function St(e) {
  let t = e, i;
  if (t) {
    for (i = 0; (t = t.previousSibling) !== null; )
      t.nodeType === 1 && (i += 1);
    return i;
  }
}
function rn(e, t) {
  const i = [];
  let s = e.parentElement;
  for (; s; )
    t ? s.matches(t) && i.push(s) : i.push(s), s = s.parentElement;
  return i;
}
function eu(e, t) {
  function i(s) {
    s.target === e && (t.call(e, s), e.removeEventListener("transitionend", i));
  }
  t && e.addEventListener("transitionend", i);
}
function ki(e, t, i) {
  const s = oe();
  return e[t === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(s.getComputedStyle(e, null).getPropertyValue(t === "width" ? "margin-right" : "margin-top")) + parseFloat(s.getComputedStyle(e, null).getPropertyValue(t === "width" ? "margin-left" : "margin-bottom"));
}
function U(e) {
  return (Array.isArray(e) ? e : [e]).filter((t) => !!t);
}
function Ci(e, t) {
  t === void 0 && (t = ""), typeof trustedTypes < "u" ? e.innerHTML = trustedTypes.createPolicy("html", {
    createHTML: (i) => i
  }).createHTML(t) : e.innerHTML = t;
}
let fi;
function tu() {
  const e = oe(), t = He();
  return {
    smoothScroll: t.documentElement && t.documentElement.style && "scrollBehavior" in t.documentElement.style,
    touch: !!("ontouchstart" in e || e.DocumentTouch && t instanceof e.DocumentTouch)
  };
}
function an() {
  return fi || (fi = tu()), fi;
}
let pi;
function iu(e) {
  let {
    userAgent: t
  } = e === void 0 ? {} : e;
  const i = an(), s = oe(), n = s.navigator.platform, r = t || s.navigator.userAgent, a = {
    ios: !1,
    android: !1
  }, o = s.screen.width, l = s.screen.height, c = r.match(/(Android);?[\s\/]+([\d.]+)?/);
  let d = r.match(/(iPad).*OS\s([\d_]+)/);
  const u = r.match(/(iPod)(.*OS\s([\d_]+))?/), h = !d && r.match(/(iPhone\sOS|iOS)\s([\d_]+)/), g = n === "Win32";
  let _ = n === "MacIntel";
  const b = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  return !d && _ && i.touch && b.indexOf(`${o}x${l}`) >= 0 && (d = r.match(/(Version)\/([\d.]+)/), d || (d = [0, 1, "13_0_0"]), _ = !1), c && !g && (a.os = "android", a.android = !0), (d || h || u) && (a.os = "ios", a.ios = !0), a;
}
function on(e) {
  return e === void 0 && (e = {}), pi || (pi = iu(e)), pi;
}
let hi;
function su() {
  const e = oe(), t = on();
  let i = !1;
  function s() {
    const o = e.navigator.userAgent.toLowerCase();
    return o.indexOf("safari") >= 0 && o.indexOf("chrome") < 0 && o.indexOf("android") < 0;
  }
  if (s()) {
    const o = String(e.navigator.userAgent);
    if (o.includes("Version/")) {
      const [l, c] = o.split("Version/")[1].split(" ")[0].split(".").map((d) => Number(d));
      i = l < 16 || l === 16 && c < 2;
    }
  }
  const n = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent), r = s(), a = r || n && t.ios;
  return {
    isSafari: i || r,
    needPerspectiveFix: i,
    need3dFix: a,
    isWebView: n
  };
}
function ln() {
  return hi || (hi = su()), hi;
}
function nu(e) {
  let {
    swiper: t,
    on: i,
    emit: s
  } = e;
  const n = oe();
  let r = null, a = null;
  const o = () => {
    !t || t.destroyed || !t.initialized || (s("beforeResize"), s("resize"));
  }, l = () => {
    !t || t.destroyed || !t.initialized || (r = new ResizeObserver((u) => {
      a = n.requestAnimationFrame(() => {
        const {
          width: h,
          height: g
        } = t;
        let _ = h, b = g;
        u.forEach((E) => {
          let {
            contentBoxSize: x,
            contentRect: f,
            target: m
          } = E;
          m && m !== t.el || (_ = f ? f.width : (x[0] || x).inlineSize, b = f ? f.height : (x[0] || x).blockSize);
        }), (_ !== h || b !== g) && o();
      });
    }), r.observe(t.el));
  }, c = () => {
    a && n.cancelAnimationFrame(a), r && r.unobserve && t.el && (r.unobserve(t.el), r = null);
  }, d = () => {
    !t || t.destroyed || !t.initialized || s("orientationchange");
  };
  i("init", () => {
    if (t.params.resizeObserver && typeof n.ResizeObserver < "u") {
      l();
      return;
    }
    n.addEventListener("resize", o), n.addEventListener("orientationchange", d);
  }), i("destroy", () => {
    c(), n.removeEventListener("resize", o), n.removeEventListener("orientationchange", d);
  });
}
function ru(e) {
  let {
    swiper: t,
    extendParams: i,
    on: s,
    emit: n
  } = e;
  const r = [], a = oe(), o = function(d, u) {
    u === void 0 && (u = {});
    const h = a.MutationObserver || a.WebkitMutationObserver, g = new h((_) => {
      if (t.__preventObserver__) return;
      if (_.length === 1) {
        n("observerUpdate", _[0]);
        return;
      }
      const b = function() {
        n("observerUpdate", _[0]);
      };
      a.requestAnimationFrame ? a.requestAnimationFrame(b) : a.setTimeout(b, 0);
    });
    g.observe(d, {
      attributes: typeof u.attributes > "u" ? !0 : u.attributes,
      childList: t.isElement || (typeof u.childList > "u" ? !0 : u).childList,
      characterData: typeof u.characterData > "u" ? !0 : u.characterData
    }), r.push(g);
  }, l = () => {
    if (t.params.observer) {
      if (t.params.observeParents) {
        const d = rn(t.hostEl);
        for (let u = 0; u < d.length; u += 1)
          o(d[u]);
      }
      o(t.hostEl, {
        childList: t.params.observeSlideChildren
      }), o(t.wrapperEl, {
        attributes: !1
      });
    }
  }, c = () => {
    r.forEach((d) => {
      d.disconnect();
    }), r.splice(0, r.length);
  };
  i({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), s("init", l), s("destroy", c);
}
var au = {
  on(e, t, i) {
    const s = this;
    if (!s.eventsListeners || s.destroyed || typeof t != "function") return s;
    const n = i ? "unshift" : "push";
    return e.split(" ").forEach((r) => {
      s.eventsListeners[r] || (s.eventsListeners[r] = []), s.eventsListeners[r][n](t);
    }), s;
  },
  once(e, t, i) {
    const s = this;
    if (!s.eventsListeners || s.destroyed || typeof t != "function") return s;
    function n() {
      s.off(e, n), n.__emitterProxy && delete n.__emitterProxy;
      for (var r = arguments.length, a = new Array(r), o = 0; o < r; o++)
        a[o] = arguments[o];
      t.apply(s, a);
    }
    return n.__emitterProxy = t, s.on(e, n, i);
  },
  onAny(e, t) {
    const i = this;
    if (!i.eventsListeners || i.destroyed || typeof e != "function") return i;
    const s = t ? "unshift" : "push";
    return i.eventsAnyListeners.indexOf(e) < 0 && i.eventsAnyListeners[s](e), i;
  },
  offAny(e) {
    const t = this;
    if (!t.eventsListeners || t.destroyed || !t.eventsAnyListeners) return t;
    const i = t.eventsAnyListeners.indexOf(e);
    return i >= 0 && t.eventsAnyListeners.splice(i, 1), t;
  },
  off(e, t) {
    const i = this;
    return !i.eventsListeners || i.destroyed || !i.eventsListeners || e.split(" ").forEach((s) => {
      typeof t > "u" ? i.eventsListeners[s] = [] : i.eventsListeners[s] && i.eventsListeners[s].forEach((n, r) => {
        (n === t || n.__emitterProxy && n.__emitterProxy === t) && i.eventsListeners[s].splice(r, 1);
      });
    }), i;
  },
  emit() {
    const e = this;
    if (!e.eventsListeners || e.destroyed || !e.eventsListeners) return e;
    let t, i, s;
    for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
      r[a] = arguments[a];
    return typeof r[0] == "string" || Array.isArray(r[0]) ? (t = r[0], i = r.slice(1, r.length), s = e) : (t = r[0].events, i = r[0].data, s = r[0].context || e), i.unshift(s), (Array.isArray(t) ? t : t.split(" ")).forEach((l) => {
      e.eventsAnyListeners && e.eventsAnyListeners.length && e.eventsAnyListeners.forEach((c) => {
        c.apply(s, [l, ...i]);
      }), e.eventsListeners && e.eventsListeners[l] && e.eventsListeners[l].forEach((c) => {
        c.apply(s, i);
      });
    }), e;
  }
};
function ou() {
  const e = this;
  let t, i;
  const s = e.el;
  typeof e.params.width < "u" && e.params.width !== null ? t = e.params.width : t = s.clientWidth, typeof e.params.height < "u" && e.params.height !== null ? i = e.params.height : i = s.clientHeight, !(t === 0 && e.isHorizontal() || i === 0 && e.isVertical()) && (t = t - parseInt(We(s, "padding-left") || 0, 10) - parseInt(We(s, "padding-right") || 0, 10), i = i - parseInt(We(s, "padding-top") || 0, 10) - parseInt(We(s, "padding-bottom") || 0, 10), Number.isNaN(t) && (t = 0), Number.isNaN(i) && (i = 0), Object.assign(e, {
    width: t,
    height: i,
    size: e.isHorizontal() ? t : i
  }));
}
function lu() {
  const e = this;
  function t(M, C) {
    return parseFloat(M.getPropertyValue(e.getDirectionLabel(C)) || 0);
  }
  const i = e.params, {
    wrapperEl: s,
    slidesEl: n,
    size: r,
    rtlTranslate: a,
    wrongRTL: o
  } = e, l = e.virtual && i.virtual.enabled, c = l ? e.virtual.slides.length : e.slides.length, d = Ce(n, `.${e.params.slideClass}, swiper-slide`), u = l ? e.virtual.slides.length : d.length;
  let h = [];
  const g = [], _ = [];
  let b = i.slidesOffsetBefore;
  typeof b == "function" && (b = i.slidesOffsetBefore.call(e));
  let E = i.slidesOffsetAfter;
  typeof E == "function" && (E = i.slidesOffsetAfter.call(e));
  const x = e.snapGrid.length, f = e.slidesGrid.length;
  let m = i.spaceBetween, v = -b, w = 0, y = 0;
  if (typeof r > "u")
    return;
  typeof m == "string" && m.indexOf("%") >= 0 ? m = parseFloat(m.replace("%", "")) / 100 * r : typeof m == "string" && (m = parseFloat(m)), e.virtualSize = -m, d.forEach((M) => {
    a ? M.style.marginLeft = "" : M.style.marginRight = "", M.style.marginBottom = "", M.style.marginTop = "";
  }), i.centeredSlides && i.cssMode && (Pt(s, "--swiper-centered-offset-before", ""), Pt(s, "--swiper-centered-offset-after", ""));
  const S = i.grid && i.grid.rows > 1 && e.grid;
  S ? e.grid.initSlides(d) : e.grid && e.grid.unsetSlides();
  let k;
  const O = i.slidesPerView === "auto" && i.breakpoints && Object.keys(i.breakpoints).filter((M) => typeof i.breakpoints[M].slidesPerView < "u").length > 0;
  for (let M = 0; M < u; M += 1) {
    k = 0;
    let C;
    if (d[M] && (C = d[M]), S && e.grid.updateSlide(M, C, d), !(d[M] && We(C, "display") === "none")) {
      if (i.slidesPerView === "auto") {
        O && (d[M].style[e.getDirectionLabel("width")] = "");
        const D = getComputedStyle(C), P = C.style.transform, $ = C.style.webkitTransform;
        if (P && (C.style.transform = "none"), $ && (C.style.webkitTransform = "none"), i.roundLengths)
          k = e.isHorizontal() ? ki(C, "width") : ki(C, "height");
        else {
          const B = t(D, "width"), R = t(D, "padding-left"), A = t(D, "padding-right"), N = t(D, "margin-left"), z = t(D, "margin-right"), G = D.getPropertyValue("box-sizing");
          if (G && G === "border-box")
            k = B + N + z;
          else {
            const {
              clientWidth: J,
              offsetWidth: X
            } = C;
            k = B + R + A + N + z + (X - J);
          }
        }
        P && (C.style.transform = P), $ && (C.style.webkitTransform = $), i.roundLengths && (k = Math.floor(k));
      } else
        k = (r - (i.slidesPerView - 1) * m) / i.slidesPerView, i.roundLengths && (k = Math.floor(k)), d[M] && (d[M].style[e.getDirectionLabel("width")] = `${k}px`);
      d[M] && (d[M].swiperSlideSize = k), _.push(k), i.centeredSlides ? (v = v + k / 2 + w / 2 + m, w === 0 && M !== 0 && (v = v - r / 2 - m), M === 0 && (v = v - r / 2 - m), Math.abs(v) < 1 / 1e3 && (v = 0), i.roundLengths && (v = Math.floor(v)), y % i.slidesPerGroup === 0 && h.push(v), g.push(v)) : (i.roundLengths && (v = Math.floor(v)), (y - Math.min(e.params.slidesPerGroupSkip, y)) % e.params.slidesPerGroup === 0 && h.push(v), g.push(v), v = v + k + m), e.virtualSize += k + m, w = k, y += 1;
    }
  }
  if (e.virtualSize = Math.max(e.virtualSize, r) + E, a && o && (i.effect === "slide" || i.effect === "coverflow") && (s.style.width = `${e.virtualSize + m}px`), i.setWrapperSize && (s.style[e.getDirectionLabel("width")] = `${e.virtualSize + m}px`), S && e.grid.updateWrapperSize(k, h), !i.centeredSlides) {
    const M = [];
    for (let C = 0; C < h.length; C += 1) {
      let D = h[C];
      i.roundLengths && (D = Math.floor(D)), h[C] <= e.virtualSize - r && M.push(D);
    }
    h = M, Math.floor(e.virtualSize - r) - Math.floor(h[h.length - 1]) > 1 && h.push(e.virtualSize - r);
  }
  if (l && i.loop) {
    const M = _[0] + m;
    if (i.slidesPerGroup > 1) {
      const C = Math.ceil((e.virtual.slidesBefore + e.virtual.slidesAfter) / i.slidesPerGroup), D = M * i.slidesPerGroup;
      for (let P = 0; P < C; P += 1)
        h.push(h[h.length - 1] + D);
    }
    for (let C = 0; C < e.virtual.slidesBefore + e.virtual.slidesAfter; C += 1)
      i.slidesPerGroup === 1 && h.push(h[h.length - 1] + M), g.push(g[g.length - 1] + M), e.virtualSize += M;
  }
  if (h.length === 0 && (h = [0]), m !== 0) {
    const M = e.isHorizontal() && a ? "marginLeft" : e.getDirectionLabel("marginRight");
    d.filter((C, D) => !i.cssMode || i.loop ? !0 : D !== d.length - 1).forEach((C) => {
      C.style[M] = `${m}px`;
    });
  }
  if (i.centeredSlides && i.centeredSlidesBounds) {
    let M = 0;
    _.forEach((D) => {
      M += D + (m || 0);
    }), M -= m;
    const C = M > r ? M - r : 0;
    h = h.map((D) => D <= 0 ? -b : D > C ? C + E : D);
  }
  if (i.centerInsufficientSlides) {
    let M = 0;
    _.forEach((D) => {
      M += D + (m || 0);
    }), M -= m;
    const C = (i.slidesOffsetBefore || 0) + (i.slidesOffsetAfter || 0);
    if (M + C < r) {
      const D = (r - M - C) / 2;
      h.forEach((P, $) => {
        h[$] = P - D;
      }), g.forEach((P, $) => {
        g[$] = P + D;
      });
    }
  }
  if (Object.assign(e, {
    slides: d,
    snapGrid: h,
    slidesGrid: g,
    slidesSizesGrid: _
  }), i.centeredSlides && i.cssMode && !i.centeredSlidesBounds) {
    Pt(s, "--swiper-centered-offset-before", `${-h[0]}px`), Pt(s, "--swiper-centered-offset-after", `${e.size / 2 - _[_.length - 1] / 2}px`);
    const M = -e.snapGrid[0], C = -e.slidesGrid[0];
    e.snapGrid = e.snapGrid.map((D) => D + M), e.slidesGrid = e.slidesGrid.map((D) => D + C);
  }
  if (u !== c && e.emit("slidesLengthChange"), h.length !== x && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")), g.length !== f && e.emit("slidesGridLengthChange"), i.watchSlidesProgress && e.updateSlidesOffset(), e.emit("slidesUpdated"), !l && !i.cssMode && (i.effect === "slide" || i.effect === "fade")) {
    const M = `${i.containerModifierClass}backface-hidden`, C = e.el.classList.contains(M);
    u <= i.maxBackfaceHiddenSlides ? C || e.el.classList.add(M) : C && e.el.classList.remove(M);
  }
}
function cu(e) {
  const t = this, i = [], s = t.virtual && t.params.virtual.enabled;
  let n = 0, r;
  typeof e == "number" ? t.setTransition(e) : e === !0 && t.setTransition(t.params.speed);
  const a = (o) => s ? t.slides[t.getSlideIndexByData(o)] : t.slides[o];
  if (t.params.slidesPerView !== "auto" && t.params.slidesPerView > 1)
    if (t.params.centeredSlides)
      (t.visibleSlides || []).forEach((o) => {
        i.push(o);
      });
    else
      for (r = 0; r < Math.ceil(t.params.slidesPerView); r += 1) {
        const o = t.activeIndex + r;
        if (o > t.slides.length && !s) break;
        i.push(a(o));
      }
  else
    i.push(a(t.activeIndex));
  for (r = 0; r < i.length; r += 1)
    if (typeof i[r] < "u") {
      const o = i[r].offsetHeight;
      n = o > n ? o : n;
    }
  (n || n === 0) && (t.wrapperEl.style.height = `${n}px`);
}
function du() {
  const e = this, t = e.slides, i = e.isElement ? e.isHorizontal() ? e.wrapperEl.offsetLeft : e.wrapperEl.offsetTop : 0;
  for (let s = 0; s < t.length; s += 1)
    t[s].swiperSlideOffset = (e.isHorizontal() ? t[s].offsetLeft : t[s].offsetTop) - i - e.cssOverflowAdjustment();
}
const xs = (e, t, i) => {
  t && !e.classList.contains(i) ? e.classList.add(i) : !t && e.classList.contains(i) && e.classList.remove(i);
};
function uu(e) {
  e === void 0 && (e = this && this.translate || 0);
  const t = this, i = t.params, {
    slides: s,
    rtlTranslate: n,
    snapGrid: r
  } = t;
  if (s.length === 0) return;
  typeof s[0].swiperSlideOffset > "u" && t.updateSlidesOffset();
  let a = -e;
  n && (a = e), t.visibleSlidesIndexes = [], t.visibleSlides = [];
  let o = i.spaceBetween;
  typeof o == "string" && o.indexOf("%") >= 0 ? o = parseFloat(o.replace("%", "")) / 100 * t.size : typeof o == "string" && (o = parseFloat(o));
  for (let l = 0; l < s.length; l += 1) {
    const c = s[l];
    let d = c.swiperSlideOffset;
    i.cssMode && i.centeredSlides && (d -= s[0].swiperSlideOffset);
    const u = (a + (i.centeredSlides ? t.minTranslate() : 0) - d) / (c.swiperSlideSize + o), h = (a - r[0] + (i.centeredSlides ? t.minTranslate() : 0) - d) / (c.swiperSlideSize + o), g = -(a - d), _ = g + t.slidesSizesGrid[l], b = g >= 0 && g <= t.size - t.slidesSizesGrid[l], E = g >= 0 && g < t.size - 1 || _ > 1 && _ <= t.size || g <= 0 && _ >= t.size;
    E && (t.visibleSlides.push(c), t.visibleSlidesIndexes.push(l)), xs(c, E, i.slideVisibleClass), xs(c, b, i.slideFullyVisibleClass), c.progress = n ? -u : u, c.originalProgress = n ? -h : h;
  }
}
function fu(e) {
  const t = this;
  if (typeof e > "u") {
    const d = t.rtlTranslate ? -1 : 1;
    e = t && t.translate && t.translate * d || 0;
  }
  const i = t.params, s = t.maxTranslate() - t.minTranslate();
  let {
    progress: n,
    isBeginning: r,
    isEnd: a,
    progressLoop: o
  } = t;
  const l = r, c = a;
  if (s === 0)
    n = 0, r = !0, a = !0;
  else {
    n = (e - t.minTranslate()) / s;
    const d = Math.abs(e - t.minTranslate()) < 1, u = Math.abs(e - t.maxTranslate()) < 1;
    r = d || n <= 0, a = u || n >= 1, d && (n = 0), u && (n = 1);
  }
  if (i.loop) {
    const d = t.getSlideIndexByData(0), u = t.getSlideIndexByData(t.slides.length - 1), h = t.slidesGrid[d], g = t.slidesGrid[u], _ = t.slidesGrid[t.slidesGrid.length - 1], b = Math.abs(e);
    b >= h ? o = (b - h) / _ : o = (b + _ - g) / _, o > 1 && (o -= 1);
  }
  Object.assign(t, {
    progress: n,
    progressLoop: o,
    isBeginning: r,
    isEnd: a
  }), (i.watchSlidesProgress || i.centeredSlides && i.autoHeight) && t.updateSlidesProgress(e), r && !l && t.emit("reachBeginning toEdge"), a && !c && t.emit("reachEnd toEdge"), (l && !r || c && !a) && t.emit("fromEdge"), t.emit("progress", n);
}
const mi = (e, t, i) => {
  t && !e.classList.contains(i) ? e.classList.add(i) : !t && e.classList.contains(i) && e.classList.remove(i);
};
function pu() {
  const e = this, {
    slides: t,
    params: i,
    slidesEl: s,
    activeIndex: n
  } = e, r = e.virtual && i.virtual.enabled, a = e.grid && i.grid && i.grid.rows > 1, o = (u) => Ce(s, `.${i.slideClass}${u}, swiper-slide${u}`)[0];
  let l, c, d;
  if (r)
    if (i.loop) {
      let u = n - e.virtual.slidesBefore;
      u < 0 && (u = e.virtual.slides.length + u), u >= e.virtual.slides.length && (u -= e.virtual.slides.length), l = o(`[data-swiper-slide-index="${u}"]`);
    } else
      l = o(`[data-swiper-slide-index="${n}"]`);
  else
    a ? (l = t.find((u) => u.column === n), d = t.find((u) => u.column === n + 1), c = t.find((u) => u.column === n - 1)) : l = t[n];
  l && (a || (d = Jd(l, `.${i.slideClass}, swiper-slide`)[0], i.loop && !d && (d = t[0]), c = Qd(l, `.${i.slideClass}, swiper-slide`)[0], i.loop && !c === 0 && (c = t[t.length - 1]))), t.forEach((u) => {
    mi(u, u === l, i.slideActiveClass), mi(u, u === d, i.slideNextClass), mi(u, u === c, i.slidePrevClass);
  }), e.emitSlidesClasses();
}
const Bt = (e, t) => {
  if (!e || e.destroyed || !e.params) return;
  const i = () => e.isElement ? "swiper-slide" : `.${e.params.slideClass}`, s = t.closest(i());
  if (s) {
    let n = s.querySelector(`.${e.params.lazyPreloaderClass}`);
    !n && e.isElement && (s.shadowRoot ? n = s.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`) : requestAnimationFrame(() => {
      s.shadowRoot && (n = s.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`), n && n.remove());
    })), n && n.remove();
  }
}, gi = (e, t) => {
  if (!e.slides[t]) return;
  const i = e.slides[t].querySelector('[loading="lazy"]');
  i && i.removeAttribute("loading");
}, Ni = (e) => {
  if (!e || e.destroyed || !e.params) return;
  let t = e.params.lazyPreloadPrevNext;
  const i = e.slides.length;
  if (!i || !t || t < 0) return;
  t = Math.min(t, i);
  const s = e.params.slidesPerView === "auto" ? e.slidesPerViewDynamic() : Math.ceil(e.params.slidesPerView), n = e.activeIndex;
  if (e.params.grid && e.params.grid.rows > 1) {
    const a = n, o = [a - t];
    o.push(...Array.from({
      length: t
    }).map((l, c) => a + s + c)), e.slides.forEach((l, c) => {
      o.includes(l.column) && gi(e, c);
    });
    return;
  }
  const r = n + s - 1;
  if (e.params.rewind || e.params.loop)
    for (let a = n - t; a <= r + t; a += 1) {
      const o = (a % i + i) % i;
      (o < n || o > r) && gi(e, o);
    }
  else
    for (let a = Math.max(n - t, 0); a <= Math.min(r + t, i - 1); a += 1)
      a !== n && (a > r || a < n) && gi(e, a);
};
function hu(e) {
  const {
    slidesGrid: t,
    params: i
  } = e, s = e.rtlTranslate ? e.translate : -e.translate;
  let n;
  for (let r = 0; r < t.length; r += 1)
    typeof t[r + 1] < "u" ? s >= t[r] && s < t[r + 1] - (t[r + 1] - t[r]) / 2 ? n = r : s >= t[r] && s < t[r + 1] && (n = r + 1) : s >= t[r] && (n = r);
  return i.normalizeSlideIndex && (n < 0 || typeof n > "u") && (n = 0), n;
}
function mu(e) {
  const t = this, i = t.rtlTranslate ? t.translate : -t.translate, {
    snapGrid: s,
    params: n,
    activeIndex: r,
    realIndex: a,
    snapIndex: o
  } = t;
  let l = e, c;
  const d = (g) => {
    let _ = g - t.virtual.slidesBefore;
    return _ < 0 && (_ = t.virtual.slides.length + _), _ >= t.virtual.slides.length && (_ -= t.virtual.slides.length), _;
  };
  if (typeof l > "u" && (l = hu(t)), s.indexOf(i) >= 0)
    c = s.indexOf(i);
  else {
    const g = Math.min(n.slidesPerGroupSkip, l);
    c = g + Math.floor((l - g) / n.slidesPerGroup);
  }
  if (c >= s.length && (c = s.length - 1), l === r && !t.params.loop) {
    c !== o && (t.snapIndex = c, t.emit("snapIndexChange"));
    return;
  }
  if (l === r && t.params.loop && t.virtual && t.params.virtual.enabled) {
    t.realIndex = d(l);
    return;
  }
  const u = t.grid && n.grid && n.grid.rows > 1;
  let h;
  if (t.virtual && n.virtual.enabled && n.loop)
    h = d(l);
  else if (u) {
    const g = t.slides.find((b) => b.column === l);
    let _ = parseInt(g.getAttribute("data-swiper-slide-index"), 10);
    Number.isNaN(_) && (_ = Math.max(t.slides.indexOf(g), 0)), h = Math.floor(_ / n.grid.rows);
  } else if (t.slides[l]) {
    const g = t.slides[l].getAttribute("data-swiper-slide-index");
    g ? h = parseInt(g, 10) : h = l;
  } else
    h = l;
  Object.assign(t, {
    previousSnapIndex: o,
    snapIndex: c,
    previousRealIndex: a,
    realIndex: h,
    previousIndex: r,
    activeIndex: l
  }), t.initialized && Ni(t), t.emit("activeIndexChange"), t.emit("snapIndexChange"), (t.initialized || t.params.runCallbacksOnInit) && (a !== h && t.emit("realIndexChange"), t.emit("slideChange"));
}
function gu(e, t) {
  const i = this, s = i.params;
  let n = e.closest(`.${s.slideClass}, swiper-slide`);
  !n && i.isElement && t && t.length > 1 && t.includes(e) && [...t.slice(t.indexOf(e) + 1, t.length)].forEach((o) => {
    !n && o.matches && o.matches(`.${s.slideClass}, swiper-slide`) && (n = o);
  });
  let r = !1, a;
  if (n) {
    for (let o = 0; o < i.slides.length; o += 1)
      if (i.slides[o] === n) {
        r = !0, a = o;
        break;
      }
  }
  if (n && r)
    i.clickedSlide = n, i.virtual && i.params.virtual.enabled ? i.clickedIndex = parseInt(n.getAttribute("data-swiper-slide-index"), 10) : i.clickedIndex = a;
  else {
    i.clickedSlide = void 0, i.clickedIndex = void 0;
    return;
  }
  s.slideToClickedSlide && i.clickedIndex !== void 0 && i.clickedIndex !== i.activeIndex && i.slideToClickedSlide();
}
var vu = {
  updateSize: ou,
  updateSlides: lu,
  updateAutoHeight: cu,
  updateSlidesOffset: du,
  updateSlidesProgress: uu,
  updateProgress: fu,
  updateSlidesClasses: pu,
  updateActiveIndex: mu,
  updateClickedSlide: gu
};
function _u(e) {
  e === void 0 && (e = this.isHorizontal() ? "x" : "y");
  const t = this, {
    params: i,
    rtlTranslate: s,
    translate: n,
    wrapperEl: r
  } = t;
  if (i.virtualTranslate)
    return s ? -n : n;
  if (i.cssMode)
    return n;
  let a = Yd(r, e);
  return a += t.cssOverflowAdjustment(), s && (a = -a), a || 0;
}
function wu(e, t) {
  const i = this, {
    rtlTranslate: s,
    params: n,
    wrapperEl: r,
    progress: a
  } = i;
  let o = 0, l = 0;
  const c = 0;
  i.isHorizontal() ? o = s ? -e : e : l = e, n.roundLengths && (o = Math.floor(o), l = Math.floor(l)), i.previousTranslate = i.translate, i.translate = i.isHorizontal() ? o : l, n.cssMode ? r[i.isHorizontal() ? "scrollLeft" : "scrollTop"] = i.isHorizontal() ? -o : -l : n.virtualTranslate || (i.isHorizontal() ? o -= i.cssOverflowAdjustment() : l -= i.cssOverflowAdjustment(), r.style.transform = `translate3d(${o}px, ${l}px, ${c}px)`);
  let d;
  const u = i.maxTranslate() - i.minTranslate();
  u === 0 ? d = 0 : d = (e - i.minTranslate()) / u, d !== a && i.updateProgress(e), i.emit("setTranslate", i.translate, t);
}
function bu() {
  return -this.snapGrid[0];
}
function yu() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function Eu(e, t, i, s, n) {
  e === void 0 && (e = 0), t === void 0 && (t = this.params.speed), i === void 0 && (i = !0), s === void 0 && (s = !0);
  const r = this, {
    params: a,
    wrapperEl: o
  } = r;
  if (r.animating && a.preventInteractionOnTransition)
    return !1;
  const l = r.minTranslate(), c = r.maxTranslate();
  let d;
  if (s && e > l ? d = l : s && e < c ? d = c : d = e, r.updateProgress(d), a.cssMode) {
    const u = r.isHorizontal();
    if (t === 0)
      o[u ? "scrollLeft" : "scrollTop"] = -d;
    else {
      if (!r.support.smoothScroll)
        return sn({
          swiper: r,
          targetPosition: -d,
          side: u ? "left" : "top"
        }), !0;
      o.scrollTo({
        [u ? "left" : "top"]: -d,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return t === 0 ? (r.setTransition(0), r.setTranslate(d), i && (r.emit("beforeTransitionStart", t, n), r.emit("transitionEnd"))) : (r.setTransition(t), r.setTranslate(d), i && (r.emit("beforeTransitionStart", t, n), r.emit("transitionStart")), r.animating || (r.animating = !0, r.onTranslateToWrapperTransitionEnd || (r.onTranslateToWrapperTransitionEnd = function(h) {
    !r || r.destroyed || h.target === this && (r.wrapperEl.removeEventListener("transitionend", r.onTranslateToWrapperTransitionEnd), r.onTranslateToWrapperTransitionEnd = null, delete r.onTranslateToWrapperTransitionEnd, r.animating = !1, i && r.emit("transitionEnd"));
  }), r.wrapperEl.addEventListener("transitionend", r.onTranslateToWrapperTransitionEnd))), !0;
}
var xu = {
  getTranslate: _u,
  setTranslate: wu,
  minTranslate: bu,
  maxTranslate: yu,
  translateTo: Eu
};
function Su(e, t) {
  const i = this;
  i.params.cssMode || (i.wrapperEl.style.transitionDuration = `${e}ms`, i.wrapperEl.style.transitionDelay = e === 0 ? "0ms" : ""), i.emit("setTransition", e, t);
}
function cn(e) {
  let {
    swiper: t,
    runCallbacks: i,
    direction: s,
    step: n
  } = e;
  const {
    activeIndex: r,
    previousIndex: a
  } = t;
  let o = s;
  o || (r > a ? o = "next" : r < a ? o = "prev" : o = "reset"), t.emit(`transition${n}`), i && o === "reset" ? t.emit(`slideResetTransition${n}`) : i && r !== a && (t.emit(`slideChangeTransition${n}`), o === "next" ? t.emit(`slideNextTransition${n}`) : t.emit(`slidePrevTransition${n}`));
}
function Tu(e, t) {
  e === void 0 && (e = !0);
  const i = this, {
    params: s
  } = i;
  s.cssMode || (s.autoHeight && i.updateAutoHeight(), cn({
    swiper: i,
    runCallbacks: e,
    direction: t,
    step: "Start"
  }));
}
function Au(e, t) {
  e === void 0 && (e = !0);
  const i = this, {
    params: s
  } = i;
  i.animating = !1, !s.cssMode && (i.setTransition(0), cn({
    swiper: i,
    runCallbacks: e,
    direction: t,
    step: "End"
  }));
}
var Mu = {
  setTransition: Su,
  transitionStart: Tu,
  transitionEnd: Au
};
function ku(e, t, i, s, n) {
  e === void 0 && (e = 0), i === void 0 && (i = !0), typeof e == "string" && (e = parseInt(e, 10));
  const r = this;
  let a = e;
  a < 0 && (a = 0);
  const {
    params: o,
    snapGrid: l,
    slidesGrid: c,
    previousIndex: d,
    activeIndex: u,
    rtlTranslate: h,
    wrapperEl: g,
    enabled: _
  } = r;
  if (!_ && !s && !n || r.destroyed || r.animating && o.preventInteractionOnTransition)
    return !1;
  typeof t > "u" && (t = r.params.speed);
  const b = Math.min(r.params.slidesPerGroupSkip, a);
  let E = b + Math.floor((a - b) / r.params.slidesPerGroup);
  E >= l.length && (E = l.length - 1);
  const x = -l[E];
  if (o.normalizeSlideIndex)
    for (let S = 0; S < c.length; S += 1) {
      const k = -Math.floor(x * 100), O = Math.floor(c[S] * 100), M = Math.floor(c[S + 1] * 100);
      typeof c[S + 1] < "u" ? k >= O && k < M - (M - O) / 2 ? a = S : k >= O && k < M && (a = S + 1) : k >= O && (a = S);
    }
  if (r.initialized && a !== u && (!r.allowSlideNext && (h ? x > r.translate && x > r.minTranslate() : x < r.translate && x < r.minTranslate()) || !r.allowSlidePrev && x > r.translate && x > r.maxTranslate() && (u || 0) !== a))
    return !1;
  a !== (d || 0) && i && r.emit("beforeSlideChangeStart"), r.updateProgress(x);
  let f;
  a > u ? f = "next" : a < u ? f = "prev" : f = "reset";
  const m = r.virtual && r.params.virtual.enabled;
  if (!(m && n) && (h && -x === r.translate || !h && x === r.translate))
    return r.updateActiveIndex(a), o.autoHeight && r.updateAutoHeight(), r.updateSlidesClasses(), o.effect !== "slide" && r.setTranslate(x), f !== "reset" && (r.transitionStart(i, f), r.transitionEnd(i, f)), !1;
  if (o.cssMode) {
    const S = r.isHorizontal(), k = h ? x : -x;
    if (t === 0)
      m && (r.wrapperEl.style.scrollSnapType = "none", r._immediateVirtual = !0), m && !r._cssModeVirtualInitialSet && r.params.initialSlide > 0 ? (r._cssModeVirtualInitialSet = !0, requestAnimationFrame(() => {
        g[S ? "scrollLeft" : "scrollTop"] = k;
      })) : g[S ? "scrollLeft" : "scrollTop"] = k, m && requestAnimationFrame(() => {
        r.wrapperEl.style.scrollSnapType = "", r._immediateVirtual = !1;
      });
    else {
      if (!r.support.smoothScroll)
        return sn({
          swiper: r,
          targetPosition: k,
          side: S ? "left" : "top"
        }), !0;
      g.scrollTo({
        [S ? "left" : "top"]: k,
        behavior: "smooth"
      });
    }
    return !0;
  }
  const y = ln().isSafari;
  return m && !n && y && r.isElement && r.virtual.update(!1, !1, a), r.setTransition(t), r.setTranslate(x), r.updateActiveIndex(a), r.updateSlidesClasses(), r.emit("beforeTransitionStart", t, s), r.transitionStart(i, f), t === 0 ? r.transitionEnd(i, f) : r.animating || (r.animating = !0, r.onSlideToWrapperTransitionEnd || (r.onSlideToWrapperTransitionEnd = function(k) {
    !r || r.destroyed || k.target === this && (r.wrapperEl.removeEventListener("transitionend", r.onSlideToWrapperTransitionEnd), r.onSlideToWrapperTransitionEnd = null, delete r.onSlideToWrapperTransitionEnd, r.transitionEnd(i, f));
  }), r.wrapperEl.addEventListener("transitionend", r.onSlideToWrapperTransitionEnd)), !0;
}
function Cu(e, t, i, s) {
  e === void 0 && (e = 0), i === void 0 && (i = !0), typeof e == "string" && (e = parseInt(e, 10));
  const n = this;
  if (n.destroyed) return;
  typeof t > "u" && (t = n.params.speed);
  const r = n.grid && n.params.grid && n.params.grid.rows > 1;
  let a = e;
  if (n.params.loop)
    if (n.virtual && n.params.virtual.enabled)
      a = a + n.virtual.slidesBefore;
    else {
      let o;
      if (r) {
        const h = a * n.params.grid.rows;
        o = n.slides.find((g) => g.getAttribute("data-swiper-slide-index") * 1 === h).column;
      } else
        o = n.getSlideIndexByData(a);
      const l = r ? Math.ceil(n.slides.length / n.params.grid.rows) : n.slides.length, {
        centeredSlides: c
      } = n.params;
      let d = n.params.slidesPerView;
      d === "auto" ? d = n.slidesPerViewDynamic() : (d = Math.ceil(parseFloat(n.params.slidesPerView, 10)), c && d % 2 === 0 && (d = d + 1));
      let u = l - o < d;
      if (c && (u = u || o < Math.ceil(d / 2)), s && c && n.params.slidesPerView !== "auto" && !r && (u = !1), u) {
        const h = c ? o < n.activeIndex ? "prev" : "next" : o - n.activeIndex - 1 < n.params.slidesPerView ? "next" : "prev";
        n.loopFix({
          direction: h,
          slideTo: !0,
          activeSlideIndex: h === "next" ? o + 1 : o - l + 1,
          slideRealIndex: h === "next" ? n.realIndex : void 0
        });
      }
      if (r) {
        const h = a * n.params.grid.rows;
        a = n.slides.find((g) => g.getAttribute("data-swiper-slide-index") * 1 === h).column;
      } else
        a = n.getSlideIndexByData(a);
    }
  return requestAnimationFrame(() => {
    n.slideTo(a, t, i, s);
  }), n;
}
function Nu(e, t, i) {
  t === void 0 && (t = !0);
  const s = this, {
    enabled: n,
    params: r,
    animating: a
  } = s;
  if (!n || s.destroyed) return s;
  typeof e > "u" && (e = s.params.speed);
  let o = r.slidesPerGroup;
  r.slidesPerView === "auto" && r.slidesPerGroup === 1 && r.slidesPerGroupAuto && (o = Math.max(s.slidesPerViewDynamic("current", !0), 1));
  const l = s.activeIndex < r.slidesPerGroupSkip ? 1 : o, c = s.virtual && r.virtual.enabled;
  if (r.loop) {
    if (a && !c && r.loopPreventsSliding) return !1;
    if (s.loopFix({
      direction: "next"
    }), s._clientLeft = s.wrapperEl.clientLeft, s.activeIndex === s.slides.length - 1 && r.cssMode)
      return requestAnimationFrame(() => {
        s.slideTo(s.activeIndex + l, e, t, i);
      }), !0;
  }
  return r.rewind && s.isEnd ? s.slideTo(0, e, t, i) : s.slideTo(s.activeIndex + l, e, t, i);
}
function Iu(e, t, i) {
  t === void 0 && (t = !0);
  const s = this, {
    params: n,
    snapGrid: r,
    slidesGrid: a,
    rtlTranslate: o,
    enabled: l,
    animating: c
  } = s;
  if (!l || s.destroyed) return s;
  typeof e > "u" && (e = s.params.speed);
  const d = s.virtual && n.virtual.enabled;
  if (n.loop) {
    if (c && !d && n.loopPreventsSliding) return !1;
    s.loopFix({
      direction: "prev"
    }), s._clientLeft = s.wrapperEl.clientLeft;
  }
  const u = o ? s.translate : -s.translate;
  function h(f) {
    return f < 0 ? -Math.floor(Math.abs(f)) : Math.floor(f);
  }
  const g = h(u), _ = r.map((f) => h(f)), b = n.freeMode && n.freeMode.enabled;
  let E = r[_.indexOf(g) - 1];
  if (typeof E > "u" && (n.cssMode || b)) {
    let f;
    r.forEach((m, v) => {
      g >= m && (f = v);
    }), typeof f < "u" && (E = b ? r[f] : r[f > 0 ? f - 1 : f]);
  }
  let x = 0;
  if (typeof E < "u" && (x = a.indexOf(E), x < 0 && (x = s.activeIndex - 1), n.slidesPerView === "auto" && n.slidesPerGroup === 1 && n.slidesPerGroupAuto && (x = x - s.slidesPerViewDynamic("previous", !0) + 1, x = Math.max(x, 0))), n.rewind && s.isBeginning) {
    const f = s.params.virtual && s.params.virtual.enabled && s.virtual ? s.virtual.slides.length - 1 : s.slides.length - 1;
    return s.slideTo(f, e, t, i);
  } else if (n.loop && s.activeIndex === 0 && n.cssMode)
    return requestAnimationFrame(() => {
      s.slideTo(x, e, t, i);
    }), !0;
  return s.slideTo(x, e, t, i);
}
function Ou(e, t, i) {
  t === void 0 && (t = !0);
  const s = this;
  if (!s.destroyed)
    return typeof e > "u" && (e = s.params.speed), s.slideTo(s.activeIndex, e, t, i);
}
function Ru(e, t, i, s) {
  t === void 0 && (t = !0), s === void 0 && (s = 0.5);
  const n = this;
  if (n.destroyed) return;
  typeof e > "u" && (e = n.params.speed);
  let r = n.activeIndex;
  const a = Math.min(n.params.slidesPerGroupSkip, r), o = a + Math.floor((r - a) / n.params.slidesPerGroup), l = n.rtlTranslate ? n.translate : -n.translate;
  if (l >= n.snapGrid[o]) {
    const c = n.snapGrid[o], d = n.snapGrid[o + 1];
    l - c > (d - c) * s && (r += n.params.slidesPerGroup);
  } else {
    const c = n.snapGrid[o - 1], d = n.snapGrid[o];
    l - c <= (d - c) * s && (r -= n.params.slidesPerGroup);
  }
  return r = Math.max(r, 0), r = Math.min(r, n.slidesGrid.length - 1), n.slideTo(r, e, t, i);
}
function Pu() {
  const e = this;
  if (e.destroyed) return;
  const {
    params: t,
    slidesEl: i
  } = e, s = t.slidesPerView === "auto" ? e.slidesPerViewDynamic() : t.slidesPerView;
  let n = e.clickedIndex, r;
  const a = e.isElement ? "swiper-slide" : `.${t.slideClass}`;
  if (t.loop) {
    if (e.animating) return;
    r = parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"), 10), t.centeredSlides ? n < e.loopedSlides - s / 2 || n > e.slides.length - e.loopedSlides + s / 2 ? (e.loopFix(), n = e.getSlideIndex(Ce(i, `${a}[data-swiper-slide-index="${r}"]`)[0]), Mi(() => {
      e.slideTo(n);
    })) : e.slideTo(n) : n > e.slides.length - s ? (e.loopFix(), n = e.getSlideIndex(Ce(i, `${a}[data-swiper-slide-index="${r}"]`)[0]), Mi(() => {
      e.slideTo(n);
    })) : e.slideTo(n);
  } else
    e.slideTo(n);
}
var Lu = {
  slideTo: ku,
  slideToLoop: Cu,
  slideNext: Nu,
  slidePrev: Iu,
  slideReset: Ou,
  slideToClosest: Ru,
  slideToClickedSlide: Pu
};
function Du(e, t) {
  const i = this, {
    params: s,
    slidesEl: n
  } = i;
  if (!s.loop || i.virtual && i.params.virtual.enabled) return;
  const r = () => {
    Ce(n, `.${s.slideClass}, swiper-slide`).forEach((h, g) => {
      h.setAttribute("data-swiper-slide-index", g);
    });
  }, a = i.grid && s.grid && s.grid.rows > 1, o = s.slidesPerGroup * (a ? s.grid.rows : 1), l = i.slides.length % o !== 0, c = a && i.slides.length % s.grid.rows !== 0, d = (u) => {
    for (let h = 0; h < u; h += 1) {
      const g = i.isElement ? xt("swiper-slide", [s.slideBlankClass]) : xt("div", [s.slideClass, s.slideBlankClass]);
      i.slidesEl.append(g);
    }
  };
  if (l) {
    if (s.loopAddBlankSlides) {
      const u = o - i.slides.length % o;
      d(u), i.recalcSlides(), i.updateSlides();
    } else
      Ut("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    r();
  } else if (c) {
    if (s.loopAddBlankSlides) {
      const u = s.grid.rows - i.slides.length % s.grid.rows;
      d(u), i.recalcSlides(), i.updateSlides();
    } else
      Ut("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    r();
  } else
    r();
  i.loopFix({
    slideRealIndex: e,
    direction: s.centeredSlides ? void 0 : "next",
    initial: t
  });
}
function zu(e) {
  let {
    slideRealIndex: t,
    slideTo: i = !0,
    direction: s,
    setTranslate: n,
    activeSlideIndex: r,
    initial: a,
    byController: o,
    byMousewheel: l
  } = e === void 0 ? {} : e;
  const c = this;
  if (!c.params.loop) return;
  c.emit("beforeLoopFix");
  const {
    slides: d,
    allowSlidePrev: u,
    allowSlideNext: h,
    slidesEl: g,
    params: _
  } = c, {
    centeredSlides: b,
    initialSlide: E
  } = _;
  if (c.allowSlidePrev = !0, c.allowSlideNext = !0, c.virtual && _.virtual.enabled) {
    i && (!_.centeredSlides && c.snapIndex === 0 ? c.slideTo(c.virtual.slides.length, 0, !1, !0) : _.centeredSlides && c.snapIndex < _.slidesPerView ? c.slideTo(c.virtual.slides.length + c.snapIndex, 0, !1, !0) : c.snapIndex === c.snapGrid.length - 1 && c.slideTo(c.virtual.slidesBefore, 0, !1, !0)), c.allowSlidePrev = u, c.allowSlideNext = h, c.emit("loopFix");
    return;
  }
  let x = _.slidesPerView;
  x === "auto" ? x = c.slidesPerViewDynamic() : (x = Math.ceil(parseFloat(_.slidesPerView, 10)), b && x % 2 === 0 && (x = x + 1));
  const f = _.slidesPerGroupAuto ? x : _.slidesPerGroup;
  let m = f;
  m % f !== 0 && (m += f - m % f), m += _.loopAdditionalSlides, c.loopedSlides = m;
  const v = c.grid && _.grid && _.grid.rows > 1;
  d.length < x + m || c.params.effect === "cards" && d.length < x + m * 2 ? Ut("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters") : v && _.grid.fill === "row" && Ut("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
  const w = [], y = [], S = v ? Math.ceil(d.length / _.grid.rows) : d.length, k = a && S - E < x && !b;
  let O = k ? E : c.activeIndex;
  typeof r > "u" ? r = c.getSlideIndex(d.find((R) => R.classList.contains(_.slideActiveClass))) : O = r;
  const M = s === "next" || !s, C = s === "prev" || !s;
  let D = 0, P = 0;
  const B = (v ? d[r].column : r) + (b && typeof n > "u" ? -x / 2 + 0.5 : 0);
  if (B < m) {
    D = Math.max(m - B, f);
    for (let R = 0; R < m - B; R += 1) {
      const A = R - Math.floor(R / S) * S;
      if (v) {
        const N = S - A - 1;
        for (let z = d.length - 1; z >= 0; z -= 1)
          d[z].column === N && w.push(z);
      } else
        w.push(S - A - 1);
    }
  } else if (B + x > S - m) {
    P = Math.max(B - (S - m * 2), f), k && (P = Math.max(P, x - S + E + 1));
    for (let R = 0; R < P; R += 1) {
      const A = R - Math.floor(R / S) * S;
      v ? d.forEach((N, z) => {
        N.column === A && y.push(z);
      }) : y.push(A);
    }
  }
  if (c.__preventObserver__ = !0, requestAnimationFrame(() => {
    c.__preventObserver__ = !1;
  }), c.params.effect === "cards" && d.length < x + m * 2 && (y.includes(r) && y.splice(y.indexOf(r), 1), w.includes(r) && w.splice(w.indexOf(r), 1)), C && w.forEach((R) => {
    d[R].swiperLoopMoveDOM = !0, g.prepend(d[R]), d[R].swiperLoopMoveDOM = !1;
  }), M && y.forEach((R) => {
    d[R].swiperLoopMoveDOM = !0, g.append(d[R]), d[R].swiperLoopMoveDOM = !1;
  }), c.recalcSlides(), _.slidesPerView === "auto" ? c.updateSlides() : v && (w.length > 0 && C || y.length > 0 && M) && c.slides.forEach((R, A) => {
    c.grid.updateSlide(A, R, c.slides);
  }), _.watchSlidesProgress && c.updateSlidesOffset(), i) {
    if (w.length > 0 && C) {
      if (typeof t > "u") {
        const R = c.slidesGrid[O], N = c.slidesGrid[O + D] - R;
        l ? c.setTranslate(c.translate - N) : (c.slideTo(O + Math.ceil(D), 0, !1, !0), n && (c.touchEventsData.startTranslate = c.touchEventsData.startTranslate - N, c.touchEventsData.currentTranslate = c.touchEventsData.currentTranslate - N));
      } else if (n) {
        const R = v ? w.length / _.grid.rows : w.length;
        c.slideTo(c.activeIndex + R, 0, !1, !0), c.touchEventsData.currentTranslate = c.translate;
      }
    } else if (y.length > 0 && M)
      if (typeof t > "u") {
        const R = c.slidesGrid[O], N = c.slidesGrid[O - P] - R;
        l ? c.setTranslate(c.translate - N) : (c.slideTo(O - P, 0, !1, !0), n && (c.touchEventsData.startTranslate = c.touchEventsData.startTranslate - N, c.touchEventsData.currentTranslate = c.touchEventsData.currentTranslate - N));
      } else {
        const R = v ? y.length / _.grid.rows : y.length;
        c.slideTo(c.activeIndex - R, 0, !1, !0);
      }
  }
  if (c.allowSlidePrev = u, c.allowSlideNext = h, c.controller && c.controller.control && !o) {
    const R = {
      slideRealIndex: t,
      direction: s,
      setTranslate: n,
      activeSlideIndex: r,
      byController: !0
    };
    Array.isArray(c.controller.control) ? c.controller.control.forEach((A) => {
      !A.destroyed && A.params.loop && A.loopFix({
        ...R,
        slideTo: A.params.slidesPerView === _.slidesPerView ? i : !1
      });
    }) : c.controller.control instanceof c.constructor && c.controller.control.params.loop && c.controller.control.loopFix({
      ...R,
      slideTo: c.controller.control.params.slidesPerView === _.slidesPerView ? i : !1
    });
  }
  c.emit("loopFix");
}
function Vu() {
  const e = this, {
    params: t,
    slidesEl: i
  } = e;
  if (!t.loop || !i || e.virtual && e.params.virtual.enabled) return;
  e.recalcSlides();
  const s = [];
  e.slides.forEach((n) => {
    const r = typeof n.swiperSlideIndex > "u" ? n.getAttribute("data-swiper-slide-index") * 1 : n.swiperSlideIndex;
    s[r] = n;
  }), e.slides.forEach((n) => {
    n.removeAttribute("data-swiper-slide-index");
  }), s.forEach((n) => {
    i.append(n);
  }), e.recalcSlides(), e.slideTo(e.realIndex, 0);
}
var Bu = {
  loopCreate: Du,
  loopFix: zu,
  loopDestroy: Vu
};
function $u(e) {
  const t = this;
  if (!t.params.simulateTouch || t.params.watchOverflow && t.isLocked || t.params.cssMode) return;
  const i = t.params.touchEventsTarget === "container" ? t.el : t.wrapperEl;
  t.isElement && (t.__preventObserver__ = !0), i.style.cursor = "move", i.style.cursor = e ? "grabbing" : "grab", t.isElement && requestAnimationFrame(() => {
    t.__preventObserver__ = !1;
  });
}
function Hu() {
  const e = this;
  e.params.watchOverflow && e.isLocked || e.params.cssMode || (e.isElement && (e.__preventObserver__ = !0), e[e.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "", e.isElement && requestAnimationFrame(() => {
    e.__preventObserver__ = !1;
  }));
}
var Fu = {
  setGrabCursor: $u,
  unsetGrabCursor: Hu
};
function Gu(e, t) {
  t === void 0 && (t = this);
  function i(s) {
    if (!s || s === He() || s === oe()) return null;
    s.assignedSlot && (s = s.assignedSlot);
    const n = s.closest(e);
    return !n && !s.getRootNode ? null : n || i(s.getRootNode().host);
  }
  return i(t);
}
function Ss(e, t, i) {
  const s = oe(), {
    params: n
  } = e, r = n.edgeSwipeDetection, a = n.edgeSwipeThreshold;
  return r && (i <= a || i >= s.innerWidth - a) ? r === "prevent" ? (t.preventDefault(), !0) : !1 : !0;
}
function qu(e) {
  const t = this, i = He();
  let s = e;
  s.originalEvent && (s = s.originalEvent);
  const n = t.touchEventsData;
  if (s.type === "pointerdown") {
    if (n.pointerId !== null && n.pointerId !== s.pointerId)
      return;
    n.pointerId = s.pointerId;
  } else s.type === "touchstart" && s.targetTouches.length === 1 && (n.touchId = s.targetTouches[0].identifier);
  if (s.type === "touchstart") {
    Ss(t, s, s.targetTouches[0].pageX);
    return;
  }
  const {
    params: r,
    touches: a,
    enabled: o
  } = t;
  if (!o || !r.simulateTouch && s.pointerType === "mouse" || t.animating && r.preventInteractionOnTransition)
    return;
  !t.animating && r.cssMode && r.loop && t.loopFix();
  let l = s.target;
  if (r.touchEventsTarget === "wrapper" && !Kd(l, t.wrapperEl) || "which" in s && s.which === 3 || "button" in s && s.button > 0 || n.isTouched && n.isMoved) return;
  const c = !!r.noSwipingClass && r.noSwipingClass !== "", d = s.composedPath ? s.composedPath() : s.path;
  c && s.target && s.target.shadowRoot && d && (l = d[0]);
  const u = r.noSwipingSelector ? r.noSwipingSelector : `.${r.noSwipingClass}`, h = !!(s.target && s.target.shadowRoot);
  if (r.noSwiping && (h ? Gu(u, l) : l.closest(u))) {
    t.allowClick = !0;
    return;
  }
  if (r.swipeHandler && !l.closest(r.swipeHandler))
    return;
  a.currentX = s.pageX, a.currentY = s.pageY;
  const g = a.currentX, _ = a.currentY;
  if (!Ss(t, s, g))
    return;
  Object.assign(n, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0
  }), a.startX = g, a.startY = _, n.touchStartTime = Wt(), t.allowClick = !0, t.updateSize(), t.swipeDirection = void 0, r.threshold > 0 && (n.allowThresholdMove = !1);
  let b = !0;
  l.matches(n.focusableElements) && (b = !1, l.nodeName === "SELECT" && (n.isTouched = !1)), i.activeElement && i.activeElement.matches(n.focusableElements) && i.activeElement !== l && (s.pointerType === "mouse" || s.pointerType !== "mouse" && !l.matches(n.focusableElements)) && i.activeElement.blur();
  const E = b && t.allowTouchMove && r.touchStartPreventDefault;
  (r.touchStartForcePreventDefault || E) && !l.isContentEditable && s.preventDefault(), r.freeMode && r.freeMode.enabled && t.freeMode && t.animating && !r.cssMode && t.freeMode.onTouchStart(), t.emit("touchStart", s);
}
function ju(e) {
  const t = He(), i = this, s = i.touchEventsData, {
    params: n,
    touches: r,
    rtlTranslate: a,
    enabled: o
  } = i;
  if (!o || !n.simulateTouch && e.pointerType === "mouse") return;
  let l = e;
  if (l.originalEvent && (l = l.originalEvent), l.type === "pointermove" && (s.touchId !== null || l.pointerId !== s.pointerId))
    return;
  let c;
  if (l.type === "touchmove") {
    if (c = [...l.changedTouches].find((y) => y.identifier === s.touchId), !c || c.identifier !== s.touchId) return;
  } else
    c = l;
  if (!s.isTouched) {
    s.startMoving && s.isScrolling && i.emit("touchMoveOpposite", l);
    return;
  }
  const d = c.pageX, u = c.pageY;
  if (l.preventedByNestedSwiper) {
    r.startX = d, r.startY = u;
    return;
  }
  if (!i.allowTouchMove) {
    l.target.matches(s.focusableElements) || (i.allowClick = !1), s.isTouched && (Object.assign(r, {
      startX: d,
      startY: u,
      currentX: d,
      currentY: u
    }), s.touchStartTime = Wt());
    return;
  }
  if (n.touchReleaseOnEdges && !n.loop)
    if (i.isVertical()) {
      if (u < r.startY && i.translate <= i.maxTranslate() || u > r.startY && i.translate >= i.minTranslate()) {
        s.isTouched = !1, s.isMoved = !1;
        return;
      }
    } else {
      if (a && (d > r.startX && -i.translate <= i.maxTranslate() || d < r.startX && -i.translate >= i.minTranslate()))
        return;
      if (!a && (d < r.startX && i.translate <= i.maxTranslate() || d > r.startX && i.translate >= i.minTranslate()))
        return;
    }
  if (t.activeElement && t.activeElement.matches(s.focusableElements) && t.activeElement !== l.target && l.pointerType !== "mouse" && t.activeElement.blur(), t.activeElement && l.target === t.activeElement && l.target.matches(s.focusableElements)) {
    s.isMoved = !0, i.allowClick = !1;
    return;
  }
  s.allowTouchCallbacks && i.emit("touchMove", l), r.previousX = r.currentX, r.previousY = r.currentY, r.currentX = d, r.currentY = u;
  const h = r.currentX - r.startX, g = r.currentY - r.startY;
  if (i.params.threshold && Math.sqrt(h ** 2 + g ** 2) < i.params.threshold) return;
  if (typeof s.isScrolling > "u") {
    let y;
    i.isHorizontal() && r.currentY === r.startY || i.isVertical() && r.currentX === r.startX ? s.isScrolling = !1 : h * h + g * g >= 25 && (y = Math.atan2(Math.abs(g), Math.abs(h)) * 180 / Math.PI, s.isScrolling = i.isHorizontal() ? y > n.touchAngle : 90 - y > n.touchAngle);
  }
  if (s.isScrolling && i.emit("touchMoveOpposite", l), typeof s.startMoving > "u" && (r.currentX !== r.startX || r.currentY !== r.startY) && (s.startMoving = !0), s.isScrolling || l.type === "touchmove" && s.preventTouchMoveFromPointerMove) {
    s.isTouched = !1;
    return;
  }
  if (!s.startMoving)
    return;
  i.allowClick = !1, !n.cssMode && l.cancelable && l.preventDefault(), n.touchMoveStopPropagation && !n.nested && l.stopPropagation();
  let _ = i.isHorizontal() ? h : g, b = i.isHorizontal() ? r.currentX - r.previousX : r.currentY - r.previousY;
  n.oneWayMovement && (_ = Math.abs(_) * (a ? 1 : -1), b = Math.abs(b) * (a ? 1 : -1)), r.diff = _, _ *= n.touchRatio, a && (_ = -_, b = -b);
  const E = i.touchesDirection;
  i.swipeDirection = _ > 0 ? "prev" : "next", i.touchesDirection = b > 0 ? "prev" : "next";
  const x = i.params.loop && !n.cssMode, f = i.touchesDirection === "next" && i.allowSlideNext || i.touchesDirection === "prev" && i.allowSlidePrev;
  if (!s.isMoved) {
    if (x && f && i.loopFix({
      direction: i.swipeDirection
    }), s.startTranslate = i.getTranslate(), i.setTransition(0), i.animating) {
      const y = new window.CustomEvent("transitionend", {
        bubbles: !0,
        cancelable: !0,
        detail: {
          bySwiperTouchMove: !0
        }
      });
      i.wrapperEl.dispatchEvent(y);
    }
    s.allowMomentumBounce = !1, n.grabCursor && (i.allowSlideNext === !0 || i.allowSlidePrev === !0) && i.setGrabCursor(!0), i.emit("sliderFirstMove", l);
  }
  let m;
  if ((/* @__PURE__ */ new Date()).getTime(), n._loopSwapReset !== !1 && s.isMoved && s.allowThresholdMove && E !== i.touchesDirection && x && f && Math.abs(_) >= 1) {
    Object.assign(r, {
      startX: d,
      startY: u,
      currentX: d,
      currentY: u,
      startTranslate: s.currentTranslate
    }), s.loopSwapReset = !0, s.startTranslate = s.currentTranslate;
    return;
  }
  i.emit("sliderMove", l), s.isMoved = !0, s.currentTranslate = _ + s.startTranslate;
  let v = !0, w = n.resistanceRatio;
  if (n.touchReleaseOnEdges && (w = 0), _ > 0 ? (x && f && !m && s.allowThresholdMove && s.currentTranslate > (n.centeredSlides ? i.minTranslate() - i.slidesSizesGrid[i.activeIndex + 1] - (n.slidesPerView !== "auto" && i.slides.length - n.slidesPerView >= 2 ? i.slidesSizesGrid[i.activeIndex + 1] + i.params.spaceBetween : 0) - i.params.spaceBetween : i.minTranslate()) && i.loopFix({
    direction: "prev",
    setTranslate: !0,
    activeSlideIndex: 0
  }), s.currentTranslate > i.minTranslate() && (v = !1, n.resistance && (s.currentTranslate = i.minTranslate() - 1 + (-i.minTranslate() + s.startTranslate + _) ** w))) : _ < 0 && (x && f && !m && s.allowThresholdMove && s.currentTranslate < (n.centeredSlides ? i.maxTranslate() + i.slidesSizesGrid[i.slidesSizesGrid.length - 1] + i.params.spaceBetween + (n.slidesPerView !== "auto" && i.slides.length - n.slidesPerView >= 2 ? i.slidesSizesGrid[i.slidesSizesGrid.length - 1] + i.params.spaceBetween : 0) : i.maxTranslate()) && i.loopFix({
    direction: "next",
    setTranslate: !0,
    activeSlideIndex: i.slides.length - (n.slidesPerView === "auto" ? i.slidesPerViewDynamic() : Math.ceil(parseFloat(n.slidesPerView, 10)))
  }), s.currentTranslate < i.maxTranslate() && (v = !1, n.resistance && (s.currentTranslate = i.maxTranslate() + 1 - (i.maxTranslate() - s.startTranslate - _) ** w))), v && (l.preventedByNestedSwiper = !0), !i.allowSlideNext && i.swipeDirection === "next" && s.currentTranslate < s.startTranslate && (s.currentTranslate = s.startTranslate), !i.allowSlidePrev && i.swipeDirection === "prev" && s.currentTranslate > s.startTranslate && (s.currentTranslate = s.startTranslate), !i.allowSlidePrev && !i.allowSlideNext && (s.currentTranslate = s.startTranslate), n.threshold > 0)
    if (Math.abs(_) > n.threshold || s.allowThresholdMove) {
      if (!s.allowThresholdMove) {
        s.allowThresholdMove = !0, r.startX = r.currentX, r.startY = r.currentY, s.currentTranslate = s.startTranslate, r.diff = i.isHorizontal() ? r.currentX - r.startX : r.currentY - r.startY;
        return;
      }
    } else {
      s.currentTranslate = s.startTranslate;
      return;
    }
  !n.followFinger || n.cssMode || ((n.freeMode && n.freeMode.enabled && i.freeMode || n.watchSlidesProgress) && (i.updateActiveIndex(), i.updateSlidesClasses()), n.freeMode && n.freeMode.enabled && i.freeMode && i.freeMode.onTouchMove(), i.updateProgress(s.currentTranslate), i.setTranslate(s.currentTranslate));
}
function Wu(e) {
  const t = this, i = t.touchEventsData;
  let s = e;
  s.originalEvent && (s = s.originalEvent);
  let n;
  if (s.type === "touchend" || s.type === "touchcancel") {
    if (n = [...s.changedTouches].find((w) => w.identifier === i.touchId), !n || n.identifier !== i.touchId) return;
  } else {
    if (i.touchId !== null || s.pointerId !== i.pointerId) return;
    n = s;
  }
  if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(s.type) && !(["pointercancel", "contextmenu"].includes(s.type) && (t.browser.isSafari || t.browser.isWebView)))
    return;
  i.pointerId = null, i.touchId = null;
  const {
    params: a,
    touches: o,
    rtlTranslate: l,
    slidesGrid: c,
    enabled: d
  } = t;
  if (!d || !a.simulateTouch && s.pointerType === "mouse") return;
  if (i.allowTouchCallbacks && t.emit("touchEnd", s), i.allowTouchCallbacks = !1, !i.isTouched) {
    i.isMoved && a.grabCursor && t.setGrabCursor(!1), i.isMoved = !1, i.startMoving = !1;
    return;
  }
  a.grabCursor && i.isMoved && i.isTouched && (t.allowSlideNext === !0 || t.allowSlidePrev === !0) && t.setGrabCursor(!1);
  const u = Wt(), h = u - i.touchStartTime;
  if (t.allowClick) {
    const w = s.path || s.composedPath && s.composedPath();
    t.updateClickedSlide(w && w[0] || s.target, w), t.emit("tap click", s), h < 300 && u - i.lastClickTime < 300 && t.emit("doubleTap doubleClick", s);
  }
  if (i.lastClickTime = Wt(), Mi(() => {
    t.destroyed || (t.allowClick = !0);
  }), !i.isTouched || !i.isMoved || !t.swipeDirection || o.diff === 0 && !i.loopSwapReset || i.currentTranslate === i.startTranslate && !i.loopSwapReset) {
    i.isTouched = !1, i.isMoved = !1, i.startMoving = !1;
    return;
  }
  i.isTouched = !1, i.isMoved = !1, i.startMoving = !1;
  let g;
  if (a.followFinger ? g = l ? t.translate : -t.translate : g = -i.currentTranslate, a.cssMode)
    return;
  if (a.freeMode && a.freeMode.enabled) {
    t.freeMode.onTouchEnd({
      currentPos: g
    });
    return;
  }
  const _ = g >= -t.maxTranslate() && !t.params.loop;
  let b = 0, E = t.slidesSizesGrid[0];
  for (let w = 0; w < c.length; w += w < a.slidesPerGroupSkip ? 1 : a.slidesPerGroup) {
    const y = w < a.slidesPerGroupSkip - 1 ? 1 : a.slidesPerGroup;
    typeof c[w + y] < "u" ? (_ || g >= c[w] && g < c[w + y]) && (b = w, E = c[w + y] - c[w]) : (_ || g >= c[w]) && (b = w, E = c[c.length - 1] - c[c.length - 2]);
  }
  let x = null, f = null;
  a.rewind && (t.isBeginning ? f = a.virtual && a.virtual.enabled && t.virtual ? t.virtual.slides.length - 1 : t.slides.length - 1 : t.isEnd && (x = 0));
  const m = (g - c[b]) / E, v = b < a.slidesPerGroupSkip - 1 ? 1 : a.slidesPerGroup;
  if (h > a.longSwipesMs) {
    if (!a.longSwipes) {
      t.slideTo(t.activeIndex);
      return;
    }
    t.swipeDirection === "next" && (m >= a.longSwipesRatio ? t.slideTo(a.rewind && t.isEnd ? x : b + v) : t.slideTo(b)), t.swipeDirection === "prev" && (m > 1 - a.longSwipesRatio ? t.slideTo(b + v) : f !== null && m < 0 && Math.abs(m) > a.longSwipesRatio ? t.slideTo(f) : t.slideTo(b));
  } else {
    if (!a.shortSwipes) {
      t.slideTo(t.activeIndex);
      return;
    }
    t.navigation && (s.target === t.navigation.nextEl || s.target === t.navigation.prevEl) ? s.target === t.navigation.nextEl ? t.slideTo(b + v) : t.slideTo(b) : (t.swipeDirection === "next" && t.slideTo(x !== null ? x : b + v), t.swipeDirection === "prev" && t.slideTo(f !== null ? f : b));
  }
}
function Ts() {
  const e = this, {
    params: t,
    el: i
  } = e;
  if (i && i.offsetWidth === 0) return;
  t.breakpoints && e.setBreakpoint();
  const {
    allowSlideNext: s,
    allowSlidePrev: n,
    snapGrid: r
  } = e, a = e.virtual && e.params.virtual.enabled;
  e.allowSlideNext = !0, e.allowSlidePrev = !0, e.updateSize(), e.updateSlides(), e.updateSlidesClasses();
  const o = a && t.loop;
  (t.slidesPerView === "auto" || t.slidesPerView > 1) && e.isEnd && !e.isBeginning && !e.params.centeredSlides && !o ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.params.loop && !a ? e.slideToLoop(e.realIndex, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0), e.autoplay && e.autoplay.running && e.autoplay.paused && (clearTimeout(e.autoplay.resizeTimeout), e.autoplay.resizeTimeout = setTimeout(() => {
    e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.resume();
  }, 500)), e.allowSlidePrev = n, e.allowSlideNext = s, e.params.watchOverflow && r !== e.snapGrid && e.checkOverflow();
}
function Uu(e) {
  const t = this;
  t.enabled && (t.allowClick || (t.params.preventClicks && e.preventDefault(), t.params.preventClicksPropagation && t.animating && (e.stopPropagation(), e.stopImmediatePropagation())));
}
function Yu() {
  const e = this, {
    wrapperEl: t,
    rtlTranslate: i,
    enabled: s
  } = e;
  if (!s) return;
  e.previousTranslate = e.translate, e.isHorizontal() ? e.translate = -t.scrollLeft : e.translate = -t.scrollTop, e.translate === 0 && (e.translate = 0), e.updateActiveIndex(), e.updateSlidesClasses();
  let n;
  const r = e.maxTranslate() - e.minTranslate();
  r === 0 ? n = 0 : n = (e.translate - e.minTranslate()) / r, n !== e.progress && e.updateProgress(i ? -e.translate : e.translate), e.emit("setTranslate", e.translate, !1);
}
function Xu(e) {
  const t = this;
  Bt(t, e.target), !(t.params.cssMode || t.params.slidesPerView !== "auto" && !t.params.autoHeight) && t.update();
}
function Zu() {
  const e = this;
  e.documentTouchHandlerProceeded || (e.documentTouchHandlerProceeded = !0, e.params.touchReleaseOnEdges && (e.el.style.touchAction = "auto"));
}
const dn = (e, t) => {
  const i = He(), {
    params: s,
    el: n,
    wrapperEl: r,
    device: a
  } = e, o = !!s.nested, l = t === "on" ? "addEventListener" : "removeEventListener", c = t;
  !n || typeof n == "string" || (i[l]("touchstart", e.onDocumentTouchStart, {
    passive: !1,
    capture: o
  }), n[l]("touchstart", e.onTouchStart, {
    passive: !1
  }), n[l]("pointerdown", e.onTouchStart, {
    passive: !1
  }), i[l]("touchmove", e.onTouchMove, {
    passive: !1,
    capture: o
  }), i[l]("pointermove", e.onTouchMove, {
    passive: !1,
    capture: o
  }), i[l]("touchend", e.onTouchEnd, {
    passive: !0
  }), i[l]("pointerup", e.onTouchEnd, {
    passive: !0
  }), i[l]("pointercancel", e.onTouchEnd, {
    passive: !0
  }), i[l]("touchcancel", e.onTouchEnd, {
    passive: !0
  }), i[l]("pointerout", e.onTouchEnd, {
    passive: !0
  }), i[l]("pointerleave", e.onTouchEnd, {
    passive: !0
  }), i[l]("contextmenu", e.onTouchEnd, {
    passive: !0
  }), (s.preventClicks || s.preventClicksPropagation) && n[l]("click", e.onClick, !0), s.cssMode && r[l]("scroll", e.onScroll), s.updateOnWindowResize ? e[c](a.ios || a.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", Ts, !0) : e[c]("observerUpdate", Ts, !0), n[l]("load", e.onLoad, {
    capture: !0
  }));
};
function Ku() {
  const e = this, {
    params: t
  } = e;
  e.onTouchStart = qu.bind(e), e.onTouchMove = ju.bind(e), e.onTouchEnd = Wu.bind(e), e.onDocumentTouchStart = Zu.bind(e), t.cssMode && (e.onScroll = Yu.bind(e)), e.onClick = Uu.bind(e), e.onLoad = Xu.bind(e), dn(e, "on");
}
function Qu() {
  dn(this, "off");
}
var Ju = {
  attachEvents: Ku,
  detachEvents: Qu
};
const As = (e, t) => e.grid && t.grid && t.grid.rows > 1;
function ef() {
  const e = this, {
    realIndex: t,
    initialized: i,
    params: s,
    el: n
  } = e, r = s.breakpoints;
  if (!r || r && Object.keys(r).length === 0) return;
  const a = He(), o = s.breakpointsBase === "window" || !s.breakpointsBase ? s.breakpointsBase : "container", l = ["window", "container"].includes(s.breakpointsBase) || !s.breakpointsBase ? e.el : a.querySelector(s.breakpointsBase), c = e.getBreakpoint(r, o, l);
  if (!c || e.currentBreakpoint === c) return;
  const u = (c in r ? r[c] : void 0) || e.originalParams, h = As(e, s), g = As(e, u), _ = e.params.grabCursor, b = u.grabCursor, E = s.enabled;
  h && !g ? (n.classList.remove(`${s.containerModifierClass}grid`, `${s.containerModifierClass}grid-column`), e.emitContainerClasses()) : !h && g && (n.classList.add(`${s.containerModifierClass}grid`), (u.grid.fill && u.grid.fill === "column" || !u.grid.fill && s.grid.fill === "column") && n.classList.add(`${s.containerModifierClass}grid-column`), e.emitContainerClasses()), _ && !b ? e.unsetGrabCursor() : !_ && b && e.setGrabCursor(), ["navigation", "pagination", "scrollbar"].forEach((y) => {
    if (typeof u[y] > "u") return;
    const S = s[y] && s[y].enabled, k = u[y] && u[y].enabled;
    S && !k && e[y].disable(), !S && k && e[y].enable();
  });
  const x = u.direction && u.direction !== s.direction, f = s.loop && (u.slidesPerView !== s.slidesPerView || x), m = s.loop;
  x && i && e.changeDirection(), he(e.params, u);
  const v = e.params.enabled, w = e.params.loop;
  Object.assign(e, {
    allowTouchMove: e.params.allowTouchMove,
    allowSlideNext: e.params.allowSlideNext,
    allowSlidePrev: e.params.allowSlidePrev
  }), E && !v ? e.disable() : !E && v && e.enable(), e.currentBreakpoint = c, e.emit("_beforeBreakpoint", u), i && (f ? (e.loopDestroy(), e.loopCreate(t), e.updateSlides()) : !m && w ? (e.loopCreate(t), e.updateSlides()) : m && !w && e.loopDestroy()), e.emit("breakpoint", u);
}
function tf(e, t, i) {
  if (t === void 0 && (t = "window"), !e || t === "container" && !i) return;
  let s = !1;
  const n = oe(), r = t === "window" ? n.innerHeight : i.clientHeight, a = Object.keys(e).map((o) => {
    if (typeof o == "string" && o.indexOf("@") === 0) {
      const l = parseFloat(o.substr(1));
      return {
        value: r * l,
        point: o
      };
    }
    return {
      value: o,
      point: o
    };
  });
  a.sort((o, l) => parseInt(o.value, 10) - parseInt(l.value, 10));
  for (let o = 0; o < a.length; o += 1) {
    const {
      point: l,
      value: c
    } = a[o];
    t === "window" ? n.matchMedia(`(min-width: ${c}px)`).matches && (s = l) : c <= i.clientWidth && (s = l);
  }
  return s || "max";
}
var sf = {
  setBreakpoint: ef,
  getBreakpoint: tf
};
function nf(e, t) {
  const i = [];
  return e.forEach((s) => {
    typeof s == "object" ? Object.keys(s).forEach((n) => {
      s[n] && i.push(t + n);
    }) : typeof s == "string" && i.push(t + s);
  }), i;
}
function rf() {
  const e = this, {
    classNames: t,
    params: i,
    rtl: s,
    el: n,
    device: r
  } = e, a = nf(["initialized", i.direction, {
    "free-mode": e.params.freeMode && i.freeMode.enabled
  }, {
    autoheight: i.autoHeight
  }, {
    rtl: s
  }, {
    grid: i.grid && i.grid.rows > 1
  }, {
    "grid-column": i.grid && i.grid.rows > 1 && i.grid.fill === "column"
  }, {
    android: r.android
  }, {
    ios: r.ios
  }, {
    "css-mode": i.cssMode
  }, {
    centered: i.cssMode && i.centeredSlides
  }, {
    "watch-progress": i.watchSlidesProgress
  }], i.containerModifierClass);
  t.push(...a), n.classList.add(...t), e.emitContainerClasses();
}
function af() {
  const e = this, {
    el: t,
    classNames: i
  } = e;
  !t || typeof t == "string" || (t.classList.remove(...i), e.emitContainerClasses());
}
var of = {
  addClasses: rf,
  removeClasses: af
};
function lf() {
  const e = this, {
    isLocked: t,
    params: i
  } = e, {
    slidesOffsetBefore: s
  } = i;
  if (s) {
    const n = e.slides.length - 1, r = e.slidesGrid[n] + e.slidesSizesGrid[n] + s * 2;
    e.isLocked = e.size > r;
  } else
    e.isLocked = e.snapGrid.length === 1;
  i.allowSlideNext === !0 && (e.allowSlideNext = !e.isLocked), i.allowSlidePrev === !0 && (e.allowSlidePrev = !e.isLocked), t && t !== e.isLocked && (e.isEnd = !1), t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
}
var cf = {
  checkOverflow: lf
}, Ms = {
  init: !0,
  direction: "horizontal",
  oneWayMovement: !1,
  swiperElementNodeName: "SWIPER-CONTAINER",
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: !1,
  updateOnWindowResize: !0,
  resizeObserver: !0,
  nested: !1,
  createElements: !1,
  eventsPrefix: "swiper",
  enabled: !0,
  focusableElements: "input, select, option, textarea, button, video, label",
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: !1,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: !1,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: !1,
  // Set wrapper width
  setWrapperSize: !1,
  // Virtual Translate
  virtualTranslate: !1,
  // Effects
  effect: "slide",
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: void 0,
  breakpointsBase: "window",
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: !1,
  centeredSlides: !1,
  centeredSlidesBounds: !1,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: !0,
  centerInsufficientSlides: !1,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: !0,
  // Round length
  roundLengths: !1,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: !0,
  shortSwipes: !0,
  longSwipes: !0,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: !0,
  allowTouchMove: !0,
  threshold: 5,
  touchMoveStopPropagation: !1,
  touchStartPreventDefault: !0,
  touchStartForcePreventDefault: !1,
  touchReleaseOnEdges: !1,
  // Unique Navigation Elements
  uniqueNavElements: !0,
  // Resistance
  resistance: !0,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: !1,
  // Cursor
  grabCursor: !1,
  // Clicks
  preventClicks: !0,
  preventClicksPropagation: !0,
  slideToClickedSlide: !1,
  // loop
  loop: !1,
  loopAddBlankSlides: !0,
  loopAdditionalSlides: 0,
  loopPreventsSliding: !0,
  // rewind
  rewind: !1,
  // Swiping/no swiping
  allowSlidePrev: !0,
  allowSlideNext: !0,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: !0,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: !0,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: "swiper-",
  // NEW
  slideClass: "swiper-slide",
  slideBlankClass: "swiper-slide-blank",
  slideActiveClass: "swiper-slide-active",
  slideVisibleClass: "swiper-slide-visible",
  slideFullyVisibleClass: "swiper-slide-fully-visible",
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
  wrapperClass: "swiper-wrapper",
  lazyPreloaderClass: "swiper-lazy-preloader",
  lazyPreloadPrevNext: 0,
  // Callbacks
  runCallbacksOnInit: !0,
  // Internals
  _emitClasses: !1
};
function df(e, t) {
  return function(s) {
    s === void 0 && (s = {});
    const n = Object.keys(s)[0], r = s[n];
    if (typeof r != "object" || r === null) {
      he(t, s);
      return;
    }
    if (e[n] === !0 && (e[n] = {
      enabled: !0
    }), n === "navigation" && e[n] && e[n].enabled && !e[n].prevEl && !e[n].nextEl && (e[n].auto = !0), ["pagination", "scrollbar"].indexOf(n) >= 0 && e[n] && e[n].enabled && !e[n].el && (e[n].auto = !0), !(n in e && "enabled" in r)) {
      he(t, s);
      return;
    }
    typeof e[n] == "object" && !("enabled" in e[n]) && (e[n].enabled = !0), e[n] || (e[n] = {
      enabled: !1
    }), he(t, s);
  };
}
const vi = {
  eventsEmitter: au,
  update: vu,
  translate: xu,
  transition: Mu,
  slide: Lu,
  loop: Bu,
  grabCursor: Fu,
  events: Ju,
  breakpoints: sf,
  checkOverflow: cf,
  classes: of
}, _i = {};
class be {
  constructor() {
    let t, i;
    for (var s = arguments.length, n = new Array(s), r = 0; r < s; r++)
      n[r] = arguments[r];
    n.length === 1 && n[0].constructor && Object.prototype.toString.call(n[0]).slice(8, -1) === "Object" ? i = n[0] : [t, i] = n, i || (i = {}), i = he({}, i), t && !i.el && (i.el = t);
    const a = He();
    if (i.el && typeof i.el == "string" && a.querySelectorAll(i.el).length > 1) {
      const d = [];
      return a.querySelectorAll(i.el).forEach((u) => {
        const h = he({}, i, {
          el: u
        });
        d.push(new be(h));
      }), d;
    }
    const o = this;
    o.__swiper__ = !0, o.support = an(), o.device = on({
      userAgent: i.userAgent
    }), o.browser = ln(), o.eventsListeners = {}, o.eventsAnyListeners = [], o.modules = [...o.__modules__], i.modules && Array.isArray(i.modules) && o.modules.push(...i.modules);
    const l = {};
    o.modules.forEach((d) => {
      d({
        params: i,
        swiper: o,
        extendParams: df(i, l),
        on: o.on.bind(o),
        once: o.once.bind(o),
        off: o.off.bind(o),
        emit: o.emit.bind(o)
      });
    });
    const c = he({}, Ms, l);
    return o.params = he({}, c, _i, i), o.originalParams = he({}, o.params), o.passedParams = he({}, i), o.params && o.params.on && Object.keys(o.params.on).forEach((d) => {
      o.on(d, o.params.on[d]);
    }), o.params && o.params.onAny && o.onAny(o.params.onAny), Object.assign(o, {
      enabled: o.params.enabled,
      el: t,
      // Classes
      classNames: [],
      // Slides
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return o.params.direction === "horizontal";
      },
      isVertical() {
        return o.params.direction === "vertical";
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: !0,
      isEnd: !1,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: !1,
      cssOverflowAdjustment() {
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
      },
      // Locks
      allowSlideNext: o.params.allowSlideNext,
      allowSlidePrev: o.params.allowSlidePrev,
      // Touch Events
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        // Form elements to match
        focusableElements: o.params.focusableElements,
        // Last click time
        lastClickTime: 0,
        clickTimeout: void 0,
        // Velocities
        velocities: [],
        allowMomentumBounce: void 0,
        startMoving: void 0,
        pointerId: null,
        touchId: null
      },
      // Clicks
      allowClick: !0,
      // Touches
      allowTouchMove: o.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }), o.emit("_swiper"), o.params.init && o.init(), o;
  }
  getDirectionLabel(t) {
    return this.isHorizontal() ? t : {
      width: "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      marginRight: "marginBottom"
    }[t];
  }
  getSlideIndex(t) {
    const {
      slidesEl: i,
      params: s
    } = this, n = Ce(i, `.${s.slideClass}, swiper-slide`), r = St(n[0]);
    return St(t) - r;
  }
  getSlideIndexByData(t) {
    return this.getSlideIndex(this.slides.find((i) => i.getAttribute("data-swiper-slide-index") * 1 === t));
  }
  recalcSlides() {
    const t = this, {
      slidesEl: i,
      params: s
    } = t;
    t.slides = Ce(i, `.${s.slideClass}, swiper-slide`);
  }
  enable() {
    const t = this;
    t.enabled || (t.enabled = !0, t.params.grabCursor && t.setGrabCursor(), t.emit("enable"));
  }
  disable() {
    const t = this;
    t.enabled && (t.enabled = !1, t.params.grabCursor && t.unsetGrabCursor(), t.emit("disable"));
  }
  setProgress(t, i) {
    const s = this;
    t = Math.min(Math.max(t, 0), 1);
    const n = s.minTranslate(), a = (s.maxTranslate() - n) * t + n;
    s.translateTo(a, typeof i > "u" ? 0 : i), s.updateActiveIndex(), s.updateSlidesClasses();
  }
  emitContainerClasses() {
    const t = this;
    if (!t.params._emitClasses || !t.el) return;
    const i = t.el.className.split(" ").filter((s) => s.indexOf("swiper") === 0 || s.indexOf(t.params.containerModifierClass) === 0);
    t.emit("_containerClasses", i.join(" "));
  }
  getSlideClasses(t) {
    const i = this;
    return i.destroyed ? "" : t.className.split(" ").filter((s) => s.indexOf("swiper-slide") === 0 || s.indexOf(i.params.slideClass) === 0).join(" ");
  }
  emitSlidesClasses() {
    const t = this;
    if (!t.params._emitClasses || !t.el) return;
    const i = [];
    t.slides.forEach((s) => {
      const n = t.getSlideClasses(s);
      i.push({
        slideEl: s,
        classNames: n
      }), t.emit("_slideClass", s, n);
    }), t.emit("_slideClasses", i);
  }
  slidesPerViewDynamic(t, i) {
    t === void 0 && (t = "current"), i === void 0 && (i = !1);
    const s = this, {
      params: n,
      slides: r,
      slidesGrid: a,
      slidesSizesGrid: o,
      size: l,
      activeIndex: c
    } = s;
    let d = 1;
    if (typeof n.slidesPerView == "number") return n.slidesPerView;
    if (n.centeredSlides) {
      let u = r[c] ? Math.ceil(r[c].swiperSlideSize) : 0, h;
      for (let g = c + 1; g < r.length; g += 1)
        r[g] && !h && (u += Math.ceil(r[g].swiperSlideSize), d += 1, u > l && (h = !0));
      for (let g = c - 1; g >= 0; g -= 1)
        r[g] && !h && (u += r[g].swiperSlideSize, d += 1, u > l && (h = !0));
    } else if (t === "current")
      for (let u = c + 1; u < r.length; u += 1)
        (i ? a[u] + o[u] - a[c] < l : a[u] - a[c] < l) && (d += 1);
    else
      for (let u = c - 1; u >= 0; u -= 1)
        a[c] - a[u] < l && (d += 1);
    return d;
  }
  update() {
    const t = this;
    if (!t || t.destroyed) return;
    const {
      snapGrid: i,
      params: s
    } = t;
    s.breakpoints && t.setBreakpoint(), [...t.el.querySelectorAll('[loading="lazy"]')].forEach((a) => {
      a.complete && Bt(t, a);
    }), t.updateSize(), t.updateSlides(), t.updateProgress(), t.updateSlidesClasses();
    function n() {
      const a = t.rtlTranslate ? t.translate * -1 : t.translate, o = Math.min(Math.max(a, t.maxTranslate()), t.minTranslate());
      t.setTranslate(o), t.updateActiveIndex(), t.updateSlidesClasses();
    }
    let r;
    if (s.freeMode && s.freeMode.enabled && !s.cssMode)
      n(), s.autoHeight && t.updateAutoHeight();
    else {
      if ((s.slidesPerView === "auto" || s.slidesPerView > 1) && t.isEnd && !s.centeredSlides) {
        const a = t.virtual && s.virtual.enabled ? t.virtual.slides : t.slides;
        r = t.slideTo(a.length - 1, 0, !1, !0);
      } else
        r = t.slideTo(t.activeIndex, 0, !1, !0);
      r || n();
    }
    s.watchOverflow && i !== t.snapGrid && t.checkOverflow(), t.emit("update");
  }
  changeDirection(t, i) {
    i === void 0 && (i = !0);
    const s = this, n = s.params.direction;
    return t || (t = n === "horizontal" ? "vertical" : "horizontal"), t === n || t !== "horizontal" && t !== "vertical" || (s.el.classList.remove(`${s.params.containerModifierClass}${n}`), s.el.classList.add(`${s.params.containerModifierClass}${t}`), s.emitContainerClasses(), s.params.direction = t, s.slides.forEach((r) => {
      t === "vertical" ? r.style.width = "" : r.style.height = "";
    }), s.emit("changeDirection"), i && s.update()), s;
  }
  changeLanguageDirection(t) {
    const i = this;
    i.rtl && t === "rtl" || !i.rtl && t === "ltr" || (i.rtl = t === "rtl", i.rtlTranslate = i.params.direction === "horizontal" && i.rtl, i.rtl ? (i.el.classList.add(`${i.params.containerModifierClass}rtl`), i.el.dir = "rtl") : (i.el.classList.remove(`${i.params.containerModifierClass}rtl`), i.el.dir = "ltr"), i.update());
  }
  mount(t) {
    const i = this;
    if (i.mounted) return !0;
    let s = t || i.params.el;
    if (typeof s == "string" && (s = document.querySelector(s)), !s)
      return !1;
    s.swiper = i, s.parentNode && s.parentNode.host && s.parentNode.host.nodeName === i.params.swiperElementNodeName.toUpperCase() && (i.isElement = !0);
    const n = () => `.${(i.params.wrapperClass || "").trim().split(" ").join(".")}`;
    let a = s && s.shadowRoot && s.shadowRoot.querySelector ? s.shadowRoot.querySelector(n()) : Ce(s, n())[0];
    return !a && i.params.createElements && (a = xt("div", i.params.wrapperClass), s.append(a), Ce(s, `.${i.params.slideClass}`).forEach((o) => {
      a.append(o);
    })), Object.assign(i, {
      el: s,
      wrapperEl: a,
      slidesEl: i.isElement && !s.parentNode.host.slideSlots ? s.parentNode.host : a,
      hostEl: i.isElement ? s.parentNode.host : s,
      mounted: !0,
      // RTL
      rtl: s.dir.toLowerCase() === "rtl" || We(s, "direction") === "rtl",
      rtlTranslate: i.params.direction === "horizontal" && (s.dir.toLowerCase() === "rtl" || We(s, "direction") === "rtl"),
      wrongRTL: We(a, "display") === "-webkit-box"
    }), !0;
  }
  init(t) {
    const i = this;
    if (i.initialized || i.mount(t) === !1) return i;
    i.emit("beforeInit"), i.params.breakpoints && i.setBreakpoint(), i.addClasses(), i.updateSize(), i.updateSlides(), i.params.watchOverflow && i.checkOverflow(), i.params.grabCursor && i.enabled && i.setGrabCursor(), i.params.loop && i.virtual && i.params.virtual.enabled ? i.slideTo(i.params.initialSlide + i.virtual.slidesBefore, 0, i.params.runCallbacksOnInit, !1, !0) : i.slideTo(i.params.initialSlide, 0, i.params.runCallbacksOnInit, !1, !0), i.params.loop && i.loopCreate(void 0, !0), i.attachEvents();
    const n = [...i.el.querySelectorAll('[loading="lazy"]')];
    return i.isElement && n.push(...i.hostEl.querySelectorAll('[loading="lazy"]')), n.forEach((r) => {
      r.complete ? Bt(i, r) : r.addEventListener("load", (a) => {
        Bt(i, a.target);
      });
    }), Ni(i), i.initialized = !0, Ni(i), i.emit("init"), i.emit("afterInit"), i;
  }
  destroy(t, i) {
    t === void 0 && (t = !0), i === void 0 && (i = !0);
    const s = this, {
      params: n,
      el: r,
      wrapperEl: a,
      slides: o
    } = s;
    return typeof s.params > "u" || s.destroyed || (s.emit("beforeDestroy"), s.initialized = !1, s.detachEvents(), n.loop && s.loopDestroy(), i && (s.removeClasses(), r && typeof r != "string" && r.removeAttribute("style"), a && a.removeAttribute("style"), o && o.length && o.forEach((l) => {
      l.classList.remove(n.slideVisibleClass, n.slideFullyVisibleClass, n.slideActiveClass, n.slideNextClass, n.slidePrevClass), l.removeAttribute("style"), l.removeAttribute("data-swiper-slide-index");
    })), s.emit("destroy"), Object.keys(s.eventsListeners).forEach((l) => {
      s.off(l);
    }), t !== !1 && (s.el && typeof s.el != "string" && (s.el.swiper = null), Wd(s)), s.destroyed = !0), null;
  }
  static extendDefaults(t) {
    he(_i, t);
  }
  static get extendedDefaults() {
    return _i;
  }
  static get defaults() {
    return Ms;
  }
  static installModule(t) {
    be.prototype.__modules__ || (be.prototype.__modules__ = []);
    const i = be.prototype.__modules__;
    typeof t == "function" && i.indexOf(t) < 0 && i.push(t);
  }
  static use(t) {
    return Array.isArray(t) ? (t.forEach((i) => be.installModule(i)), be) : (be.installModule(t), be);
  }
}
Object.keys(vi).forEach((e) => {
  Object.keys(vi[e]).forEach((t) => {
    be.prototype[t] = vi[e][t];
  });
});
be.use([nu, ru]);
function uf(e, t, i, s) {
  return e.params.createElements && Object.keys(s).forEach((n) => {
    if (!i[n] && i.auto === !0) {
      let r = Ce(e.el, `.${s[n]}`)[0];
      r || (r = xt("div", s[n]), r.className = s[n], e.el.append(r)), i[n] = r, t[n] = r;
    }
  }), i;
}
function qe(e) {
  return e === void 0 && (e = ""), `.${e.trim().replace(/([\.:!+\/])/g, "\\$1").replace(/ /g, ".")}`;
}
function ff(e) {
  let {
    swiper: t,
    extendParams: i,
    on: s,
    emit: n
  } = e;
  const r = "swiper-pagination";
  i({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: !1,
      hideOnClick: !1,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: !1,
      type: "bullets",
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: !1,
      dynamicMainBullets: 1,
      formatFractionCurrent: (f) => f,
      formatFractionTotal: (f) => f,
      bulletClass: `${r}-bullet`,
      bulletActiveClass: `${r}-bullet-active`,
      modifierClass: `${r}-`,
      currentClass: `${r}-current`,
      totalClass: `${r}-total`,
      hiddenClass: `${r}-hidden`,
      progressbarFillClass: `${r}-progressbar-fill`,
      progressbarOppositeClass: `${r}-progressbar-opposite`,
      clickableClass: `${r}-clickable`,
      lockClass: `${r}-lock`,
      horizontalClass: `${r}-horizontal`,
      verticalClass: `${r}-vertical`,
      paginationDisabledClass: `${r}-disabled`
    }
  }), t.pagination = {
    el: null,
    bullets: []
  };
  let a, o = 0;
  function l() {
    return !t.params.pagination.el || !t.pagination.el || Array.isArray(t.pagination.el) && t.pagination.el.length === 0;
  }
  function c(f, m) {
    const {
      bulletActiveClass: v
    } = t.params.pagination;
    f && (f = f[`${m === "prev" ? "previous" : "next"}ElementSibling`], f && (f.classList.add(`${v}-${m}`), f = f[`${m === "prev" ? "previous" : "next"}ElementSibling`], f && f.classList.add(`${v}-${m}-${m}`)));
  }
  function d(f, m, v) {
    if (f = f % v, m = m % v, m === f + 1)
      return "next";
    if (m === f - 1)
      return "previous";
  }
  function u(f) {
    const m = f.target.closest(qe(t.params.pagination.bulletClass));
    if (!m)
      return;
    f.preventDefault();
    const v = St(m) * t.params.slidesPerGroup;
    if (t.params.loop) {
      if (t.realIndex === v) return;
      const w = d(t.realIndex, v, t.slides.length);
      w === "next" ? t.slideNext() : w === "previous" ? t.slidePrev() : t.slideToLoop(v);
    } else
      t.slideTo(v);
  }
  function h() {
    const f = t.rtl, m = t.params.pagination;
    if (l()) return;
    let v = t.pagination.el;
    v = U(v);
    let w, y;
    const S = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : t.slides.length, k = t.params.loop ? Math.ceil(S / t.params.slidesPerGroup) : t.snapGrid.length;
    if (t.params.loop ? (y = t.previousRealIndex || 0, w = t.params.slidesPerGroup > 1 ? Math.floor(t.realIndex / t.params.slidesPerGroup) : t.realIndex) : typeof t.snapIndex < "u" ? (w = t.snapIndex, y = t.previousSnapIndex) : (y = t.previousIndex || 0, w = t.activeIndex || 0), m.type === "bullets" && t.pagination.bullets && t.pagination.bullets.length > 0) {
      const O = t.pagination.bullets;
      let M, C, D;
      if (m.dynamicBullets && (a = ki(O[0], t.isHorizontal() ? "width" : "height"), v.forEach((P) => {
        P.style[t.isHorizontal() ? "width" : "height"] = `${a * (m.dynamicMainBullets + 4)}px`;
      }), m.dynamicMainBullets > 1 && y !== void 0 && (o += w - (y || 0), o > m.dynamicMainBullets - 1 ? o = m.dynamicMainBullets - 1 : o < 0 && (o = 0)), M = Math.max(w - o, 0), C = M + (Math.min(O.length, m.dynamicMainBullets) - 1), D = (C + M) / 2), O.forEach((P) => {
        const $ = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((B) => `${m.bulletActiveClass}${B}`)].map((B) => typeof B == "string" && B.includes(" ") ? B.split(" ") : B).flat();
        P.classList.remove(...$);
      }), v.length > 1)
        O.forEach((P) => {
          const $ = St(P);
          $ === w ? P.classList.add(...m.bulletActiveClass.split(" ")) : t.isElement && P.setAttribute("part", "bullet"), m.dynamicBullets && ($ >= M && $ <= C && P.classList.add(...`${m.bulletActiveClass}-main`.split(" ")), $ === M && c(P, "prev"), $ === C && c(P, "next"));
        });
      else {
        const P = O[w];
        if (P && P.classList.add(...m.bulletActiveClass.split(" ")), t.isElement && O.forEach(($, B) => {
          $.setAttribute("part", B === w ? "bullet-active" : "bullet");
        }), m.dynamicBullets) {
          const $ = O[M], B = O[C];
          for (let R = M; R <= C; R += 1)
            O[R] && O[R].classList.add(...`${m.bulletActiveClass}-main`.split(" "));
          c($, "prev"), c(B, "next");
        }
      }
      if (m.dynamicBullets) {
        const P = Math.min(O.length, m.dynamicMainBullets + 4), $ = (a * P - a) / 2 - D * a, B = f ? "right" : "left";
        O.forEach((R) => {
          R.style[t.isHorizontal() ? B : "top"] = `${$}px`;
        });
      }
    }
    v.forEach((O, M) => {
      if (m.type === "fraction" && (O.querySelectorAll(qe(m.currentClass)).forEach((C) => {
        C.textContent = m.formatFractionCurrent(w + 1);
      }), O.querySelectorAll(qe(m.totalClass)).forEach((C) => {
        C.textContent = m.formatFractionTotal(k);
      })), m.type === "progressbar") {
        let C;
        m.progressbarOpposite ? C = t.isHorizontal() ? "vertical" : "horizontal" : C = t.isHorizontal() ? "horizontal" : "vertical";
        const D = (w + 1) / k;
        let P = 1, $ = 1;
        C === "horizontal" ? P = D : $ = D, O.querySelectorAll(qe(m.progressbarFillClass)).forEach((B) => {
          B.style.transform = `translate3d(0,0,0) scaleX(${P}) scaleY(${$})`, B.style.transitionDuration = `${t.params.speed}ms`;
        });
      }
      m.type === "custom" && m.renderCustom ? (Ci(O, m.renderCustom(t, w + 1, k)), M === 0 && n("paginationRender", O)) : (M === 0 && n("paginationRender", O), n("paginationUpdate", O)), t.params.watchOverflow && t.enabled && O.classList[t.isLocked ? "add" : "remove"](m.lockClass);
    });
  }
  function g() {
    const f = t.params.pagination;
    if (l()) return;
    const m = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : t.grid && t.params.grid.rows > 1 ? t.slides.length / Math.ceil(t.params.grid.rows) : t.slides.length;
    let v = t.pagination.el;
    v = U(v);
    let w = "";
    if (f.type === "bullets") {
      let y = t.params.loop ? Math.ceil(m / t.params.slidesPerGroup) : t.snapGrid.length;
      t.params.freeMode && t.params.freeMode.enabled && y > m && (y = m);
      for (let S = 0; S < y; S += 1)
        f.renderBullet ? w += f.renderBullet.call(t, S, f.bulletClass) : w += `<${f.bulletElement} ${t.isElement ? 'part="bullet"' : ""} class="${f.bulletClass}"></${f.bulletElement}>`;
    }
    f.type === "fraction" && (f.renderFraction ? w = f.renderFraction.call(t, f.currentClass, f.totalClass) : w = `<span class="${f.currentClass}"></span> / <span class="${f.totalClass}"></span>`), f.type === "progressbar" && (f.renderProgressbar ? w = f.renderProgressbar.call(t, f.progressbarFillClass) : w = `<span class="${f.progressbarFillClass}"></span>`), t.pagination.bullets = [], v.forEach((y) => {
      f.type !== "custom" && Ci(y, w || ""), f.type === "bullets" && t.pagination.bullets.push(...y.querySelectorAll(qe(f.bulletClass)));
    }), f.type !== "custom" && n("paginationRender", v[0]);
  }
  function _() {
    t.params.pagination = uf(t, t.originalParams.pagination, t.params.pagination, {
      el: "swiper-pagination"
    });
    const f = t.params.pagination;
    if (!f.el) return;
    let m;
    typeof f.el == "string" && t.isElement && (m = t.el.querySelector(f.el)), !m && typeof f.el == "string" && (m = [...document.querySelectorAll(f.el)]), m || (m = f.el), !(!m || m.length === 0) && (t.params.uniqueNavElements && typeof f.el == "string" && Array.isArray(m) && m.length > 1 && (m = [...t.el.querySelectorAll(f.el)], m.length > 1 && (m = m.find((v) => rn(v, ".swiper")[0] === t.el))), Array.isArray(m) && m.length === 1 && (m = m[0]), Object.assign(t.pagination, {
      el: m
    }), m = U(m), m.forEach((v) => {
      f.type === "bullets" && f.clickable && v.classList.add(...(f.clickableClass || "").split(" ")), v.classList.add(f.modifierClass + f.type), v.classList.add(t.isHorizontal() ? f.horizontalClass : f.verticalClass), f.type === "bullets" && f.dynamicBullets && (v.classList.add(`${f.modifierClass}${f.type}-dynamic`), o = 0, f.dynamicMainBullets < 1 && (f.dynamicMainBullets = 1)), f.type === "progressbar" && f.progressbarOpposite && v.classList.add(f.progressbarOppositeClass), f.clickable && v.addEventListener("click", u), t.enabled || v.classList.add(f.lockClass);
    }));
  }
  function b() {
    const f = t.params.pagination;
    if (l()) return;
    let m = t.pagination.el;
    m && (m = U(m), m.forEach((v) => {
      v.classList.remove(f.hiddenClass), v.classList.remove(f.modifierClass + f.type), v.classList.remove(t.isHorizontal() ? f.horizontalClass : f.verticalClass), f.clickable && (v.classList.remove(...(f.clickableClass || "").split(" ")), v.removeEventListener("click", u));
    })), t.pagination.bullets && t.pagination.bullets.forEach((v) => v.classList.remove(...f.bulletActiveClass.split(" ")));
  }
  s("changeDirection", () => {
    if (!t.pagination || !t.pagination.el) return;
    const f = t.params.pagination;
    let {
      el: m
    } = t.pagination;
    m = U(m), m.forEach((v) => {
      v.classList.remove(f.horizontalClass, f.verticalClass), v.classList.add(t.isHorizontal() ? f.horizontalClass : f.verticalClass);
    });
  }), s("init", () => {
    t.params.pagination.enabled === !1 ? x() : (_(), g(), h());
  }), s("activeIndexChange", () => {
    typeof t.snapIndex > "u" && h();
  }), s("snapIndexChange", () => {
    h();
  }), s("snapGridLengthChange", () => {
    g(), h();
  }), s("destroy", () => {
    b();
  }), s("enable disable", () => {
    let {
      el: f
    } = t.pagination;
    f && (f = U(f), f.forEach((m) => m.classList[t.enabled ? "remove" : "add"](t.params.pagination.lockClass)));
  }), s("lock unlock", () => {
    h();
  }), s("click", (f, m) => {
    const v = m.target, w = U(t.pagination.el);
    if (t.params.pagination.el && t.params.pagination.hideOnClick && w && w.length > 0 && !v.classList.contains(t.params.pagination.bulletClass)) {
      if (t.navigation && (t.navigation.nextEl && v === t.navigation.nextEl || t.navigation.prevEl && v === t.navigation.prevEl)) return;
      const y = w[0].classList.contains(t.params.pagination.hiddenClass);
      n(y === !0 ? "paginationShow" : "paginationHide"), w.forEach((S) => S.classList.toggle(t.params.pagination.hiddenClass));
    }
  });
  const E = () => {
    t.el.classList.remove(t.params.pagination.paginationDisabledClass);
    let {
      el: f
    } = t.pagination;
    f && (f = U(f), f.forEach((m) => m.classList.remove(t.params.pagination.paginationDisabledClass))), _(), g(), h();
  }, x = () => {
    t.el.classList.add(t.params.pagination.paginationDisabledClass);
    let {
      el: f
    } = t.pagination;
    f && (f = U(f), f.forEach((m) => m.classList.add(t.params.pagination.paginationDisabledClass))), b();
  };
  Object.assign(t.pagination, {
    enable: E,
    disable: x,
    render: g,
    update: h,
    init: _,
    destroy: b
  });
}
function pf(e) {
  let {
    swiper: t,
    extendParams: i,
    on: s
  } = e;
  i({
    a11y: {
      enabled: !0,
      notificationClass: "swiper-notification",
      prevSlideMessage: "Previous slide",
      nextSlideMessage: "Next slide",
      firstSlideMessage: "This is the first slide",
      lastSlideMessage: "This is the last slide",
      paginationBulletMessage: "Go to slide {{index}}",
      slideLabelMessage: "{{index}} / {{slidesLength}}",
      containerMessage: null,
      containerRoleDescriptionMessage: null,
      containerRole: null,
      itemRoleDescriptionMessage: null,
      slideRole: "group",
      id: null,
      scrollOnFocus: !0
    }
  }), t.a11y = {
    clicked: !1
  };
  let n = null, r, a, o = (/* @__PURE__ */ new Date()).getTime();
  function l(A) {
    const N = n;
    N.length !== 0 && Ci(N, A);
  }
  function c(A) {
    const N = () => Math.round(16 * Math.random()).toString(16);
    return "x".repeat(A).replace(/x/g, N);
  }
  function d(A) {
    A = U(A), A.forEach((N) => {
      N.setAttribute("tabIndex", "0");
    });
  }
  function u(A) {
    A = U(A), A.forEach((N) => {
      N.setAttribute("tabIndex", "-1");
    });
  }
  function h(A, N) {
    A = U(A), A.forEach((z) => {
      z.setAttribute("role", N);
    });
  }
  function g(A, N) {
    A = U(A), A.forEach((z) => {
      z.setAttribute("aria-roledescription", N);
    });
  }
  function _(A, N) {
    A = U(A), A.forEach((z) => {
      z.setAttribute("aria-controls", N);
    });
  }
  function b(A, N) {
    A = U(A), A.forEach((z) => {
      z.setAttribute("aria-label", N);
    });
  }
  function E(A, N) {
    A = U(A), A.forEach((z) => {
      z.setAttribute("id", N);
    });
  }
  function x(A, N) {
    A = U(A), A.forEach((z) => {
      z.setAttribute("aria-live", N);
    });
  }
  function f(A) {
    A = U(A), A.forEach((N) => {
      N.setAttribute("aria-disabled", !0);
    });
  }
  function m(A) {
    A = U(A), A.forEach((N) => {
      N.setAttribute("aria-disabled", !1);
    });
  }
  function v(A) {
    if (A.keyCode !== 13 && A.keyCode !== 32) return;
    const N = t.params.a11y, z = A.target;
    if (!(t.pagination && t.pagination.el && (z === t.pagination.el || t.pagination.el.contains(A.target)) && !A.target.matches(qe(t.params.pagination.bulletClass)))) {
      if (t.navigation && t.navigation.prevEl && t.navigation.nextEl) {
        const G = U(t.navigation.prevEl);
        U(t.navigation.nextEl).includes(z) && (t.isEnd && !t.params.loop || t.slideNext(), t.isEnd ? l(N.lastSlideMessage) : l(N.nextSlideMessage)), G.includes(z) && (t.isBeginning && !t.params.loop || t.slidePrev(), t.isBeginning ? l(N.firstSlideMessage) : l(N.prevSlideMessage));
      }
      t.pagination && z.matches(qe(t.params.pagination.bulletClass)) && z.click();
    }
  }
  function w() {
    if (t.params.loop || t.params.rewind || !t.navigation) return;
    const {
      nextEl: A,
      prevEl: N
    } = t.navigation;
    N && (t.isBeginning ? (f(N), u(N)) : (m(N), d(N))), A && (t.isEnd ? (f(A), u(A)) : (m(A), d(A)));
  }
  function y() {
    return t.pagination && t.pagination.bullets && t.pagination.bullets.length;
  }
  function S() {
    return y() && t.params.pagination.clickable;
  }
  function k() {
    const A = t.params.a11y;
    y() && t.pagination.bullets.forEach((N) => {
      t.params.pagination.clickable && (d(N), t.params.pagination.renderBullet || (h(N, "button"), b(N, A.paginationBulletMessage.replace(/\{\{index\}\}/, St(N) + 1)))), N.matches(qe(t.params.pagination.bulletActiveClass)) ? N.setAttribute("aria-current", "true") : N.removeAttribute("aria-current");
    });
  }
  const O = (A, N, z) => {
    d(A), A.tagName !== "BUTTON" && (h(A, "button"), A.addEventListener("keydown", v)), b(A, z), _(A, N);
  }, M = (A) => {
    a && a !== A.target && !a.contains(A.target) && (r = !0), t.a11y.clicked = !0;
  }, C = () => {
    r = !1, requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        t.destroyed || (t.a11y.clicked = !1);
      });
    });
  }, D = (A) => {
    o = (/* @__PURE__ */ new Date()).getTime();
  }, P = (A) => {
    if (t.a11y.clicked || !t.params.a11y.scrollOnFocus || (/* @__PURE__ */ new Date()).getTime() - o < 100) return;
    const N = A.target.closest(`.${t.params.slideClass}, swiper-slide`);
    if (!N || !t.slides.includes(N)) return;
    a = N;
    const z = t.slides.indexOf(N) === t.activeIndex, G = t.params.watchSlidesProgress && t.visibleSlides && t.visibleSlides.includes(N);
    z || G || A.sourceCapabilities && A.sourceCapabilities.firesTouchEvents || (t.isHorizontal() ? t.el.scrollLeft = 0 : t.el.scrollTop = 0, requestAnimationFrame(() => {
      r || (t.params.loop ? t.slideToLoop(parseInt(N.getAttribute("data-swiper-slide-index")), 0) : t.slideTo(t.slides.indexOf(N), 0), r = !1);
    }));
  }, $ = () => {
    const A = t.params.a11y;
    A.itemRoleDescriptionMessage && g(t.slides, A.itemRoleDescriptionMessage), A.slideRole && h(t.slides, A.slideRole);
    const N = t.slides.length;
    A.slideLabelMessage && t.slides.forEach((z, G) => {
      const J = t.params.loop ? parseInt(z.getAttribute("data-swiper-slide-index"), 10) : G, X = A.slideLabelMessage.replace(/\{\{index\}\}/, J + 1).replace(/\{\{slidesLength\}\}/, N);
      b(z, X);
    });
  }, B = () => {
    const A = t.params.a11y;
    t.el.append(n);
    const N = t.el;
    A.containerRoleDescriptionMessage && g(N, A.containerRoleDescriptionMessage), A.containerMessage && b(N, A.containerMessage), A.containerRole && h(N, A.containerRole);
    const z = t.wrapperEl, G = A.id || z.getAttribute("id") || `swiper-wrapper-${c(16)}`, J = t.params.autoplay && t.params.autoplay.enabled ? "off" : "polite";
    E(z, G), x(z, J), $();
    let {
      nextEl: X,
      prevEl: K
    } = t.navigation ? t.navigation : {};
    X = U(X), K = U(K), X && X.forEach((re) => O(re, G, A.nextSlideMessage)), K && K.forEach((re) => O(re, G, A.prevSlideMessage)), S() && U(t.pagination.el).forEach((Re) => {
      Re.addEventListener("keydown", v);
    }), He().addEventListener("visibilitychange", D), t.el.addEventListener("focus", P, !0), t.el.addEventListener("focus", P, !0), t.el.addEventListener("pointerdown", M, !0), t.el.addEventListener("pointerup", C, !0);
  };
  function R() {
    n && n.remove();
    let {
      nextEl: A,
      prevEl: N
    } = t.navigation ? t.navigation : {};
    A = U(A), N = U(N), A && A.forEach((G) => G.removeEventListener("keydown", v)), N && N.forEach((G) => G.removeEventListener("keydown", v)), S() && U(t.pagination.el).forEach((J) => {
      J.removeEventListener("keydown", v);
    }), He().removeEventListener("visibilitychange", D), t.el && typeof t.el != "string" && (t.el.removeEventListener("focus", P, !0), t.el.removeEventListener("pointerdown", M, !0), t.el.removeEventListener("pointerup", C, !0));
  }
  s("beforeInit", () => {
    n = xt("span", t.params.a11y.notificationClass), n.setAttribute("aria-live", "assertive"), n.setAttribute("aria-atomic", "true");
  }), s("afterInit", () => {
    t.params.a11y.enabled && B();
  }), s("slidesLengthChange snapGridLengthChange slidesGridLengthChange", () => {
    t.params.a11y.enabled && $();
  }), s("fromEdge toEdge afterInit lock unlock", () => {
    t.params.a11y.enabled && w();
  }), s("paginationUpdate", () => {
    t.params.a11y.enabled && k();
  }), s("destroy", () => {
    t.params.a11y.enabled && R();
  });
}
function hf(e) {
  const {
    effect: t,
    swiper: i,
    on: s,
    setTranslate: n,
    setTransition: r,
    overwriteParams: a,
    perspective: o,
    recreateShadows: l,
    getEffectParams: c
  } = e;
  s("beforeInit", () => {
    if (i.params.effect !== t) return;
    i.classNames.push(`${i.params.containerModifierClass}${t}`), o && o() && i.classNames.push(`${i.params.containerModifierClass}3d`);
    const u = a ? a() : {};
    Object.assign(i.params, u), Object.assign(i.originalParams, u);
  }), s("setTranslate _virtualUpdated", () => {
    i.params.effect === t && n();
  }), s("setTransition", (u, h) => {
    i.params.effect === t && r(h);
  }), s("transitionEnd", () => {
    if (i.params.effect === t && l) {
      if (!c || !c().slideShadows) return;
      i.slides.forEach((u) => {
        u.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((h) => h.remove());
      }), l();
    }
  });
  let d;
  s("virtualUpdate", () => {
    i.params.effect === t && (i.slides.length || (d = !0), requestAnimationFrame(() => {
      d && i.slides && i.slides.length && (n(), d = !1);
    }));
  });
}
function mf(e, t) {
  const i = nn(t);
  return i !== t && (i.style.backfaceVisibility = "hidden", i.style["-webkit-backface-visibility"] = "hidden"), i;
}
function gf(e) {
  let {
    swiper: t,
    duration: i,
    transformElements: s,
    allSlides: n
  } = e;
  const {
    activeIndex: r
  } = t, a = (o) => o.parentElement ? o.parentElement : t.slides.find((c) => c.shadowRoot && c.shadowRoot === o.parentNode);
  if (t.params.virtualTranslate && i !== 0) {
    let o = !1, l;
    n ? l = s : l = s.filter((c) => {
      const d = c.classList.contains("swiper-slide-transform") ? a(c) : c;
      return t.getSlideIndex(d) === r;
    }), l.forEach((c) => {
      eu(c, () => {
        if (o || !t || t.destroyed) return;
        o = !0, t.animating = !1;
        const d = new window.CustomEvent("transitionend", {
          bubbles: !0,
          cancelable: !0
        });
        t.wrapperEl.dispatchEvent(d);
      });
    });
  }
}
function vf(e) {
  let {
    swiper: t,
    extendParams: i,
    on: s
  } = e;
  i({
    fadeEffect: {
      crossFade: !1
    }
  }), hf({
    effect: "fade",
    swiper: t,
    on: s,
    setTranslate: () => {
      const {
        slides: a
      } = t, o = t.params.fadeEffect;
      for (let l = 0; l < a.length; l += 1) {
        const c = t.slides[l];
        let u = -c.swiperSlideOffset;
        t.params.virtualTranslate || (u -= t.translate);
        let h = 0;
        t.isHorizontal() || (h = u, u = 0);
        const g = t.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(c.progress), 0) : 1 + Math.min(Math.max(c.progress, -1), 0), _ = mf(o, c);
        _.style.opacity = g, _.style.transform = `translate3d(${u}px, ${h}px, 0px)`;
      }
    },
    setTransition: (a) => {
      const o = t.slides.map((l) => nn(l));
      o.forEach((l) => {
        l.style.transitionDuration = `${a}ms`;
      }), gf({
        swiper: t,
        duration: a,
        transformElements: o,
        allSlides: !0
      });
    },
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      spaceBetween: 0,
      virtualTranslate: !t.params.cssMode
    })
  });
}
var Yt = /* @__PURE__ */ ((e) => (e.BY_SLIDE = "by-slide", e.BY_PAGE = "by-page", e))(Yt || {}), Ye = /* @__PURE__ */ ((e) => (e.ENTER_FROM_RIGHT = "enter-from-right", e.CROSSFADE = "crossfade", e))(Ye || {});
const ks = (e) => e <= 2 ? 1 : 2, wi = {
  [te.SMALL]: 25,
  [te.MEDIUM]: 24,
  [te.LARGE]: 30,
  [te.X_LARGE]: 0,
  // unused, 0 is library default
  [te.XX_LARGE]: 0
  // unused, 0 is library default
}, _f = {
  [Ye.ENTER_FROM_RIGHT]: 500,
  [Ye.CROSSFADE]: 800
}, wf = {
  [Ye.ENTER_FROM_RIGHT]: "slide",
  [Ye.CROSSFADE]: "fade"
}, bf = (e, t, i) => ({
  [te.SMALL]: {
    spaceBetween: wi[te.SMALL],
    slidesPerView: 1,
    slidesPerGroup: 1
  },
  [te.MEDIUM]: {
    spaceBetween: wi[te.MEDIUM],
    slidesPerView: ks(e),
    slidesPerGroup: i === Yt.BY_PAGE ? ks(e) : 1
  },
  [te.LARGE]: {
    spaceBetween: wi[te.LARGE],
    /**
     * https://github.com/nolimits4web/swiper/issues/2062
     */
    slidesPerView: t === Ye.CROSSFADE ? 1 : e,
    slidesPerGroup: i === Yt.BY_PAGE ? e : 1
  }
}), yf = (e) => _f[e], Ef = (e) => wf[e], bi = (e) => {
  const t = e.el.querySelectorAll(".swiper-slide-visible"), i = Array.from(t);
  e.slides.forEach((s) => {
    i.includes(s) ? (s.removeAttribute("inert"), s.removeAttribute("aria-hidden")) : (s.setAttribute("inert", ""), s.setAttribute("aria-hidden", "true"));
  });
}, Dp = ({
  id: e,
  slidesPerPage: t,
  nextSlideLabel: i,
  prevSlideLabel: s,
  trackSlide: n,
  transition: r = Yt.BY_PAGE,
  animation: a,
  slot: o,
  children: l
}) => {
  const c = `${Ue(36)}rem`, [d, u] = V(0), [h, g] = V(!0), [_, b] = V(!1), [E, x] = V(!1), f = H(null), m = H(null), v = Ks(), w = (k) => {
    g(k.isBeginning), b(k.isEnd);
  };
  F(() => (v && a !== Ye.CROSSFADE ? u(0) : u(yf(a)), f.current && (m.current = new be(f.current, {
    a11y: { enabled: !0 },
    modules: [ff, vf, pf],
    watchSlidesProgress: !0,
    watchOverflow: !0,
    noSwipingClass: "vjs-control-bar",
    navigation: !1,
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
      renderFraction(k, O) {
        return document.documentElement.getAttribute("dir") === "rtl" ? `<span class="${O}"></span>/<span class="${k}"></span>` : `<span class="${k}"></span>/<span class="${O}"></span>`;
      }
    },
    on: {
      init: (k) => {
        w(k), bi(k), x(k.isLocked);
      },
      slideChange: (k) => {
        w(k), bi(k);
      },
      activeIndexChange: (k) => {
        n(k.snapIndex, k.previousIndex, e);
      },
      resize: (k) => {
        w(k), bi(k), x(k.isLocked);
      },
      lock: () => x(!0),
      unlock: () => x(!1)
    },
    effect: Ef(a),
    fadeEffect: {
      crossFade: a === Ye.CROSSFADE
    },
    speed: d,
    observer: !0,
    observeParents: !0,
    breakpoints: bf(t, a, r)
  })), () => {
    m.current && (m.current.destroy(), m.current = null);
  }), [v]);
  const y = () => {
    m.current && m.current.slideNext(d);
  }, S = () => {
    m.current && m.current.slidePrev(d);
  };
  return l ? /* @__PURE__ */ I("div", { className: "swiper", ref: f, slot: o, children: [
    /* @__PURE__ */ p("div", { className: "swiper-wrapper", children: l.map((k, O) => /* @__PURE__ */ p("div", { className: "swiper-slide", children: k }, `swiper-slide-${O}`)) }),
    /* @__PURE__ */ p(
      "div",
      {
        className: L(
          Ve["swiper__controls-wrapper"],
          E && Ve["swiper__controls-wrapper--navigation-hidden"]
        ),
        children: /* @__PURE__ */ I("div", { className: Ve.swiper__controls, children: [
          /* @__PURE__ */ p(
            "button",
            {
              className: L(Ve["swiper__button-prev-custom"], h && Ve["swiper__button--disabled"]),
              onClick: S,
              disabled: h,
              "aria-disabled": h,
              "aria-label": s,
              children: /* @__PURE__ */ p("span", { className: Ve["swiper__button-icon-custom"], children: /* @__PURE__ */ p(q, { icon: "chevron-left", height: c, decorative: !0 }) })
            }
          ),
          /* @__PURE__ */ p("div", { className: "swiper-pagination" }),
          /* @__PURE__ */ p(
            "button",
            {
              className: L(Ve["swiper__button-next-custom"], _ && Ve["swiper__button--disabled"]),
              onClick: y,
              disabled: _,
              "aria-disabled": _,
              "aria-label": i,
              children: /* @__PURE__ */ p("span", { className: Ve["swiper__button-icon-custom"], children: /* @__PURE__ */ p(q, { icon: "chevron-right", height: c, decorative: !0 }) })
            }
          )
        ] })
      }
    )
  ] }) : null;
};
var _t = /* @__PURE__ */ ((e) => (e.DEFAULT = "", e.LEFT = "left", e.CENTER = "center", e.RIGHT = "right", e))(_t || {});
const de = {
  "social-media": "social-media",
  "social-media__overline": "social-media__overline",
  "social-media__links-list": "social-media__links-list",
  "social-media__icon": "social-media__icon",
  "social-media__link-wrapper": "social-media__link-wrapper",
  "social-media__link": "social-media__link",
  "social-media__copy-feedback": "social-media__copy-feedback",
  "social-media__copy-feedback--show": "social-media__copy-feedback--show",
  "social-media__copy-feedback-content": "social-media__copy-feedback-content",
  "social-media__copy-feedback-arrow": "social-media__copy-feedback-arrow",
  "social-media--align-left": "social-media--align-left",
  "social-media--align-center": "social-media--align-center",
  "social-media--align-right": "social-media--align-right"
}, xf = 24, zp = ({
  overline: e,
  align: t = _t.DEFAULT,
  disableFacebook: i = !1,
  disableTwitter: s = !1,
  disableLinkedin: n = !1,
  mailToSubject: r,
  url: a,
  facebookLabel: o,
  twitterLabel: l,
  linkedinLabel: c,
  copylinkLabel: d,
  copySuccessLabel: u,
  onClick: h
}) => {
  const [g, _] = V(!1), b = [
    {
      "data-social": "email",
      icon: "mobile",
      href: `mailto:?subject=${r}&body=${a}`,
      type: "link",
      shouldRender: !1
    },
    {
      "data-social": "facebook",
      icon: "facebook",
      href: `https://www.facebook.com/sharer/sharer.php?u=${a}`,
      type: "link",
      shouldRender: !i,
      ariaLabel: o
    },
    {
      "data-social": "twitter",
      icon: "twitter",
      href: `http://twitter.com/intent/tweet?url=${a}`,
      type: "link",
      shouldRender: !s,
      ariaLabel: l
    },
    {
      "data-social": "linkedin",
      icon: "linkedin",
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${a}`,
      type: "link",
      shouldRender: !n,
      ariaLabel: c
    },
    {
      "data-social": "xing",
      icon: "mobile",
      href: `https://www.xing.com/spi/shares/new?url=${a}`,
      type: "link",
      shouldRender: !1
    },
    {
      "data-social": "copy",
      icon: "copy-link",
      href: "#",
      type: "button",
      shouldRender: !0,
      ariaLabel: d
    }
  ], E = async (f) => {
    const m = f.currentTarget.getAttribute("data-social");
    m === "copy" && (f.preventDefault(), await navigator.clipboard.writeText(a), _(!0), setTimeout(() => _(!1), 2200)), m && h && h(f, m);
  }, x = L(
    de["social-media"],
    t === _t.LEFT && de["social-media--align-left"],
    t === _t.CENTER && de["social-media--align-center"],
    t === _t.RIGHT && de["social-media--align-right"]
  );
  return /* @__PURE__ */ I("div", { className: x, children: [
    e && /* @__PURE__ */ p("p", { className: de["social-media__overline"], children: e }),
    /* @__PURE__ */ p("ul", { className: de["social-media__links-list"], children: b.map((f, m) => {
      const { shouldRender: v, icon: w, ariaLabel: y, type: S, ...k } = f;
      if (!v)
        return null;
      const O = f["data-social"], M = O === "copy";
      return /* @__PURE__ */ I("li", { className: de["social-media__link-wrapper"], children: [
        /* @__PURE__ */ p("span", { className: de["social-media__icon"], children: /* @__PURE__ */ p(q, { icon: w, height: `${Ue(xf)}rem`, decorative: !0 }) }),
        S === "button" ? /* @__PURE__ */ p(
          "button",
          {
            className: de["social-media__link"],
            onClick: E,
            "aria-label": y,
            "data-social": O,
            type: "button"
          }
        ) : /* @__PURE__ */ p(
          "a",
          {
            className: de["social-media__link"],
            target: "_blank",
            rel: "noreferrer",
            onClick: E,
            "aria-label": y,
            ...k
          }
        ),
        M && /* @__PURE__ */ I(
          "div",
          {
            className: L(
              de["social-media__copy-feedback"],
              g && de["social-media__copy-feedback--show"]
            ),
            role: "alert",
            "aria-live": "assertive",
            "aria-atomic": "true",
            children: [
              /* @__PURE__ */ p("span", { className: de["social-media__copy-feedback-content"], children: u }),
              /* @__PURE__ */ p("div", { className: de["social-media__copy-feedback-arrow"] })
            ]
          }
        )
      ] }, m);
    }) })
  ] });
}, vt = {
  "stage-home-teaser": "stage-home-teaser",
  "stage-home-teaser__title": "stage-home-teaser__title",
  "stage-home-teaser__description": "stage-home-teaser__description",
  "stage-home-teaser__button-wrapper": "stage-home-teaser__button-wrapper"
}, Vp = ({
  teaserTitle: e,
  teaserDescription: t,
  headingLevel: i = 2,
  children: s
}) => {
  const n = `h${i}`;
  return /* @__PURE__ */ I("div", { className: vt["stage-home-teaser"], children: [
    /* @__PURE__ */ I("div", { className: vt["stage-home-teaser__top-wrapper"], children: [
      /* @__PURE__ */ p(n, { className: vt["stage-home-teaser__title"], children: e }),
      /* @__PURE__ */ p("p", { className: vt["stage-home-teaser__description"], children: t })
    ] }),
    /* @__PURE__ */ p("div", { className: vt["stage-home-teaser__button-wrapper"], children: s })
  ] });
}, Sf = "image", Tf = {
  "scale-on-scroll": "scale-on-scroll",
  image: Sf
}, Af = 1864, Mf = (e) => (Math.min(window.innerWidth, Af) - e) / e, kf = (e) => {
  const t = e.getAttribute("data-ratio");
  if (!t) return null;
  const [i, s] = t.split(":").map(parseFloat);
  return i && s ? [i, s] : null;
}, Cf = ({ children: e }) => {
  const t = H(null), [i, s] = V(1), [n, r] = V("auto"), a = H(null);
  return F(() => {
    const o = t.current;
    if (!o)
      return;
    const l = () => {
      const d = o.querySelector(".image");
      if (!d) {
        a.current = null, r("auto");
        return;
      }
      const u = o.getBoundingClientRect().top + window.scrollY, h = o.getBoundingClientRect().width, g = Mf(h), _ = o.getBoundingClientRect().width, b = kf(d), E = b ? Math.floor(_ * b[1] / b[0]) : 0;
      a.current = {
        initialSpaceToViewTop: u,
        initialHeight: E,
        widthPercentage: g
      };
      const x = E * (1 + g);
      r(`${x}px`);
    }, c = () => {
      l();
    };
    return window.addEventListener("resize", c), l(), () => {
      window.removeEventListener("resize", c);
    };
  }, []), F(() => {
    const o = t.current;
    if (!o || !a.current) return;
    const l = () => {
      const c = o.getBoundingClientRect().top, d = window.innerHeight;
      if (!(c > d || c < -0.3 * d) && a.current) {
        const { initialSpaceToViewTop: h, widthPercentage: g } = a.current, _ = Math.min(h, d), b = d > h, E = b ? 1 : 0.75, f = _ * (b ? 0.1 : 0.25), m = _ * (1 - E), v = _ - f - m, w = Math.min(
          Math.max((_ - c - f) / v, 0),
          1
        ), y = 1 + g * w;
        s(y);
      }
    };
    return window.addEventListener("scroll", l, { passive: !0 }), () => {
      window.removeEventListener("scroll", l);
    };
  }, [t.current, a.current]), /* @__PURE__ */ p(
    "div",
    {
      ref: t,
      className: Tf["scale-on-scroll"],
      style: {
        "--scale-factor": i,
        height: n
      },
      children: e
    }
  );
}, Nf = "headline", If = "image", Of = {
  "stage-home": "stage-home",
  headline: Nf,
  "headline--1": "headline--1",
  "stage-home--heading-visible": "stage-home--heading-visible",
  "stage-home--original-branding": "stage-home--original-branding",
  "scale-on-scroll": "scale-on-scroll",
  "video-player": "video-player",
  image: If,
  "stage-home__teasers": "stage-home__teasers",
  "stage-home-teaser": "stage-home-teaser"
}, Bp = ({
  statement: e,
  Image: t,
  slot: i,
  children: s
}) => {
  const [n, r] = V(!1);
  F(() => {
    r(!0);
  }, []);
  const a = L({
    "stage-home": !0,
    "stage-home--original-branding": e === "Doing now what patients need next",
    "stage-home--heading-visible": n
  });
  return /* @__PURE__ */ I("div", { className: a, slot: i, children: [
    /* @__PURE__ */ p(zs, { headline: e, level: "1" }),
    /* @__PURE__ */ p(Cf, { children: t }),
    /* @__PURE__ */ p("div", { className: Of["stage-home__teasers"], children: s })
  ] });
}, Rf = "image", Ae = {
  "staging-hero": "staging-hero",
  "staging-hero__background": "staging-hero__background",
  "staging-hero__image": "staging-hero__image",
  image: Rf,
  "staging-hero__wrapper": "staging-hero__wrapper",
  "staging-hero__content": "staging-hero__content",
  "staging-hero__headline": "staging-hero__headline",
  "staging-hero__text": "staging-hero__text",
  "staging-hero__divider": "staging-hero__divider",
  "hero--variant-a": "hero--variant-a",
  "staging-hero__letter": "staging-hero__letter",
  "hero--variant-b": "hero--variant-b"
};
var Xt = /* @__PURE__ */ ((e) => (e.VARIANT_A = "hero--variant-a", e.VARIANT_B = "hero--variant-b", e))(Xt || {});
const $p = ({
  variant: e = Xt.VARIANT_A,
  headline: t,
  content: i,
  Image: s,
  slot: n
}) => {
  const r = e === Xt.VARIANT_B, a = H(null), o = [Ae["staging-hero"], Ae[e]].filter(Boolean).join(" ");
  F(() => {
    var d;
    const c = (d = a.current) == null ? void 0 : d.closest("roche-grid");
    return c && (c.setAttribute("no-padding", "true"), c.setAttribute("data-staging-hero", e)), () => {
      c && (c.removeAttribute("no-padding"), c.removeAttribute("data-staging-hero"));
    };
  }, [e]);
  const l = r && s;
  return /* @__PURE__ */ I("section", { ref: a, className: o, "data-variant": e, slot: n, children: [
    /* @__PURE__ */ I("div", { className: Ae["staging-hero__wrapper"], children: [
      /* @__PURE__ */ p("div", { className: Ae["staging-hero__background"] }),
      /* @__PURE__ */ I("div", { className: Ae["staging-hero__content"], children: [
        /* @__PURE__ */ p("div", { className: Ae["staging-hero__letter"] }),
        t && /* @__PURE__ */ p("h1", { className: Ae["staging-hero__headline"], children: t }),
        i && /* @__PURE__ */ p("p", { className: Ae["staging-hero__text"], children: i })
      ] }),
      /* @__PURE__ */ p("div", { className: Ae["staging-hero__divider"] })
    ] }),
    l && /* @__PURE__ */ p("div", { className: Ae["staging-hero__image"], children: s })
  ] });
}, un = 2, fn = (e, t = "", i = un) => {
  const s = ["-", "", "+"][Math.sign(e) + 1], n = Math.abs(e).toFixed(i);
  return `${s}${t}${n}`;
}, Pf = (e) => `${fn(e, " ")}`, Lf = (e) => `(${fn(e)}%)`, ee = {
  "stock-price": "stock-price",
  "stock-price__heading": "stock-price__heading",
  "stock-price__price": "stock-price__price",
  "stock-price__value": "stock-price__value",
  "stock-price__currency": "stock-price__currency",
  "stock-price__unavailable": "stock-price__unavailable",
  "stock-price__daily-change": "stock-price__daily-change",
  "stock-price__difference": "stock-price__difference",
  "stock-price__relative-difference": "stock-price__relative-difference",
  "stock-price__price-difference": "stock-price__price-difference",
  "stock-price__icon": "stock-price__icon",
  "stock-price__icon--down": "stock-price__icon--down",
  "stock-price__icon--equal": "stock-price__icon--equal",
  "stock-price__icon--up": "stock-price__icon--up"
}, Hp = ({
  heading: e,
  href: t,
  price: i,
  currency: s,
  change: n,
  relativeChange: r,
  timeIntervalLabel: a,
  unavailableLabel: o
}) => {
  if (!(i !== void 0 && s !== void 0 && n !== void 0 && r !== void 0))
    return /* @__PURE__ */ I("div", { className: ee["stock-price"], children: [
      /* @__PURE__ */ p("h3", { className: ee["stock-price__heading"], children: e }),
      /* @__PURE__ */ p("span", { className: ee["stock-price__unavailable"], children: o })
    ] });
  const c = ["stock-down", "stock-equal", "stock-up"][Math.sign(n) + 1], d = L(ee["stock-price__icon"], {
    [ee["stock-price__icon--down"]]: c === "stock-down",
    [ee["stock-price__icon--equal"]]: c === "stock-equal",
    [ee["stock-price__icon--up"]]: c === "stock-up"
  });
  return /* @__PURE__ */ I("a", { className: ee["stock-price"], href: t, children: [
    /* @__PURE__ */ p("h3", { className: ee["stock-price__heading"], children: e }),
    /* @__PURE__ */ I("div", { className: ee["stock-price__price"], children: [
      /* @__PURE__ */ p("span", { className: ee["stock-price__value"], children: i.toFixed(un) }),
      /* @__PURE__ */ p("span", { className: ee["stock-price__currency"], children: s })
    ] }),
    /* @__PURE__ */ I("div", { className: ee["stock-price__daily-change"], children: [
      /* @__PURE__ */ p("span", { className: d, "aria-hidden": "true", children: /* @__PURE__ */ p(q, { icon: c, height: "32px" }) }),
      /* @__PURE__ */ I("span", { className: ee["stock-price__difference"], children: [
        /* @__PURE__ */ p("span", { className: ee["stock-price__price-difference"], children: Pf(n) }),
        /* @__PURE__ */ p("span", { className: ee["stock-price__relative-difference"], children: Lf(r) })
      ] }),
      /* @__PURE__ */ p("span", { className: ee["stock-price__time-interval"], children: a })
    ] })
  ] });
};
var Be = /* @__PURE__ */ ((e) => (e.DEFAULT = "default", e.PODCAST = "podcast", e.SERIES = "series", e.SLIDESHOW = "slideshow", e.VIDEO = "video", e))(Be || {}), Df = /* @__PURE__ */ ((e) => (e.VARIANT_A = "story-teaser--variant-a", e.VARIANT_B = "story-teaser--variant-b", e.VARIANT_C = "story-teaser--variant-c", e))(Df || {});
const Ii = {
  [Be.DEFAULT]: null,
  [Be.PODCAST]: "podcasts",
  [Be.SERIES]: "series",
  [Be.SLIDESHOW]: "book",
  [Be.VIDEO]: "play"
}, ae = {
  "story-staging-hero": "story-staging-hero",
  "story-staging-hero__background": "story-staging-hero__background",
  "story-staging-hero__wrapper": "story-staging-hero__wrapper",
  "story-staging-hero__content": "story-staging-hero__content",
  "story-staging-hero__header": "story-staging-hero__header",
  "story-staging-hero__headline": "story-staging-hero__headline",
  "story-staging-hero__text": "story-staging-hero__text",
  "story-staging-hero__divider": "story-staging-hero__divider",
  "story-staging-hero__story-type-wrapper": "story-staging-hero__story-type-wrapper",
  "story-staging-hero__story-type": "story-staging-hero__story-type",
  "story-staging-hero__tag-wrapper": "story-staging-hero__tag-wrapper",
  "hero--variant-a": "hero--variant-a",
  "story-staging-hero__letter": "story-staging-hero__letter",
  "story-staging-hero__image": "story-staging-hero__image",
  "hero--variant-b": "hero--variant-b",
  "story-staging-hero__icon": "story-staging-hero__icon"
}, Fp = ({
  variant: e,
  storyHeadline: t,
  storyDescription: i,
  storyType: s,
  storyTypeTranslation: n,
  storyTags: r,
  showTags: a,
  Image: o,
  slot: l
}) => {
  const c = e === Xt.VARIANT_B, d = H(null), u = [ae["story-staging-hero"], ae[e]].filter(Boolean).join(" "), h = c && a && r && r.length > 0, g = Ii[s] ?? "", _ = c && s && s !== Be.DEFAULT, b = c && o;
  return /* @__PURE__ */ I("section", { ref: d, className: u, "data-variant": e, slot: l, children: [
    /* @__PURE__ */ I("div", { className: ae["story-staging-hero__wrapper"], children: [
      /* @__PURE__ */ p("div", { className: ae["story-staging-hero__background"] }),
      /* @__PURE__ */ I("div", { className: ae["story-staging-hero__content"], children: [
        /* @__PURE__ */ p("div", { className: ae["story-staging-hero__letter"] }),
        _ && /* @__PURE__ */ I("div", { className: ae["story-staging-hero__story-type-wrapper"], children: [
          /* @__PURE__ */ p("span", { className: ae["story-staging-hero__icon"], children: /* @__PURE__ */ p(q, { icon: g, height: "24px" }) }),
          /* @__PURE__ */ p("span", { className: ae["story-staging-hero__story-type"], children: n })
        ] }),
        /* @__PURE__ */ I("div", { className: ae["story-staging-hero__header"], children: [
          t && /* @__PURE__ */ p("h1", { className: ae["story-staging-hero__headline"], children: t }),
          h && /* @__PURE__ */ p("div", { className: ae["story-staging-hero__tag-wrapper"], children: r })
        ] }),
        !c && /* @__PURE__ */ p("p", { className: ae["story-staging-hero__text"], children: i })
      ] }),
      /* @__PURE__ */ p("div", { className: ae["story-staging-hero__divider"] })
    ] }),
    b && /* @__PURE__ */ p("div", { className: ae["story-staging-hero__image"], children: o })
  ] });
}, zf = (e) => {
  const [t, i] = V(0);
  return F(() => {
    const s = () => {
      e.current && i(e.current.clientWidth);
    }, n = new ResizeObserver(s);
    return e.current && n.observe(e.current), () => n.disconnect();
  }, [e.current]), { width: t };
}, Vf = "date", Bf = {
  date: Vf
}, pn = ({ displayDate: e, dateTimeValue: t }) => /* @__PURE__ */ p("div", { className: Bf.date, children: /* @__PURE__ */ p("time", { dateTime: t, children: e }) }), $f = "image", Hf = "button", Me = {
  "story-teaser": "story-teaser",
  image: $f,
  "story-teaser__tag": "story-teaser__tag",
  "story-teaser__image-container": "story-teaser__image-container",
  "video-player": "video-player",
  "story-teaser__details": "story-teaser__details",
  "story-teaser__title": "story-teaser__title",
  "story-teaser__description": "story-teaser__description",
  "story-teaser__date": "story-teaser__date",
  "story-teaser--variant-a": "story-teaser--variant-a",
  "story-teaser__description-container": "story-teaser__description-container",
  "story-teaser--variant-b": "story-teaser--variant-b",
  "story-teaser--variant-c": "story-teaser--variant-c",
  button: Hf,
  "story-teaser--unpublished": "story-teaser--unpublished"
}, Cs = (e) => (t) => {
  e.forEach((i) => {
    i && (typeof i == "function" ? i(t) : i.current = t);
  });
}, Gp = Is(
  ({
    layout: e,
    teaserType: t = Be.DEFAULT,
    teaserTitle: i,
    teaserDescription: s,
    teaserImage: n,
    teaserImageAlt: r,
    teaserUrl: a,
    teaserDate: o,
    dateTimeValue: l,
    teaserTagLabel: c,
    ctaLabel: d,
    unpublished: u,
    slot: h,
    playLabel: g,
    pauseLabel: _,
    onVideoStateChange: b,
    onTeaserLinkClick: E,
    awsServiceBaseUrl: x
  }, f) => {
    const m = H(null), v = H(), { width: w } = zf(v), [y, S] = V(0), k = () => {
      switch (e) {
        case "story-teaser--variant-a":
          return { ratio: ie.NORMAL };
        case "story-teaser--variant-b":
          return { ratio: ie.SIXTOFIVE };
        case "story-teaser--variant-c":
          return { ratio: ie.ORIGINAL, forceHeight: 480 };
        default:
          return { ratio: ie.ORIGINAL };
      }
    }, O = ke(() => {
      const B = Number(n), R = k();
      return B ? /* @__PURE__ */ p(
        Hi,
        {
          awsServiceBaseUrl: x,
          service: "aws",
          videoId: n,
          previewAlt: r ?? "",
          playLabel: g ?? "",
          pauseLabel: _ ?? "",
          videoLoop: !0,
          onVideoStateChange: (A) => {
            b && b(A);
          }
        }
      ) : n ? /* @__PURE__ */ p(ti, { src: n, alt: r, ...R }) : null;
    }, [e, n]);
    F(() => {
      e === "story-teaser--variant-a" ? S(w ? w / 4 * 3 : 0) : m.current && S(m.current.clientHeight);
    }, [w, e, s]), F(() => {
      const B = (R) => {
        var A;
        R.key === "Escape" && ((A = v.current) == null || A.blur());
      };
      return window.addEventListener("keydown", B), () => {
        window.removeEventListener("keydown", B);
      };
    }, []);
    const M = /* @__PURE__ */ p("div", { className: Me["story-teaser__image-container"], children: O() }), C = /* @__PURE__ */ I("div", { className: Me["story-teaser__details"], children: [
      t !== Be.DEFAULT && /* @__PURE__ */ I("div", { className: Me["story-teaser__tag"], children: [
        Ii[t] && /* @__PURE__ */ p(q, { icon: Ii[t], height: `${Ue(20)}rem` }),
        /* @__PURE__ */ p("span", { children: c })
      ] }),
      /* @__PURE__ */ I("div", { className: Me["story-teaser__description-container"], children: [
        /* @__PURE__ */ p("h3", { className: Me["story-teaser__title"], children: i }),
        /* @__PURE__ */ p("p", { ref: m, className: Me["story-teaser__description"], children: s })
      ] }),
      o && l && e === "story-teaser--variant-a" && /* @__PURE__ */ p("div", { className: Me["story-teaser__date"], children: /* @__PURE__ */ p(pn, { displayDate: o, dateTimeValue: l }) }),
      e === "story-teaser--variant-c" && d && /* @__PURE__ */ p(Qt, { text: d, href: a, onClick: E })
    ] }), D = L(Me["story-teaser"], Me[e], {
      [Me["story-teaser--unpublished"]]: u
    }), P = /* @__PURE__ */ p(
      "a",
      {
        ref: Cs([v, f]),
        className: D,
        "aria-label": i,
        href: a,
        onClick: E,
        style: { "--teaser-hover-offset": `${y}px` },
        slot: h,
        children: /* @__PURE__ */ I("article", { children: [
          M,
          C
        ] })
      }
    ), $ = /* @__PURE__ */ I("article", { ref: Cs([v, f]), className: D, slot: h, children: [
      M,
      C
    ] });
    return e === "story-teaser--variant-c" ? $ : P;
  }
), Ff = "subline", Gf = "subline__avatar", qf = "subline__author", jf = "subline__date", Ge = {
  subline: Ff,
  "subline__attribution-phrase": "subline__attribution-phrase",
  "subline__author-container": "subline__author-container",
  subline__avatar: Gf,
  "subline__author-description-container": "subline__author-description-container",
  subline__author: qf,
  "subline__author-description": "subline__author-description",
  subline__date: jf
}, qp = ({
  author: e,
  authorDescription: t,
  attributionPhrase: i,
  displayDate: s,
  dateTimeValue: n,
  children: r
}) => /* @__PURE__ */ I("div", { className: Ge.subline, children: [
  i && /* @__PURE__ */ p("h3", { className: Ge["subline__attribution-phrase"], children: i }),
  /* @__PURE__ */ I("div", { className: Ge["subline__author-container"], children: [
    r && /* @__PURE__ */ p("div", { className: Ge.subline__avatar, children: r }),
    /* @__PURE__ */ I("div", { className: Ge["subline__author-description-container"], children: [
      /* @__PURE__ */ p("p", { className: Ge.subline__author, children: e }),
      /* @__PURE__ */ p("p", { className: Ge["subline__author-description"], children: t }),
      s && n && /* @__PURE__ */ p("div", { className: Ge.subline__date, children: /* @__PURE__ */ p(pn, { dateTimeValue: n, displayDate: s }) })
    ] })
  ] })
] }), Ns = 2;
function Wf(e) {
  const [t, i] = V("none"), s = ke(() => {
    const n = e.current;
    if (!n) {
      i("none");
      return;
    }
    const r = document.documentElement.dir === "rtl", a = n.scrollLeft, o = n.clientWidth, l = n.scrollWidth, c = r ? a - Ns > o - l : a > 0, d = l - o, u = r ? a < 0 : a + Ns < d;
    i(c && u ? "both" : c ? "left" : u ? "right" : "none");
  }, [e.current]);
  return F(() => {
    const n = e.current;
    if (n)
      return s(), n.addEventListener("scroll", s), window.addEventListener("resize", s), () => {
        n.removeEventListener("scroll", s), window.removeEventListener("resize", s);
      };
  }, [s]), t;
}
const Uf = "tabs", Yf = "tabs__tab", Xf = "tabs__panel", we = {
  tabs: Uf,
  tabs__tab: Yf,
  "tabs__tab--active": "tabs__tab--active",
  "tabs__tab-label": "tabs__tab-label",
  tabs__panel: Xf,
  "tabs__panel--active": "tabs__panel--active",
  "tabs__tab-list": "tabs__tab-list",
  "tabs__tab-list--blur-left": "tabs__tab-list--blur-left",
  "tabs__tab-list--blur-right": "tabs__tab-list--blur-right",
  "tabs__tab-list--blur-both": "tabs__tab-list--blur-both",
  "tabs__tab-list--filter": "tabs__tab-list--filter",
  "tabs__tab-list--filter-gray": "tabs__tab-list--filter-gray",
  "tabs--centered": "tabs--centered",
  "tabs__tab-list-wrapper": "tabs__tab-list-wrapper"
}, jp = ({
  initiallySelected: e = 0,
  appearance: t = "default",
  centered: i = !1,
  tabs: s,
  children: n,
  slot: r,
  onTabClick: a
}) => {
  const [o, l] = V(e), c = H([]), d = H(null), u = Wf(d), [h, g] = Rs(), { scrollToItem: _ } = Ps(c);
  F(() => {
    const v = h.substring(1), w = (s == null ? void 0 : s.findIndex((k) => k.id === v)) ?? null, y = e >= 0 && e < ((s == null ? void 0 : s.length) ?? 0) ? e : null, S = w !== null && w >= 0 ? w : y ?? 0;
    l(S), w !== null && c.current[w] && setTimeout(() => _(w), 0);
  }, []);
  const b = (v) => {
    var S;
    const y = v === e ? "" : ((S = s == null ? void 0 : s[v]) == null ? void 0 : S.id) || "";
    g(y);
  }, E = (v) => {
    var S, k;
    const w = (s == null ? void 0 : s.findIndex((O) => O.id === v.currentTarget.id)) ?? null;
    if (w === null || w < 0 || w === o)
      return;
    l(w), b(w), c.current[w] && ((S = c.current[w]) == null || S.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" }));
    const y = ((k = s == null ? void 0 : s[w ?? 0]) == null ? void 0 : k.headline) || "";
    a == null || a(v, y);
  }, x = (v) => {
    var O, M, C;
    if (!s || s.length === 0 || !v.key)
      return;
    const { key: w } = v, y = {
      ArrowRight: (D, P) => (D + 1) % P,
      ArrowLeft: (D, P) => (D - 1 + P) % P,
      Home: () => 0,
      End: (D, P) => P - 1
    };
    if (!y[w])
      return;
    v.preventDefault();
    const S = y[w](o, s.length);
    if (S === o)
      return;
    l(S), b(S), (O = c.current[S]) == null || O.focus(), (M = c.current[S]) == null || M.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
    const k = ((C = s == null ? void 0 : s[S]) == null ? void 0 : C.headline) || "";
    a == null || a(v, k);
  }, f = L(we.tabs, i && we["tabs--centered"]), m = L(
    we["tabs__tab-list"],
    (t === "filter" || t === "filter-gray") && we["tabs__tab-list--filter"],
    t === "filter-gray" && we["tabs__tab-list--filter-gray"],
    u !== "none" && we[`tabs__tab-list--blur-${u}`]
  );
  return /* @__PURE__ */ I("div", { className: f, slot: r, children: [
    /* @__PURE__ */ p("div", { className: we["tabs__tab-list-wrapper"], children: /* @__PURE__ */ p("div", { className: m, role: "tablist", ref: d, children: s == null ? void 0 : s.map((v, w) => /* @__PURE__ */ p(
      "button",
      {
        className: L(we.tabs__tab, o === w && we["tabs__tab--active"]),
        id: v.id,
        type: "button",
        role: "tab",
        "aria-selected": o === w,
        "aria-controls": `panel-${v.id}`,
        tabIndex: o === w ? 0 : -1,
        onClick: E,
        onKeyDown: x,
        ref: (y) => c.current[w] = y,
        children: /* @__PURE__ */ p("span", { className: we["tabs__tab-label"], children: v.headline })
      },
      v.headline
    )) }) }),
    n == null ? void 0 : n.map((v, w) => {
      var y, S;
      return /* @__PURE__ */ p(
        "div",
        {
          className: L(we.tabs__panel, o === w && we["tabs__panel--active"]),
          id: `panel-${(y = s == null ? void 0 : s[w]) == null ? void 0 : y.id}`,
          role: "tabpanel",
          "aria-labelledby": (S = s == null ? void 0 : s[w]) == null ? void 0 : S.id,
          hidden: o !== w,
          tabIndex: 0,
          children: v
        },
        w
      );
    })
  ] });
}, Zf = "tag", Kf = {
  tag: Zf
}, Wp = ({ tag: e, href: t, onClick: i, ariaLabel: s }) => /* @__PURE__ */ p("a", { href: t, className: Kf.tag, onClick: i, "aria-label": s, children: e }), Qf = "teaser", Jf = "image", ep = "teaser__heading", tp = "teaser__overline", ip = "teaser__title", sp = "teaser__icon", np = "teaser__description", rp = "teaser__border", ap = "teaser__image", op = "teaser__video", Z = {
  teaser: Qf,
  "teaser__image-wrapper": "teaser__image-wrapper",
  image: Jf,
  "teaser__link-wrapper": "teaser__link-wrapper",
  "teaser__image-border": "teaser__image-border",
  teaser__heading: ep,
  teaser__overline: tp,
  "teaser__overline-element": "teaser__overline-element",
  teaser__title: ip,
  "teaser__title--small": "teaser__title--small",
  teaser__icon: sp,
  teaser__description: np,
  "teaser__author-description": "teaser__author-description",
  teaser__border: rp,
  "teaser__buttons-wrapper": "teaser__buttons-wrapper",
  "teaser__buttons-wrapper--align-left": "teaser__buttons-wrapper--align-left",
  "teaser--card": "teaser--card",
  "teaser--unpublished": "teaser--unpublished",
  "teaser--in-draft": "teaser--in-draft",
  teaser__image: ap,
  "teaser__image--loaded": "teaser__image--loaded",
  "teaser__image--reduced-scale": "teaser__image--reduced-scale",
  teaser__video: op
};
var j = /* @__PURE__ */ ((e) => (e.VARIANT_A = "teaser-variant-a", e.VARIANT_B = "teaser-variant-b", e.VARIANT_C = "teaser-variant-c", e.VARIANT_D = "teaser-variant-d", e.VARIANT_E = "teaser-variant-e", e.VARIANT_E_WITHOUT_DESCRIPTION = "teaser-variant-e-without-description", e.VARIANT_A_WITHOUT_IMAGE = "teaser-variant-a-without-image", e.VARIANT_B_WITHOUT_IMAGE = "teaser-variant-b-without-image", e.VARIANT_C_WITHOUT_IMAGE = "teaser-variant-c-without-image", e.VARIANT_D_WITHOUT_IMAGE = "teaser-variant-d-without-image", e.VARIANT_C_WITHOUT_IMAGE_WITH_DATE = "teaser-variant-c-without-image-with-date", e.CARD_A = "teaser--card-a", e.CARD_B = "teaser--card-b", e.CARD_C = "teaser--card-c", e.PUBMED = "teaser--pubmed", e))(j || {}), $t = /* @__PURE__ */ ((e) => (e.DEFAULT = "arrow-right", e.DOWNLOAD = "download", e.EXTERNAL = "external-link", e))($t || {});
const lp = [
  j.VARIANT_A,
  j.VARIANT_A_WITHOUT_IMAGE,
  j.CARD_A,
  j.VARIANT_B,
  j.VARIANT_B_WITHOUT_IMAGE,
  j.CARD_B,
  j.VARIANT_E,
  j.PUBMED
], cp = [
  j.VARIANT_A,
  j.VARIANT_A_WITHOUT_IMAGE,
  j.CARD_A,
  j.VARIANT_C,
  j.VARIANT_C_WITHOUT_IMAGE,
  j.VARIANT_C_WITHOUT_IMAGE_WITH_DATE,
  j.CARD_C,
  j.PUBMED
], dp = [
  j.VARIANT_A,
  j.VARIANT_B,
  j.VARIANT_C,
  j.VARIANT_D,
  j.VARIANT_E,
  j.VARIANT_E_WITHOUT_DESCRIPTION
], up = [j.CARD_A, j.CARD_B, j.CARD_C], Up = Is(
  ({
    teaserImage: e,
    teaserImageAlt: t,
    teaserTitle: i,
    teaserDescription: s,
    teaserOverline: n,
    teaserOverlineElement: r,
    teaserUrl: a,
    target: o = Zt.SELF,
    isExternalLink: l,
    isDownloadLink: c,
    downloadTranslation: d,
    layout: u,
    secondaryButton: h,
    primaryButtonText: g,
    playLabel: _,
    pauseLabel: b,
    onTeaserClick: E,
    onVideoStateChange: x,
    isSearchResult: f,
    unpublished: m,
    isTeaserInDraft: v,
    teaserAuthorDescription: w,
    slot: y,
    loaded: S,
    forceAlignLeft: k,
    awsServiceBaseUrl: O
  }, M) => {
    const C = n && n !== "" || r, D = !Number(e), P = l ? $t.EXTERNAL : c ? $t.DOWNLOAD : $t.DEFAULT, $ = ke(() => {
      const K = u === j.VARIANT_E || u === j.VARIANT_E_WITHOUT_DESCRIPTION, Oe = K ? ie.VERTICAL : ie.HD, re = cp.includes(u), Re = lp.includes(u), it = dp.includes(u), Pe = up.includes(u);
      return {
        isVerticalLayout: K,
        imageRatio: Oe,
        hasOverline: re,
        hasDescription: Re,
        hasImage: it,
        isCard: Pe
      };
    }, [u]), { hasImage: B, isVerticalLayout: R, imageRatio: A, hasDescription: N, hasOverline: z, isCard: G } = $(), J = i && /* @__PURE__ */ I(
      "span",
      {
        className: L(Z.teaser__title, (f || c) && Z["teaser__title--small"]),
        children: [
          i,
          !G && /* @__PURE__ */ p("span", { className: Z.teaser__icon, children: /* @__PURE__ */ p(q, { icon: P, height: `${Ue(24)}rem` }) })
        ]
      }
    );
    F(() => {
      const K = new CustomEvent("rocheTeaserInit");
      window.dispatchEvent(K);
    }, []);
    const X = /* @__PURE__ */ I(Ht, { children: [
      B && e && /* @__PURE__ */ I("div", { className: Z["teaser__image-wrapper"], children: [
        D ? /* @__PURE__ */ p(ti, { src: e, alt: t ?? "", ratio: A, slot: y }) : /* @__PURE__ */ p(
          "div",
          {
            className: L(
              Z.teaser__video,
              R && Z["teaser__image--reduced-scale"],
              S && Z["teaser__image--loaded"]
            ),
            children: /* @__PURE__ */ p(
              Hi,
              {
                awsServiceBaseUrl: O,
                service: "aws",
                videoLoop: !0,
                videoId: e,
                previewAlt: t ?? "",
                playLabel: _ ?? "",
                pauseLabel: b ?? "",
                onVideoStateChange: (K) => {
                  x && x(K);
                }
              }
            )
          }
        ),
        /* @__PURE__ */ p("div", { className: Z["teaser__image-border"] })
      ] }),
      /* @__PURE__ */ I("h3", { className: Z.teaser__heading, children: [
        J,
        z && C && /* @__PURE__ */ I("span", { className: Z.teaser__overline, children: [
          n,
          r && /* @__PURE__ */ p("span", { className: Z["teaser__overline-element"], children: r })
        ] })
      ] }),
      w && /* @__PURE__ */ p("p", { className: "teaser__author-description", children: w }),
      N && s && /* @__PURE__ */ p("p", { className: Z.teaser__description, children: s }),
      !B && !G && /* @__PURE__ */ p("div", { className: Z.teaser__border }),
      G && /* @__PURE__ */ I(
        "div",
        {
          className: L(
            Z["teaser__buttons-wrapper"],
            k && Z["teaser__buttons-wrapper--align-left"]
          ),
          children: [
            a && g && /* @__PURE__ */ p(
              Qt,
              {
                href: a,
                appearance: Te.SECONDARY,
                text: g,
                onClick: E
              }
            ),
            h
          ]
        }
      )
    ] });
    return /* @__PURE__ */ p(
      "div",
      {
        ref: M,
        slot: y,
        className: L(
          Z.teaser,
          G && Z["teaser--card"],
          m && Z["teaser--unpublished"],
          v && Z["teaser--in-draft"]
        ),
        children: G ? X : /* @__PURE__ */ p(
          "a",
          {
            target: o,
            href: a,
            "aria-label": c ? `${d} ${i}` : i,
            onClick: E,
            className: Z["teaser__link-wrapper"],
            children: X
          }
        )
      }
    );
  }
);
export {
  te as Breakpoints,
  Ei as ContainerColor,
  Zt as LinkTarget,
  mp as RocheUIAccordion,
  gp as RocheUIAddToCalendar,
  vp as RocheUIAnimatedWords,
  _p as RocheUIAvatar,
  wp as RocheUIBackToBranch,
  ga as RocheUIBreadcrumbs,
  Qt as RocheUIButton,
  Te as RocheUIButtonAppearance,
  Kt as RocheUIButtonTarget,
  Ls as RocheUIButtonType,
  bp as RocheUIContactPerson,
  Lt as RocheUIContactPersonLayout,
  _a as RocheUIContainer,
  yp as RocheUIDropdown,
  Ep as RocheUIFooter,
  mt as RocheUIGrid,
  xp as RocheUIHeader,
  zs as RocheUIHeadline,
  Sp as RocheUIHeroTeaser,
  Xt as RocheUIHeroVariant,
  Tp as RocheUIHighlightBox,
  Ap as RocheUIHorizontalCenter,
  q as RocheUIIcon,
  ti as RocheUIImage,
  Ml as RocheUIImageLoading,
  ie as RocheUIImageRatio,
  Zs as RocheUILanguageSwitch,
  ei as RocheUILanguageSwitchLayoutType,
  Mp as RocheUILeadText,
  kp as RocheUILoadingSpinner,
  Cp as RocheUIMagnet,
  Np as RocheUIMarketo,
  fl as RocheUIMobileNavigation,
  ca as RocheUIOverline,
  Ip as RocheUIPodcast,
  Op as RocheUIPublishedDate,
  Rp as RocheUIQuote,
  Ai as RocheUIQuoteLayout,
  Ti as RocheUIQuoteSize,
  Pp as RocheUIRichText,
  Lp as RocheUISideBySide,
  zt as RocheUISideBySideHorizontalAlignment,
  Vt as RocheUISideBySideVerticalAlignment,
  Ye as RocheUISlideAnimation,
  Dp as RocheUISlider,
  zp as RocheUISocialMedia,
  _t as RocheUISocialMediaAlignment,
  Bp as RocheUIStageHome,
  Vp as RocheUIStageHomeTeaser,
  $p as RocheUIStagingHero,
  Hp as RocheUIStockPrice,
  Fp as RocheUIStoryStagingHero,
  Gp as RocheUIStoryTeaser,
  Df as RocheUIStoryTeaserLayout,
  Be as RocheUIStoryType,
  qp as RocheUISubline,
  jp as RocheUITabs,
  Wp as RocheUITag,
  Up as RocheUITeaser,
  j as RocheUITeaserLayout,
  Gt as RocheUITextLink,
  da as RocheUITextLinkIconSize,
  ot as RocheUITextLinkType,
  Hi as RocheUIVideoPlayer
};
